// This file is auto-generated by @hey-api/openapi-ts

import {
    type Client,
    type ClientMeta,
    formDataBodySerializer,
    type Options as Options2,
    type RequestResult,
    type ServerSentEventsResult,
    type TDataShape,
    urlSearchParamsBodySerializer,
} from "./client";
import { client } from "./client.gen";
import type {
    AskEventsAskEventsGetData,
    AskEventsAskEventsGetResponses,
    AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetData,
    AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors,
    AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses,
    CancelSubscriptionSubscriptionFeatureKeyCancelPostData,
    CancelSubscriptionSubscriptionFeatureKeyCancelPostErrors,
    CancelSubscriptionSubscriptionFeatureKeyCancelPostResponses,
    ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchData,
    ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchErrors,
    ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponses,
    ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetData,
    ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetErrors,
    ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetResponses,
    CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostData,
    CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors,
    CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses,
    CreateApiKeyUserApiKeyPostData,
    CreateApiKeyUserApiKeyPostErrors,
    CreateApiKeyUserApiKeyPostResponses,
    CreateCheckoutSessionStripeCheckoutSessionPostData,
    CreateCheckoutSessionStripeCheckoutSessionPostErrors,
    CreateCheckoutSessionStripeCheckoutSessionPostResponses,
    CreateEntryWhatsNewWhatsNewMgtEntriesPostData,
    CreateEntryWhatsNewWhatsNewMgtEntriesPostErrors,
    CreateEntryWhatsNewWhatsNewMgtEntriesPostResponses,
    CreatePortalSessionStripePortalSessionPostData,
    CreatePortalSessionStripePortalSessionPostErrors,
    CreatePortalSessionStripePortalSessionPostResponses,
    CreateUserUserPostData,
    CreateUserUserPostErrors,
    CreateUserUserPostResponses,
    CurrentAskAskMgtAnswerQuestionCurrentGetData,
    CurrentAskAskMgtAnswerQuestionCurrentGetResponses,
    DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteData,
    DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteErrors,
    DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponses,
    DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteData,
    DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors,
    DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses,
    DeleteMemoryEntryMeMemoryEntryIdDeleteData,
    DeleteMemoryEntryMeMemoryEntryIdDeleteErrors,
    DeleteMemoryEntryMeMemoryEntryIdDeleteResponses,
    DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteData,
    DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteErrors,
    DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteResponses,
    DeleteUserUserUserIdDeleteData,
    DeleteUserUserUserIdDeleteErrors,
    DeleteUserUserUserIdDeleteResponses,
    DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteData,
    DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteErrors,
    DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteResponses,
    EnterPreviewIntegrationsDevPreviewEnterHostGetData,
    EnterPreviewIntegrationsDevPreviewEnterHostGetErrors,
    EnterPreviewIntegrationsDevPreviewEnterHostGetResponses,
    ExchangeTokenIntegrationsOauth2ClientTokenPostData,
    ExchangeTokenIntegrationsOauth2ClientTokenPostErrors,
    ExchangeTokenIntegrationsOauth2ClientTokenPostResponses,
    ExportContextMePersonalContextExportGetData,
    ExportContextMePersonalContextExportGetResponses,
    GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostData,
    GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors,
    GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses,
    GetAllPlatformUsersUserAllGetData,
    GetAllPlatformUsersUserAllGetErrors,
    GetAllPlatformUsersUserAllGetResponses,
    GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetData,
    GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetErrors,
    GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponses,
    GetDomainRolesUserUserIdDomainRolesGetData,
    GetDomainRolesUserUserIdDomainRolesGetErrors,
    GetDomainRolesUserUserIdDomainRolesGetResponses,
    GetEntitlementsSubscriptionEntitlementsGetData,
    GetEntitlementsSubscriptionEntitlementsGetResponses,
    GetEntriesWhatsNewWhatsNewMgtEntriesGetData,
    GetEntriesWhatsNewWhatsNewMgtEntriesGetErrors,
    GetEntriesWhatsNewWhatsNewMgtEntriesGetResponses,
    GetEnvironmentFeaturesAdminFeaturesEnvironmentGetData,
    GetEnvironmentFeaturesAdminFeaturesEnvironmentGetResponses,
    GetFirebaseUserByEmailUserFirebaseEmailGetData,
    GetFirebaseUserByEmailUserFirebaseEmailGetErrors,
    GetFirebaseUserByEmailUserFirebaseEmailGetResponses,
    GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetData,
    GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors,
    GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses,
    GetOauthMetadataWellKnownOauthAuthorizationServerGetData,
    GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses,
    GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetData,
    GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses,
    GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetData,
    GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetErrors,
    GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetResponses,
    GetPersonalMemorySettingsMePersonalMemorySettingsGetData,
    GetPersonalMemorySettingsMePersonalMemorySettingsGetResponses,
    GetPolicyAcceptancesUserPolicyAcceptancesGetData,
    GetPolicyAcceptancesUserPolicyAcceptancesGetErrors,
    GetPolicyAcceptancesUserPolicyAcceptancesGetResponses,
    GetPolicyStatusUserPolicyStatusGetData,
    GetPolicyStatusUserPolicyStatusGetResponses,
    GetSelfUserMeGetData,
    GetSelfUserMeGetResponses,
    GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetData,
    GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponses,
    GetUsersUserGetData,
    GetUsersUserGetResponses,
    HealthcheckHealthcheckGetData,
    HealthcheckHealthcheckGetResponses,
    ListApiKeysUserApiKeysGetData,
    ListApiKeysUserApiKeysGetResponses,
    ListFeatureFlagsAdminFeatureFlagsGetData,
    ListFeatureFlagsAdminFeatureFlagsGetResponses,
    ListFeaturesSubscriptionFeaturesGetData,
    ListFeaturesSubscriptionFeaturesGetResponses,
    ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetData,
    ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetErrors,
    ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetResponses,
    ListMemoryMeMemoryGetData,
    ListMemoryMeMemoryGetResponses,
    ListOrgFeaturesAdminFeaturesOrganizationsGetData,
    ListOrgFeaturesAdminFeaturesOrganizationsGetResponses,
    ListOrgSubscriptionsAdminOrganizationsGetData,
    ListOrgSubscriptionsAdminOrganizationsGetResponses,
    ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetData,
    ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetErrors,
    ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponses,
    ListSubscriptionsAdminSubscriptionsGetData,
    ListSubscriptionsAdminSubscriptionsGetErrors,
    ListSubscriptionsAdminSubscriptionsGetResponses,
    MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostData,
    MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostErrors,
    MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponses,
    McpStreamableHttpDeleteData,
    McpStreamableHttpDeleteResponses,
    McpStreamableHttpGetData,
    McpStreamableHttpGetResponses,
    McpStreamableHttpPostData,
    McpStreamableHttpPostResponses,
    McpWhoamiData,
    McpWhoamiResponses,
    NotifyTypingThreadTypingThreadIdPostData,
    NotifyTypingThreadTypingThreadIdPostErrors,
    NotifyTypingThreadTypingThreadIdPostResponses,
    PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetData,
    PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors,
    PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses,
    PreviewJwksIntegrationsDevPreviewJwksJsonGetData,
    PreviewJwksIntegrationsDevPreviewJwksJsonGetResponses,
    PreviewLinkProxyPreviewLinkGetData,
    PreviewLinkProxyPreviewLinkGetErrors,
    PreviewLinkProxyPreviewLinkGetResponses,
    RecordAttentionEventsMeAttentionEventsPostData,
    RecordAttentionEventsMeAttentionEventsPostErrors,
    RecordAttentionEventsMeAttentionEventsPostResponses,
    RecordPolicyAcceptanceUserPolicyAcceptancePostData,
    RecordPolicyAcceptanceUserPolicyAcceptancePostErrors,
    RecordPolicyAcceptanceUserPolicyAcceptancePostResponses,
    RegisterClientIntegrationsOauth2ServerRegisterPostData,
    RegisterClientIntegrationsOauth2ServerRegisterPostErrors,
    RegisterClientIntegrationsOauth2ServerRegisterPostResponses,
    RegisterSessionIntegrationsDevPreviewSessionsPostData,
    RegisterSessionIntegrationsDevPreviewSessionsPostErrors,
    RegisterSessionIntegrationsDevPreviewSessionsPostResponses,
    ResendInvitationEndpointUserUserIdResendInvitationPostData,
    ResendInvitationEndpointUserUserIdResendInvitationPostErrors,
    ResendInvitationEndpointUserUserIdResendInvitationPostResponses,
    RevokeApiKeyUserApiKeyApiKeyIdDeleteData,
    RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors,
    RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses,
    RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostData,
    RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostErrors,
    RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponses,
    RevokeTokenIntegrationsOauth2ServerRevokePostData,
    RevokeTokenIntegrationsOauth2ServerRevokePostErrors,
    RevokeTokenIntegrationsOauth2ServerRevokePostResponses,
    SearchSearchGetData,
    SearchSearchGetErrors,
    SearchSearchGetResponses,
    SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostData,
    SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostErrors,
    SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponses,
    SessionStatusIntegrationsDevPreviewSessionsHostGetData,
    SessionStatusIntegrationsDevPreviewSessionsHostGetErrors,
    SessionStatusIntegrationsDevPreviewSessionsHostGetResponses,
    SetAttentionProbeEnabledMeAttentionProbeEnabledPutData,
    SetAttentionProbeEnabledMeAttentionProbeEnabledPutErrors,
    SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponses,
    SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutData,
    SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutErrors,
    SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutResponses,
    SetPersonalMemoryEnabledMePersonalMemoryEnabledPutData,
    SetPersonalMemoryEnabledMePersonalMemoryEnabledPutErrors,
    SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponses,
    SignupUserSignupPostData,
    SignupUserSignupPostErrors,
    SignupUserSignupPostResponses,
    SignupWithInvitationUserSignupWithInvitationPostData,
    SignupWithInvitationUserSignupWithInvitationPostErrors,
    SignupWithInvitationUserSignupWithInvitationPostResponses,
    StartAiEvaluationGetTaskEvaluationsStartPostData,
    StartAiEvaluationGetTaskEvaluationsStartPostErrors,
    StartAiEvaluationGetTaskEvaluationsStartPostResponses,
    StartAiTaskMgtGetTaskProvidersStartPostData,
    StartAiTaskMgtGetTaskProvidersStartPostErrors,
    StartAiTaskMgtGetTaskProvidersStartPostResponses,
    StartAiTaskMgtRunTaskStartPostData,
    StartAiTaskMgtRunTaskStartPostErrors,
    StartAiTaskMgtRunTaskStartPostResponses,
    StartAskAskMgtAnswerQuestionStartPostData,
    StartAskAskMgtAnswerQuestionStartPostErrors,
    StartAskAskMgtAnswerQuestionStartPostResponses,
    StartAskAskMgtAskAboutSuggestionStartPostData,
    StartAskAskMgtAskAboutSuggestionStartPostErrors,
    StartAskAskMgtAskAboutSuggestionStartPostResponses,
    StartAskAskMgtNoticedAboutStartPostData,
    StartAskAskMgtNoticedAboutStartPostErrors,
    StartAskAskMgtNoticedAboutStartPostResponses,
    StartBizArtefactManagementAddArtefactGroupStartPostData,
    StartBizArtefactManagementAddArtefactGroupStartPostErrors,
    StartBizArtefactManagementAddArtefactGroupStartPostResponses,
    StartBizArtefactManagementAddArtefactStartPostData,
    StartBizArtefactManagementAddArtefactStartPostErrors,
    StartBizArtefactManagementAddArtefactStartPostResponses,
    StartBizArtefactManagementGetArtefactStartPostData,
    StartBizArtefactManagementGetArtefactStartPostErrors,
    StartBizArtefactManagementGetArtefactStartPostResponses,
    StartBizArtefactManagementGetArtefactsTreeStartPostData,
    StartBizArtefactManagementGetArtefactsTreeStartPostErrors,
    StartBizArtefactManagementGetArtefactsTreeStartPostResponses,
    StartBizArtefactManagementGetHistoryStartPostData,
    StartBizArtefactManagementGetHistoryStartPostErrors,
    StartBizArtefactManagementGetHistoryStartPostResponses,
    StartBizArtefactManagementRemoveArtefactGroupStartPostData,
    StartBizArtefactManagementRemoveArtefactGroupStartPostErrors,
    StartBizArtefactManagementRemoveArtefactGroupStartPostResponses,
    StartBizArtefactManagementRemoveArtefactStartPostData,
    StartBizArtefactManagementRemoveArtefactStartPostErrors,
    StartBizArtefactManagementRemoveArtefactStartPostResponses,
    StartBizArtefactManagementRenameArtefactGroupStartPostData,
    StartBizArtefactManagementRenameArtefactGroupStartPostErrors,
    StartBizArtefactManagementRenameArtefactGroupStartPostResponses,
    StartBizArtefactManagementRenameArtefactStartPostData,
    StartBizArtefactManagementRenameArtefactStartPostErrors,
    StartBizArtefactManagementRenameArtefactStartPostResponses,
    StartBizArtefactManagementRestoreHistoricalArtefactStartPostData,
    StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors,
    StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses,
    StartBizArtefactManagementUpdateArtefactContentStartPostData,
    StartBizArtefactManagementUpdateArtefactContentStartPostErrors,
    StartBizArtefactManagementUpdateArtefactContentStartPostResponses,
    StartBizArtefactManagementUpdateArtefactStartPostData,
    StartBizArtefactManagementUpdateArtefactStartPostErrors,
    StartBizArtefactManagementUpdateArtefactStartPostResponses,
    StartBizEntitiesEntityTypeEntityIdAttributeGetData,
    StartBizEntitiesEntityTypeEntityIdAttributeGetErrors,
    StartBizEntitiesEntityTypeEntityIdAttributeGetResponses,
    StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData,
    StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors,
    StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses,
    StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData,
    StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors,
    StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses,
    StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData,
    StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors,
    StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse,
    StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses,
    StartBizEntitiesEntityTypeEntityIdHistoryGetData,
    StartBizEntitiesEntityTypeEntityIdHistoryGetErrors,
    StartBizEntitiesEntityTypeEntityIdHistoryGetResponses,
    StartBizEntitiesEntityTypeEntityIdInfoGetData,
    StartBizEntitiesEntityTypeEntityIdInfoGetErrors,
    StartBizEntitiesEntityTypeEntityIdInfoGetResponses,
    StartBizEntitiesEntityTypeEntityIdSnapshotGetData,
    StartBizEntitiesEntityTypeEntityIdSnapshotGetErrors,
    StartBizEntitiesEntityTypeEntityIdSnapshotGetResponses,
    StartComplianceComplianceMgtGetComplianceStartPostData,
    StartComplianceComplianceMgtGetComplianceStartPostErrors,
    StartComplianceComplianceMgtGetComplianceStartPostResponses,
    StartComplianceComplianceMgtGetTopicDetailStartPostData,
    StartComplianceComplianceMgtGetTopicDetailStartPostErrors,
    StartComplianceComplianceMgtGetTopicDetailStartPostResponses,
    StartComplianceComplianceMgtRefreshComplianceStartPostData,
    StartComplianceComplianceMgtRefreshComplianceStartPostResponses,
    StartComplianceGapMgtAnswerGapStartPostData,
    StartComplianceGapMgtAnswerGapStartPostErrors,
    StartComplianceGapMgtAnswerGapStartPostResponses,
    StartComplianceGapMgtGetPersonalGapsStartPostData,
    StartComplianceGapMgtGetPersonalGapsStartPostResponses,
    StartComplianceGapMgtRecordGapFollowUpStartPostData,
    StartComplianceGapMgtRecordGapFollowUpStartPostErrors,
    StartComplianceGapMgtRecordGapFollowUpStartPostResponses,
    StartComplianceRequirementMgtDeleteRequirementStartPostData,
    StartComplianceRequirementMgtDeleteRequirementStartPostErrors,
    StartComplianceRequirementMgtDeleteRequirementStartPostResponses,
    StartComplianceRequirementMgtExtractRequirementsStartPostData,
    StartComplianceRequirementMgtExtractRequirementsStartPostErrors,
    StartComplianceRequirementMgtExtractRequirementsStartPostResponses,
    StartComplianceRequirementMgtSetRequirementExceptionStartPostData,
    StartComplianceRequirementMgtSetRequirementExceptionStartPostErrors,
    StartComplianceRequirementMgtSetRequirementExceptionStartPostResponses,
    StartComplianceRequirementMgtSetRequirementStartPostData,
    StartComplianceRequirementMgtSetRequirementStartPostErrors,
    StartComplianceRequirementMgtSetRequirementStartPostResponses,
    StartComplianceTopicMgtReviewCustomTopicStartPostData,
    StartComplianceTopicMgtReviewCustomTopicStartPostErrors,
    StartComplianceTopicMgtReviewCustomTopicStartPostResponses,
    StartComplianceTopicMgtSetCustomTopicStartPostData,
    StartComplianceTopicMgtSetCustomTopicStartPostErrors,
    StartComplianceTopicMgtSetCustomTopicStartPostResponses,
    StartDevApplicationEntityMgtCreateApplicationEntityStartPostData,
    StartDevApplicationEntityMgtCreateApplicationEntityStartPostErrors,
    StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponses,
    StartDevApplicationEntityMgtDeleteApplicationEntityStartPostData,
    StartDevApplicationEntityMgtDeleteApplicationEntityStartPostErrors,
    StartDevApplicationEntityMgtDeleteApplicationEntityStartPostResponses,
    StartDevApplicationEntityMgtGetApplicationEntitiesStartPostData,
    StartDevApplicationEntityMgtGetApplicationEntitiesStartPostErrors,
    StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponses,
    StartDevApplicationEntityMgtLinkBusinessEntityStartPostData,
    StartDevApplicationEntityMgtLinkBusinessEntityStartPostErrors,
    StartDevApplicationEntityMgtLinkBusinessEntityStartPostResponses,
    StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostData,
    StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostErrors,
    StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostResponses,
    StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostData,
    StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostErrors,
    StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostResponses,
    StartDevApplicationEntityMgtUpdateApplicationEntityStartPostData,
    StartDevApplicationEntityMgtUpdateApplicationEntityStartPostErrors,
    StartDevApplicationEntityMgtUpdateApplicationEntityStartPostResponses,
    StartDevApplicationMgtAddApplicationDependencyStartPostData,
    StartDevApplicationMgtAddApplicationDependencyStartPostErrors,
    StartDevApplicationMgtAddApplicationDependencyStartPostResponses,
    StartDevApplicationMgtCreateApplicationStartPostData,
    StartDevApplicationMgtCreateApplicationStartPostErrors,
    StartDevApplicationMgtCreateApplicationStartPostResponses,
    StartDevApplicationMgtDeleteApplicationStartPostData,
    StartDevApplicationMgtDeleteApplicationStartPostErrors,
    StartDevApplicationMgtDeleteApplicationStartPostResponses,
    StartDevApplicationMgtGetApplicationDependenciesStartPostData,
    StartDevApplicationMgtGetApplicationDependenciesStartPostErrors,
    StartDevApplicationMgtGetApplicationDependenciesStartPostResponses,
    StartDevApplicationMgtGetApplicationsByDomainStartPostData,
    StartDevApplicationMgtGetApplicationsByDomainStartPostErrors,
    StartDevApplicationMgtGetApplicationsByDomainStartPostResponses,
    StartDevApplicationMgtGetApplicationsByProcessStartPostData,
    StartDevApplicationMgtGetApplicationsByProcessStartPostErrors,
    StartDevApplicationMgtGetApplicationsByProcessStartPostResponses,
    StartDevApplicationMgtGetApplicationsByProductStartPostData,
    StartDevApplicationMgtGetApplicationsByProductStartPostErrors,
    StartDevApplicationMgtGetApplicationsByProductStartPostResponses,
    StartDevApplicationMgtGetApplicationsByStekStartPostData,
    StartDevApplicationMgtGetApplicationsByStekStartPostResponses,
    StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostData,
    StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponses,
    StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostData,
    StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostErrors,
    StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponses,
    StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostData,
    StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostErrors,
    StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponses,
    StartDevApplicationMgtGetApplicationsGroupedByProductStartPostData,
    StartDevApplicationMgtGetApplicationsGroupedByProductStartPostErrors,
    StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponses,
    StartDevApplicationMgtGetApplicationStartPostData,
    StartDevApplicationMgtGetApplicationStartPostErrors,
    StartDevApplicationMgtGetApplicationStartPostResponses,
    StartDevApplicationMgtGetDerivedDependenciesByStekStartPostData,
    StartDevApplicationMgtGetDerivedDependenciesByStekStartPostResponses,
    StartDevApplicationMgtGetExternalCommunicationMapStartPostData,
    StartDevApplicationMgtGetExternalCommunicationMapStartPostResponses,
    StartDevApplicationMgtGetPoolTriageDecisionsStartPostData,
    StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponses,
    StartDevApplicationMgtGetPoolTriageSuggestionsStartPostData,
    StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponses,
    StartDevApplicationMgtGetStekRolesStartPostData,
    StartDevApplicationMgtGetStekRolesStartPostResponses,
    StartDevApplicationMgtLinkProcessTaskToApplicationStartPostData,
    StartDevApplicationMgtLinkProcessTaskToApplicationStartPostErrors,
    StartDevApplicationMgtLinkProcessTaskToApplicationStartPostResponses,
    StartDevApplicationMgtPromotePoolToRoleStartPostData,
    StartDevApplicationMgtPromotePoolToRoleStartPostErrors,
    StartDevApplicationMgtPromotePoolToRoleStartPostResponses,
    StartDevApplicationMgtProposePoolResolutionStartPostData,
    StartDevApplicationMgtProposePoolResolutionStartPostErrors,
    StartDevApplicationMgtProposePoolResolutionStartPostResponses,
    StartDevApplicationMgtRemoveApplicationDependencyStartPostData,
    StartDevApplicationMgtRemoveApplicationDependencyStartPostErrors,
    StartDevApplicationMgtRemoveApplicationDependencyStartPostResponses,
    StartDevApplicationMgtResolvePoolAsApplicationStartPostData,
    StartDevApplicationMgtResolvePoolAsApplicationStartPostErrors,
    StartDevApplicationMgtResolvePoolAsApplicationStartPostResponses,
    StartDevApplicationMgtResolvePoolAsPartyStartPostData,
    StartDevApplicationMgtResolvePoolAsPartyStartPostErrors,
    StartDevApplicationMgtResolvePoolAsPartyStartPostResponses,
    StartDevApplicationMgtResolvePoolAsReferenceStartPostData,
    StartDevApplicationMgtResolvePoolAsReferenceStartPostErrors,
    StartDevApplicationMgtResolvePoolAsReferenceStartPostResponses,
    StartDevApplicationMgtSetPoolAppScopeStartPostData,
    StartDevApplicationMgtSetPoolAppScopeStartPostErrors,
    StartDevApplicationMgtSetPoolAppScopeStartPostResponses,
    StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostData,
    StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostErrors,
    StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostResponses,
    StartDevApplicationMgtUnresolvePoolStartPostData,
    StartDevApplicationMgtUnresolvePoolStartPostErrors,
    StartDevApplicationMgtUnresolvePoolStartPostResponses,
    StartDevApplicationMgtUpdateApplicationDependencyStartPostData,
    StartDevApplicationMgtUpdateApplicationDependencyStartPostErrors,
    StartDevApplicationMgtUpdateApplicationDependencyStartPostResponses,
    StartDevApplicationMgtUpdateApplicationStartPostData,
    StartDevApplicationMgtUpdateApplicationStartPostErrors,
    StartDevApplicationMgtUpdateApplicationStartPostResponses,
    StartDevBuildMgtCreateBuildTicketStartPostData,
    StartDevBuildMgtCreateBuildTicketStartPostErrors,
    StartDevBuildMgtCreateBuildTicketStartPostResponses,
    StartDevBuildMgtDeleteBuildTicketStartPostData,
    StartDevBuildMgtDeleteBuildTicketStartPostErrors,
    StartDevBuildMgtDeleteBuildTicketStartPostResponses,
    StartDevBuildMgtGetChangeDetailStartPostData,
    StartDevBuildMgtGetChangeDetailStartPostErrors,
    StartDevBuildMgtGetChangeDetailStartPostResponses,
    StartDevBuildMgtGetDriftStartPostData,
    StartDevBuildMgtGetDriftStartPostResponses,
    StartDevBuildMgtMarkAllBuiltStartPostData,
    StartDevBuildMgtMarkAllBuiltStartPostResponses,
    StartDevBuildMgtSetBuildTicketBuiltStartPostData,
    StartDevBuildMgtSetBuildTicketBuiltStartPostErrors,
    StartDevBuildMgtSetBuildTicketBuiltStartPostResponses,
    StartDevBuildMgtUpdateBuildTicketStartPostData,
    StartDevBuildMgtUpdateBuildTicketStartPostErrors,
    StartDevBuildMgtUpdateBuildTicketStartPostResponses,
    StartDevExternalPartyMgtCreateExternalPartyStartPostData,
    StartDevExternalPartyMgtCreateExternalPartyStartPostErrors,
    StartDevExternalPartyMgtCreateExternalPartyStartPostResponses,
    StartDevExternalPartyMgtDeleteExternalPartyStartPostData,
    StartDevExternalPartyMgtDeleteExternalPartyStartPostErrors,
    StartDevExternalPartyMgtDeleteExternalPartyStartPostResponses,
    StartDevExternalPartyMgtGetExternalPartiesStartPostData,
    StartDevExternalPartyMgtGetExternalPartiesStartPostResponses,
    StartDevExternalPartyMgtUpdateExternalPartyStartPostData,
    StartDevExternalPartyMgtUpdateExternalPartyStartPostErrors,
    StartDevExternalPartyMgtUpdateExternalPartyStartPostResponses,
    StartDevTriageMgtAddExternalPoolStartPostData,
    StartDevTriageMgtAddExternalPoolStartPostErrors,
    StartDevTriageMgtAddExternalPoolStartPostResponses,
    StartDevTriageMgtConvertLaneToPoolStartPostData,
    StartDevTriageMgtConvertLaneToPoolStartPostErrors,
    StartDevTriageMgtConvertLaneToPoolStartPostResponses,
    StartDevTriageMgtConvertPoolToLaneStartPostData,
    StartDevTriageMgtConvertPoolToLaneStartPostErrors,
    StartDevTriageMgtConvertPoolToLaneStartPostResponses,
    StartDevTriageMgtDismissTriageIssueStartPostData,
    StartDevTriageMgtDismissTriageIssueStartPostErrors,
    StartDevTriageMgtDismissTriageIssueStartPostResponses,
    StartDevTriageMgtGetProcessTriageIssuesStartPostData,
    StartDevTriageMgtGetProcessTriageIssuesStartPostErrors,
    StartDevTriageMgtGetProcessTriageIssuesStartPostResponses,
    StartDevTriageMgtGetTriageIssuesStartPostData,
    StartDevTriageMgtGetTriageIssuesStartPostResponses,
    StartDevTriageMgtLinkLanesToApplicationStartPostData,
    StartDevTriageMgtLinkLanesToApplicationStartPostErrors,
    StartDevTriageMgtLinkLanesToApplicationStartPostResponses,
    StartDevTriageMgtProposeRestructureStartPostData,
    StartDevTriageMgtProposeRestructureStartPostErrors,
    StartDevTriageMgtProposeRestructureStartPostResponses,
    StartDevTriageMgtReopenTriageIssueStartPostData,
    StartDevTriageMgtReopenTriageIssueStartPostErrors,
    StartDevTriageMgtReopenTriageIssueStartPostResponses,
    StartDevTriageMgtResolveNamedRecipientStartPostData,
    StartDevTriageMgtResolveNamedRecipientStartPostErrors,
    StartDevTriageMgtResolveNamedRecipientStartPostResponses,
    StartDevTriageMgtUnifyLanesStartPostData,
    StartDevTriageMgtUnifyLanesStartPostErrors,
    StartDevTriageMgtUnifyLanesStartPostResponses,
    StartDomainBusinessEntityMgtConvertToDomainTermStartPostData,
    StartDomainBusinessEntityMgtConvertToDomainTermStartPostErrors,
    StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponses,
    StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData,
    StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors,
    StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtCreateBusinessRuleStartPostData,
    StartDomainBusinessEntityMgtCreateBusinessRuleStartPostErrors,
    StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData,
    StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors,
    StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostData,
    StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostErrors,
    StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntityStartPostData,
    StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessRuleStartPostData,
    StartDomainBusinessEntityMgtGetBusinessRuleStartPostErrors,
    StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostData,
    StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostErrors,
    StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponses,
    StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostData,
    StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostErrors,
    StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponses,
    StartDomainBusinessEntityMgtListBusinessRulesStartPostData,
    StartDomainBusinessEntityMgtListBusinessRulesStartPostErrors,
    StartDomainBusinessEntityMgtListBusinessRulesStartPostResponses,
    StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostData,
    StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostErrors,
    StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponses,
    StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData,
    StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors,
    StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostData,
    StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostErrors,
    StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostData,
    StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostErrors,
    StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponses,
    StartDomainDomainMgtCreateDomainStartPostData,
    StartDomainDomainMgtCreateDomainStartPostErrors,
    StartDomainDomainMgtCreateDomainStartPostResponses,
    StartDomainDomainMgtDeleteDomainStartPostData,
    StartDomainDomainMgtDeleteDomainStartPostErrors,
    StartDomainDomainMgtDeleteDomainStartPostResponses,
    StartDomainDomainMgtGetDomainsByStekStartPostData,
    StartDomainDomainMgtGetDomainsByStekStartPostResponses,
    StartDomainDomainMgtGetDomainStartPostData,
    StartDomainDomainMgtGetDomainStartPostErrors,
    StartDomainDomainMgtGetDomainStartPostResponses,
    StartDomainDomainMgtUpdateDomainOrdersStartPostData,
    StartDomainDomainMgtUpdateDomainOrdersStartPostErrors,
    StartDomainDomainMgtUpdateDomainOrdersStartPostResponses,
    StartDomainDomainMgtUpdateDomainStartPostData,
    StartDomainDomainMgtUpdateDomainStartPostErrors,
    StartDomainDomainMgtUpdateDomainStartPostResponses,
    StartDomainDomainTermMgtConvertToBusinessEntityStartPostData,
    StartDomainDomainTermMgtConvertToBusinessEntityStartPostErrors,
    StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponses,
    StartDomainDomainTermMgtCreateDomainTermStartPostData,
    StartDomainDomainTermMgtCreateDomainTermStartPostErrors,
    StartDomainDomainTermMgtCreateDomainTermStartPostResponses,
    StartDomainDomainTermMgtDeleteDomainTermStartPostData,
    StartDomainDomainTermMgtDeleteDomainTermStartPostErrors,
    StartDomainDomainTermMgtDeleteDomainTermStartPostResponses,
    StartDomainDomainTermMgtGetDomainTermsStartPostData,
    StartDomainDomainTermMgtGetDomainTermsStartPostErrors,
    StartDomainDomainTermMgtGetDomainTermsStartPostResponses,
    StartDomainDomainTermMgtGetDomainTermStartPostData,
    StartDomainDomainTermMgtGetDomainTermStartPostErrors,
    StartDomainDomainTermMgtGetDomainTermStartPostResponses,
    StartDomainDomainTermMgtUpdateDomainTermStartPostData,
    StartDomainDomainTermMgtUpdateDomainTermStartPostErrors,
    StartDomainDomainTermMgtUpdateDomainTermStartPostResponses,
    StartDomainRoleMgtCreateRoleStartPostData,
    StartDomainRoleMgtCreateRoleStartPostErrors,
    StartDomainRoleMgtCreateRoleStartPostResponses,
    StartDomainRoleMgtDeleteRoleStartPostData,
    StartDomainRoleMgtDeleteRoleStartPostErrors,
    StartDomainRoleMgtDeleteRoleStartPostResponses,
    StartDomainRoleMgtGetRolesStartPostData,
    StartDomainRoleMgtGetRolesStartPostErrors,
    StartDomainRoleMgtGetRolesStartPostResponses,
    StartDomainRoleMgtGetRoleStartPostData,
    StartDomainRoleMgtGetRoleStartPostErrors,
    StartDomainRoleMgtGetRoleStartPostResponses,
    StartDomainRoleMgtUpdateRoleStartPostData,
    StartDomainRoleMgtUpdateRoleStartPostErrors,
    StartDomainRoleMgtUpdateRoleStartPostResponses,
    StartHomeHomeMgtGetPersonalHomeStartPostData,
    StartHomeHomeMgtGetPersonalHomeStartPostErrors,
    StartHomeHomeMgtGetPersonalHomeStartPostResponses,
    StartOrganizationActivityMetricsGetOrganizationActivityStartGetData,
    StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors,
    StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses,
    StartOrganizationAgentMgtCreateAgentStartPostData,
    StartOrganizationAgentMgtCreateAgentStartPostErrors,
    StartOrganizationAgentMgtCreateAgentStartPostResponses,
    StartOrganizationAgentMgtCreateAgentTokenStartPostData,
    StartOrganizationAgentMgtCreateAgentTokenStartPostErrors,
    StartOrganizationAgentMgtCreateAgentTokenStartPostResponses,
    StartOrganizationAgentMgtDeleteAgentStartPostData,
    StartOrganizationAgentMgtDeleteAgentStartPostErrors,
    StartOrganizationAgentMgtDeleteAgentStartPostResponses,
    StartOrganizationAgentMgtListAgentsStartPostData,
    StartOrganizationAgentMgtListAgentsStartPostResponses,
    StartOrganizationAgentMgtListAgentTokensStartPostData,
    StartOrganizationAgentMgtListAgentTokensStartPostErrors,
    StartOrganizationAgentMgtListAgentTokensStartPostResponses,
    StartOrganizationAgentMgtListMcpConsumersStartPostData,
    StartOrganizationAgentMgtListMcpConsumersStartPostResponses,
    StartOrganizationAgentMgtRegrantAgentTokenStartPostData,
    StartOrganizationAgentMgtRegrantAgentTokenStartPostErrors,
    StartOrganizationAgentMgtRegrantAgentTokenStartPostResponses,
    StartOrganizationAgentMgtRevokeAgentTokenStartPostData,
    StartOrganizationAgentMgtRevokeAgentTokenStartPostErrors,
    StartOrganizationAgentMgtRevokeAgentTokenStartPostResponses,
    StartOrganizationAgentMgtRevokeMcpConsumerStartPostData,
    StartOrganizationAgentMgtRevokeMcpConsumerStartPostErrors,
    StartOrganizationAgentMgtRevokeMcpConsumerStartPostResponses,
    StartOrganizationAgentMgtUpdateAgentStartPostData,
    StartOrganizationAgentMgtUpdateAgentStartPostErrors,
    StartOrganizationAgentMgtUpdateAgentStartPostResponses,
    StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData,
    StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors,
    StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses,
    StartOrganizationOrganizationMgtGetOrganizationsStartPostData,
    StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses,
    StartProcessLaneMgtGetLaneByBpmnIdStartPostData,
    StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors,
    StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses,
    StartProcessLaneMgtGetLaneByRoleIdStartPostData,
    StartProcessLaneMgtGetLaneByRoleIdStartPostErrors,
    StartProcessLaneMgtGetLaneByRoleIdStartPostResponses,
    StartProcessLaneMgtGetLanesByProcessStartPostData,
    StartProcessLaneMgtGetLanesByProcessStartPostErrors,
    StartProcessLaneMgtGetLanesByProcessStartPostResponses,
    StartProcessLaneMgtGetLaneStartPostData,
    StartProcessLaneMgtGetLaneStartPostErrors,
    StartProcessLaneMgtGetLaneStartPostResponses,
    StartProcessProcessElementMgtArchiveProcessElementStartPostData,
    StartProcessProcessElementMgtArchiveProcessElementStartPostErrors,
    StartProcessProcessElementMgtArchiveProcessElementStartPostResponses,
    StartProcessProcessElementMgtDeleteEventStartPostData,
    StartProcessProcessElementMgtDeleteEventStartPostErrors,
    StartProcessProcessElementMgtDeleteEventStartPostResponses,
    StartProcessProcessElementMgtDeleteFlowStartPostData,
    StartProcessProcessElementMgtDeleteFlowStartPostErrors,
    StartProcessProcessElementMgtDeleteFlowStartPostResponses,
    StartProcessProcessElementMgtDeleteGatewayStartPostData,
    StartProcessProcessElementMgtDeleteGatewayStartPostErrors,
    StartProcessProcessElementMgtDeleteGatewayStartPostResponses,
    StartProcessProcessElementMgtDeleteTaskStartPostData,
    StartProcessProcessElementMgtDeleteTaskStartPostErrors,
    StartProcessProcessElementMgtDeleteTaskStartPostResponses,
    StartProcessProcessElementMgtGenerateUserInterfaceStartPostData,
    StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors,
    StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponse,
    StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses,
    StartProcessProcessElementMgtGetEventStartPostData,
    StartProcessProcessElementMgtGetEventStartPostErrors,
    StartProcessProcessElementMgtGetEventStartPostResponses,
    StartProcessProcessElementMgtGetFlowStartPostData,
    StartProcessProcessElementMgtGetFlowStartPostErrors,
    StartProcessProcessElementMgtGetFlowStartPostResponses,
    StartProcessProcessElementMgtGetGatewayStartPostData,
    StartProcessProcessElementMgtGetGatewayStartPostErrors,
    StartProcessProcessElementMgtGetGatewayStartPostResponses,
    StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData,
    StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors,
    StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses,
    StartProcessProcessElementMgtGetProcessElementsByEntityStartPostData,
    StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors,
    StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses,
    StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData,
    StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors,
    StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses,
    StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostData,
    StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostErrors,
    StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponses,
    StartProcessProcessElementMgtGetProcessTasksByStekStartPostData,
    StartProcessProcessElementMgtGetProcessTasksByStekStartPostErrors,
    StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponses,
    StartProcessProcessElementMgtGetTaskStartPostData,
    StartProcessProcessElementMgtGetTaskStartPostErrors,
    StartProcessProcessElementMgtGetTaskStartPostResponses,
    StartProcessProcessElementMgtUnarchiveProcessElementStartPostData,
    StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors,
    StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses,
    StartProcessProcessElementMgtUpdateEventStartPostData,
    StartProcessProcessElementMgtUpdateEventStartPostErrors,
    StartProcessProcessElementMgtUpdateEventStartPostResponses,
    StartProcessProcessElementMgtUpdateFlowStartPostData,
    StartProcessProcessElementMgtUpdateFlowStartPostErrors,
    StartProcessProcessElementMgtUpdateFlowStartPostResponses,
    StartProcessProcessElementMgtUpdateGatewayStartPostData,
    StartProcessProcessElementMgtUpdateGatewayStartPostErrors,
    StartProcessProcessElementMgtUpdateGatewayStartPostResponses,
    StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostData,
    StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors,
    StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses,
    StartProcessProcessElementMgtUpdateTaskEvidenceStartPostData,
    StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors,
    StartProcessProcessElementMgtUpdateTaskEvidenceStartPostResponses,
    StartProcessProcessElementMgtUpdateTaskStartPostData,
    StartProcessProcessElementMgtUpdateTaskStartPostErrors,
    StartProcessProcessElementMgtUpdateTaskStartPostResponses,
    StartProcessProcessMgtCreateProcessStartPostData,
    StartProcessProcessMgtCreateProcessStartPostErrors,
    StartProcessProcessMgtCreateProcessStartPostResponses,
    StartProcessProcessMgtDeleteProcessStartPostData,
    StartProcessProcessMgtDeleteProcessStartPostErrors,
    StartProcessProcessMgtDeleteProcessStartPostResponses,
    StartProcessProcessMgtDeployProcessStartPostData,
    StartProcessProcessMgtDeployProcessStartPostErrors,
    StartProcessProcessMgtDeployProcessStartPostResponses,
    StartProcessProcessMgtGetProcessDiagramStartPostData,
    StartProcessProcessMgtGetProcessDiagramStartPostErrors,
    StartProcessProcessMgtGetProcessDiagramStartPostResponses,
    StartProcessProcessMgtGetProcessesByProductStartPostData,
    StartProcessProcessMgtGetProcessesByProductStartPostErrors,
    StartProcessProcessMgtGetProcessesByProductStartPostResponses,
    StartProcessProcessMgtGetProcessStartPostData,
    StartProcessProcessMgtGetProcessStartPostErrors,
    StartProcessProcessMgtGetProcessStartPostResponses,
    StartProcessProcessMgtGetProcessThumbnailsByProductStartPostData,
    StartProcessProcessMgtGetProcessThumbnailsByProductStartPostErrors,
    StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponses,
    StartProcessProcessMgtMoveProcessStartPostData,
    StartProcessProcessMgtMoveProcessStartPostErrors,
    StartProcessProcessMgtMoveProcessStartPostResponses,
    StartProcessProcessMgtUpdateProcessOrdersStartPostData,
    StartProcessProcessMgtUpdateProcessOrdersStartPostErrors,
    StartProcessProcessMgtUpdateProcessOrdersStartPostResponses,
    StartProcessProcessMgtUpdateProcessStartPostData,
    StartProcessProcessMgtUpdateProcessStartPostErrors,
    StartProcessProcessMgtUpdateProcessStartPostResponses,
    StartProductProductMgtCreateProductStartPostData,
    StartProductProductMgtCreateProductStartPostErrors,
    StartProductProductMgtCreateProductStartPostResponses,
    StartProductProductMgtDeleteProductStartPostData,
    StartProductProductMgtDeleteProductStartPostErrors,
    StartProductProductMgtDeleteProductStartPostResponses,
    StartProductProductMgtGetProductsByDomainStartPostData,
    StartProductProductMgtGetProductsByDomainStartPostErrors,
    StartProductProductMgtGetProductsByDomainStartPostResponses,
    StartProductProductMgtGetProductStartPostData,
    StartProductProductMgtGetProductStartPostErrors,
    StartProductProductMgtGetProductStartPostResponses,
    StartProductProductMgtMoveProductStartPostData,
    StartProductProductMgtMoveProductStartPostErrors,
    StartProductProductMgtMoveProductStartPostResponses,
    StartProductProductMgtUpdateProductOrdersStartPostData,
    StartProductProductMgtUpdateProductOrdersStartPostErrors,
    StartProductProductMgtUpdateProductOrdersStartPostResponses,
    StartProductProductMgtUpdateProductStartPostData,
    StartProductProductMgtUpdateProductStartPostErrors,
    StartProductProductMgtUpdateProductStartPostResponses,
    StartStekLiveMgtGetComplianceEvidenceStartPostData,
    StartStekLiveMgtGetComplianceEvidenceStartPostErrors,
    StartStekLiveMgtGetComplianceEvidenceStartPostResponses,
    StartStekLiveMgtGetElementMetricsStartPostData,
    StartStekLiveMgtGetElementMetricsStartPostErrors,
    StartStekLiveMgtGetElementMetricsStartPostResponses,
    StartStekLiveMgtGetLiveInsightsStartPostData,
    StartStekLiveMgtGetLiveInsightsStartPostErrors,
    StartStekLiveMgtGetLiveInsightsStartPostResponses,
    StartStekLiveMgtGetMetricsStartPostData,
    StartStekLiveMgtGetMetricsStartPostErrors,
    StartStekLiveMgtGetMetricsStartPostResponses,
    StartStekLiveMgtGetProcessInstancesStartPostData,
    StartStekLiveMgtGetProcessInstancesStartPostErrors,
    StartStekLiveMgtGetProcessInstancesStartPostResponses,
    StartStekLiveMgtGetRecentActivityStartPostData,
    StartStekLiveMgtGetRecentActivityStartPostErrors,
    StartStekLiveMgtGetRecentActivityStartPostResponses,
    StartStekLiveMgtGetReleasesStartPostData,
    StartStekLiveMgtGetReleasesStartPostResponses,
    StartStekLiveMgtIngestEventStartPostData,
    StartStekLiveMgtIngestEventStartPostErrors,
    StartStekLiveMgtIngestEventStartPostResponses,
    StartStekLiveMgtStreamActivityStartGetData,
    StartStekLiveMgtStreamActivityStartGetErrors,
    StartStekLiveMgtStreamActivityStartGetResponses,
    StartStekStekMgtCreateStekStartPostData,
    StartStekStekMgtCreateStekStartPostErrors,
    StartStekStekMgtCreateStekStartPostResponses,
    StartStekStekMgtDeleteStekStartPostData,
    StartStekStekMgtDeleteStekStartPostResponses,
    StartStekStekMgtExportStekStartPostData,
    StartStekStekMgtExportStekStartPostResponses,
    StartStekStekMgtGenerateStekDetailsStartPostData,
    StartStekStekMgtGenerateStekDetailsStartPostErrors,
    StartStekStekMgtGenerateStekDetailsStartPostResponses,
    StartStekStekMgtGetSetupStatusStartPostData,
    StartStekStekMgtGetSetupStatusStartPostResponses,
    StartStekStekMgtGetSteksByOrganizationStartPostData,
    StartStekStekMgtGetSteksByOrganizationStartPostResponses,
    StartStekStekMgtGetStekStartPostData,
    StartStekStekMgtGetStekStartPostResponses,
    StartStekStekMgtImportStekStartPostData,
    StartStekStekMgtImportStekStartPostErrors,
    StartStekStekMgtImportStekStartPostResponses,
    StartStekStekMgtManageStekStartPostData,
    StartStekStekMgtManageStekStartPostErrors,
    StartStekStekMgtManageStekStartPostResponses,
    StartStekStekMgtTreeStartPostData,
    StartStekStekMgtTreeStartPostResponses,
    StartStekStekMgtUpdateStekStartPostData,
    StartStekStekMgtUpdateStekStartPostErrors,
    StartStekStekMgtUpdateStekStartPostResponses,
    StartStekStekMgtUpdateStrategyStartPostData,
    StartStekStekMgtUpdateStrategyStartPostErrors,
    StartStekStekMgtUpdateStrategyStartPostResponses,
    StartStekStekReleaseMgtCreateReleaseStartPostData,
    StartStekStekReleaseMgtCreateReleaseStartPostErrors,
    StartStekStekReleaseMgtCreateReleaseStartPostResponses,
    StartStekStekReleaseMgtGetReleaseDiffStartPostData,
    StartStekStekReleaseMgtGetReleaseDiffStartPostErrors,
    StartStekStekReleaseMgtGetReleaseDiffStartPostResponses,
    StartStekStekReleaseMgtGetReleaseStartPostData,
    StartStekStekReleaseMgtGetReleaseStartPostErrors,
    StartStekStekReleaseMgtGetReleaseStartPostResponses,
    StartStekStekReleaseMgtListReleasesStartPostData,
    StartStekStekReleaseMgtListReleasesStartPostResponses,
    StartStrategyStrategyMgtAcceptProposedCompetitorStartPostData,
    StartStrategyStrategyMgtAcceptProposedCompetitorStartPostErrors,
    StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponses,
    StartStrategyStrategyMgtCreateCompetitorStartPostData,
    StartStrategyStrategyMgtCreateCompetitorStartPostErrors,
    StartStrategyStrategyMgtCreateCompetitorStartPostResponses,
    StartStrategyStrategyMgtCreateObjectiveStartPostData,
    StartStrategyStrategyMgtCreateObjectiveStartPostErrors,
    StartStrategyStrategyMgtCreateObjectiveStartPostResponses,
    StartStrategyStrategyMgtCreateTrendStartPostData,
    StartStrategyStrategyMgtCreateTrendStartPostErrors,
    StartStrategyStrategyMgtCreateTrendStartPostResponses,
    StartStrategyStrategyMgtCreateWatcherStartPostData,
    StartStrategyStrategyMgtCreateWatcherStartPostErrors,
    StartStrategyStrategyMgtCreateWatcherStartPostResponses,
    StartStrategyStrategyMgtDeclineProposedCompetitorStartPostData,
    StartStrategyStrategyMgtDeclineProposedCompetitorStartPostErrors,
    StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponses,
    StartStrategyStrategyMgtDeleteCompetitorStartPostData,
    StartStrategyStrategyMgtDeleteCompetitorStartPostErrors,
    StartStrategyStrategyMgtDeleteCompetitorStartPostResponses,
    StartStrategyStrategyMgtDeleteObjectiveStartPostData,
    StartStrategyStrategyMgtDeleteObjectiveStartPostErrors,
    StartStrategyStrategyMgtDeleteObjectiveStartPostResponses,
    StartStrategyStrategyMgtDeleteTrendStartPostData,
    StartStrategyStrategyMgtDeleteTrendStartPostErrors,
    StartStrategyStrategyMgtDeleteTrendStartPostResponses,
    StartStrategyStrategyMgtDeleteWatcherStartPostData,
    StartStrategyStrategyMgtDeleteWatcherStartPostErrors,
    StartStrategyStrategyMgtDeleteWatcherStartPostResponses,
    StartStrategyStrategyMgtGetCompetitorHistoryStartPostData,
    StartStrategyStrategyMgtGetCompetitorHistoryStartPostErrors,
    StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponses,
    StartStrategyStrategyMgtGetHorizonsStartPostData,
    StartStrategyStrategyMgtGetHorizonsStartPostErrors,
    StartStrategyStrategyMgtGetHorizonsStartPostResponses,
    StartStrategyStrategyMgtGetMarketStartPostData,
    StartStrategyStrategyMgtGetMarketStartPostErrors,
    StartStrategyStrategyMgtGetMarketStartPostResponses,
    StartStrategyStrategyMgtGetObjectivesStartPostData,
    StartStrategyStrategyMgtGetObjectivesStartPostErrors,
    StartStrategyStrategyMgtGetObjectivesStartPostResponses,
    StartStrategyStrategyMgtGetProposedCompetitorsStartPostData,
    StartStrategyStrategyMgtGetProposedCompetitorsStartPostErrors,
    StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponses,
    StartStrategyStrategyMgtGetWatchersStartPostData,
    StartStrategyStrategyMgtGetWatchersStartPostErrors,
    StartStrategyStrategyMgtGetWatchersStartPostResponses,
    StartStrategyStrategyMgtUpdateCompetitorStartPostData,
    StartStrategyStrategyMgtUpdateCompetitorStartPostErrors,
    StartStrategyStrategyMgtUpdateCompetitorStartPostResponses,
    StartStrategyStrategyMgtUpdateHorizonsStartPostData,
    StartStrategyStrategyMgtUpdateHorizonsStartPostErrors,
    StartStrategyStrategyMgtUpdateHorizonsStartPostResponses,
    StartStrategyStrategyMgtUpdateObjectiveStartPostData,
    StartStrategyStrategyMgtUpdateObjectiveStartPostErrors,
    StartStrategyStrategyMgtUpdateObjectiveStartPostResponses,
    StartStrategyStrategyMgtUpdateTrendStartPostData,
    StartStrategyStrategyMgtUpdateTrendStartPostErrors,
    StartStrategyStrategyMgtUpdateTrendStartPostResponses,
    StartStrategyStrategyMgtUpdateWatcherStartPostData,
    StartStrategyStrategyMgtUpdateWatcherStartPostErrors,
    StartStrategyStrategyMgtUpdateWatcherStartPostResponses,
    StartThreadThreadMgtAttachThreadLinkStartPostData,
    StartThreadThreadMgtAttachThreadLinkStartPostErrors,
    StartThreadThreadMgtAttachThreadLinkStartPostResponses,
    StartThreadThreadMgtCatchUpStartPostData,
    StartThreadThreadMgtCatchUpStartPostErrors,
    StartThreadThreadMgtCatchUpStartPostResponses,
    StartThreadThreadMgtContributeToThreadStartPostData,
    StartThreadThreadMgtContributeToThreadStartPostErrors,
    StartThreadThreadMgtContributeToThreadStartPostResponses,
    StartThreadThreadMgtCreateThreadStartPostData,
    StartThreadThreadMgtCreateThreadStartPostErrors,
    StartThreadThreadMgtCreateThreadStartPostResponses,
    StartThreadThreadMgtDeleteThreadFileStartPostData,
    StartThreadThreadMgtDeleteThreadFileStartPostErrors,
    StartThreadThreadMgtDeleteThreadFileStartPostResponses,
    StartThreadThreadMgtDeleteThreadStartPostData,
    StartThreadThreadMgtDeleteThreadStartPostErrors,
    StartThreadThreadMgtDeleteThreadStartPostResponses,
    StartThreadThreadMgtGenerateAcceptMessageStartPostData,
    StartThreadThreadMgtGenerateAcceptMessageStartPostErrors,
    StartThreadThreadMgtGenerateAcceptMessageStartPostResponses,
    StartThreadThreadMgtGetThreadFileStartPostData,
    StartThreadThreadMgtGetThreadFileStartPostErrors,
    StartThreadThreadMgtGetThreadFileStartPostResponses,
    StartThreadThreadMgtGetThreadStartPostData,
    StartThreadThreadMgtGetThreadStartPostErrors,
    StartThreadThreadMgtGetThreadStartPostResponses,
    StartThreadThreadMgtListThreadsStartPostData,
    StartThreadThreadMgtListThreadsStartPostErrors,
    StartThreadThreadMgtListThreadsStartPostResponses,
    StartThreadThreadMgtListThreadUserChangesStartPostData,
    StartThreadThreadMgtListThreadUserChangesStartPostErrors,
    StartThreadThreadMgtListThreadUserChangesStartPostResponses,
    StartThreadThreadMgtMarkThreadReadStartPostData,
    StartThreadThreadMgtMarkThreadReadStartPostErrors,
    StartThreadThreadMgtMarkThreadReadStartPostResponses,
    StartThreadThreadMgtReadEntityVersionsStartPostData,
    StartThreadThreadMgtReadEntityVersionsStartPostErrors,
    StartThreadThreadMgtReadEntityVersionsStartPostResponses,
    StartThreadThreadMgtResolveConflictStartPostData,
    StartThreadThreadMgtResolveConflictStartPostErrors,
    StartThreadThreadMgtResolveConflictStartPostResponses,
    StartThreadThreadMgtResolveSafeConflictsStartPostData,
    StartThreadThreadMgtResolveSafeConflictsStartPostErrors,
    StartThreadThreadMgtResolveSafeConflictsStartPostResponses,
    StartThreadThreadMgtResolveThreadStartPostData,
    StartThreadThreadMgtResolveThreadStartPostErrors,
    StartThreadThreadMgtResolveThreadStartPostResponses,
    StartThreadThreadMgtRespondToProposalStartPostData,
    StartThreadThreadMgtRespondToProposalStartPostErrors,
    StartThreadThreadMgtRespondToProposalStartPostResponses,
    StartThreadThreadMgtSetAutoApplyStartPostData,
    StartThreadThreadMgtSetAutoApplyStartPostErrors,
    StartThreadThreadMgtSetAutoApplyStartPostResponses,
    StartThreadThreadMgtStartThreadAgentStartPostData,
    StartThreadThreadMgtStartThreadAgentStartPostErrors,
    StartThreadThreadMgtStartThreadAgentStartPostResponses,
    StartThreadThreadMgtUnresolveConflictStartPostData,
    StartThreadThreadMgtUnresolveConflictStartPostErrors,
    StartThreadThreadMgtUnresolveConflictStartPostResponses,
    StartThreadThreadMgtUpdateThreadStartPostData,
    StartThreadThreadMgtUpdateThreadStartPostErrors,
    StartThreadThreadMgtUpdateThreadStartPostResponses,
    StartThreadThreadMgtUploadThreadFileStartPostData,
    StartThreadThreadMgtUploadThreadFileStartPostErrors,
    StartThreadThreadMgtUploadThreadFileStartPostResponses,
    StartWorkspaceWorktreeMgtGetWorktreeStartPostData,
    StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors,
    StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses,
    StekThreadEventsThreadEventsGetData,
    StekThreadEventsThreadEventsGetResponses,
    StripeWebhookStripeWebhookPostData,
    StripeWebhookStripeWebhookPostResponses,
    TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostData,
    TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors,
    TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses,
    ThreadEventsThreadEventsThreadIdGetData,
    ThreadEventsThreadEventsThreadIdGetErrors,
    ThreadEventsThreadEventsThreadIdGetResponses,
    TokenEndpointIntegrationsOauth2ServerTokenPostData,
    TokenEndpointIntegrationsOauth2ServerTokenPostErrors,
    TokenEndpointIntegrationsOauth2ServerTokenPostResponses,
    UpdateAuthorizationUserUserIdAuthorizationPutData,
    UpdateAuthorizationUserUserIdAuthorizationPutErrors,
    UpdateAuthorizationUserUserIdAuthorizationPutResponses,
    UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutData,
    UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutErrors,
    UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponses,
    UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutData,
    UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutErrors,
    UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponses,
    UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchData,
    UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchErrors,
    UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchResponses,
    UpdateSelfPreferencesUserMePreferencesPatchData,
    UpdateSelfPreferencesUserMePreferencesPatchErrors,
    UpdateSelfPreferencesUserMePreferencesPatchResponses,
    UpdateSelfUserMePutData,
    UpdateSelfUserMePutErrors,
    UpdateSelfUserMePutResponses,
    UploadMediaWhatsNewWhatsNewMgtUploadsPostData,
    UploadMediaWhatsNewWhatsNewMgtUploadsPostErrors,
    UploadMediaWhatsNewWhatsNewMgtUploadsPostResponses,
    ValidateInvitationUserInvitationValidatePostData,
    ValidateInvitationUserInvitationValidatePostErrors,
    ValidateInvitationUserInvitationValidatePostResponses,
    WipeContextMePersonalContextDeleteData,
    WipeContextMePersonalContextDeleteResponses,
} from "./types.gen";

export type Options<
    TData extends TDataShape = TDataShape,
    ThrowOnError extends boolean = boolean,
    TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never
        ? Record<string, unknown>
        : ClientMeta;
};

/**
 * Get Oauth Metadata
 *
 * OAuth2 discovery endpoint.
 *
 * Returns server metadata according to RFC 8414.
 * This endpoint provides information about the OAuth server's capabilities.
 */
export const getOauthMetadataWellKnownOauthAuthorizationServerGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        GetOauthMetadataWellKnownOauthAuthorizationServerGetData,
        ThrowOnError
    >
): RequestResult<
    GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses,
        unknown,
        ThrowOnError
    >({ url: "/.well-known/oauth-authorization-server", ...options });

/**
 * Get Oauth Protected Resource Metadata
 *
 * OAuth2 protected resource metadata endpoint.
 *
 * Returns protected resource metadata according to RFC 9728.
 * This endpoint allows OAuth clients to discover which authorization servers
 * this protected resource trusts and what scopes it supports.
 */
export const getOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGet =
    <ThrowOnError extends boolean = false>(
        options?: Options<
            GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetData,
            ThrowOnError
        >
    ): RequestResult<
        GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses,
        unknown,
        ThrowOnError
    > =>
        (options?.client ?? client).get<
            GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses,
            unknown,
            ThrowOnError
        >({ url: "/.well-known/oauth-protected-resource", ...options });

/**
 * List Feature Flags
 *
 * Return the kill-switch state of every registered feature (platform admin only).
 *
 * Features with no stored flag row are reported as enabled: a feature is
 * switchable whether or not anyone has ever flipped it, and the operator surface
 * has to show what can be flipped, not only what already was.
 */
export const listFeatureFlagsAdminFeatureFlagsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<ListFeatureFlagsAdminFeatureFlagsGetData, ThrowOnError>
): RequestResult<
    ListFeatureFlagsAdminFeatureFlagsGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        ListFeatureFlagsAdminFeatureFlagsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/feature-flags",
        ...options,
    });

/**
 * Update Feature Flag
 *
 * Enable or disable a feature flag globally (platform admin only).
 *
 * Disabling a feature prevents all Steks from using it regardless of their
 * subscription status, and takes effect on the next entitlement check: the flag
 * is read live on every check, so there is no cache to invalidate and no TTL to
 * wait out.
 */
export const updateFeatureFlagAdminFeatureFlagsFeatureKeyPut = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutData,
        ThrowOnError
    >
): RequestResult<
    UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponses,
    UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutErrors,
    ThrowOnError
> =>
    (options.client ?? client).put<
        UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponses,
        UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/feature-flags/{feature_key}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Environment Features
 *
 * What this environment is configured with (platform admin only).
 *
 * ``env_flags`` are the ``FEATURE_FLAGS__*`` values from the Pulumi stack config, rendered
 * as-is: changing one is a config commit and a deploy, never an API call. The kill-switches
 * are the same rows ``GET /admin/feature-flags`` manages, included so the page has one
 * environment section; writes stay on that endpoint.
 */
export const getEnvironmentFeaturesAdminFeaturesEnvironmentGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        GetEnvironmentFeaturesAdminFeaturesEnvironmentGetData,
        ThrowOnError
    >
): RequestResult<
    GetEnvironmentFeaturesAdminFeaturesEnvironmentGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetEnvironmentFeaturesAdminFeaturesEnvironmentGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/features/environment",
        ...options,
    });

/**
 * List Org Features
 *
 * Every active organisation's persistence mode, capabilities, rules and stale flags.
 */
export const listOrgFeaturesAdminFeaturesOrganizationsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        ListOrgFeaturesAdminFeaturesOrganizationsGetData,
        ThrowOnError
    >
): RequestResult<
    ListOrgFeaturesAdminFeaturesOrganizationsGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        ListOrgFeaturesAdminFeaturesOrganizationsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/features/organizations",
        ...options,
    });

/**
 * Get Org Features
 *
 * One organisation, plus its last verifier report and flag audit trail.
 */
export const getOrgFeaturesAdminFeaturesOrganizationsOrgIdGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetData,
        ThrowOnError
    >
): RequestResult<
    GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetResponses,
    GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetResponses,
        GetOrgFeaturesAdminFeaturesOrganizationsOrgIdGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/features/organizations/{org_id}",
        ...options,
    });

/**
 * Update Org Flags
 *
 * Grant or revoke capability flags and triage rules for one organisation, audited.
 *
 * One batch, one reason, one audit ``batch_id``. Every key is validated against the
 * catalog before anything is written; an unknown key is a 422 naming the valid keys, so a
 * typo never becomes a silently inert row. Persistence mode is not changeable here — the
 * ladder stays in ``manage.py persistence``.
 */
export const updateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatch = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchData,
        ThrowOnError
    >
): RequestResult<
    UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchResponses,
    UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchErrors,
    ThrowOnError
> =>
    (options.client ?? client).patch<
        UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchResponses,
        UpdateOrgFlagsAdminFeaturesOrganizationsOrgIdFlagsPatchErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/features/organizations/{org_id}/flags",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Delete Stale Org Flag
 *
 * Delete one raw flag row whatever its key — the escape hatch for stale rows.
 *
 * Catalog keys should be toggled through the PATCH; this exists for rows that no catalog
 * knows any more and that would otherwise be invisible and undeletable from the UI.
 */
export const deleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDelete =
    <ThrowOnError extends boolean = false>(
        options: Options<
            DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteData,
            ThrowOnError
        >
    ): RequestResult<
        DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteResponses,
        DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteErrors,
        ThrowOnError
    > =>
        (options.client ?? client).delete<
            DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteResponses,
            DeleteStaleOrgFlagAdminFeaturesOrganizationsOrgIdFlagsFlagDeleteErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/admin/features/organizations/{org_id}/flags/{flag}",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * List Org Subscriptions
 *
 * Return all non-archived organisations with their per-feature subscription overview.
 *
 * Each row shows the primary (live_mode) plan tier, aggregate usage for the
 * current billing period, and per-feature summaries for the features column.
 */
export const listOrgSubscriptionsAdminOrganizationsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        ListOrgSubscriptionsAdminOrganizationsGetData,
        ThrowOnError
    >
): RequestResult<
    ListOrgSubscriptionsAdminOrganizationsGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        ListOrgSubscriptionsAdminOrganizationsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/organizations",
        ...options,
    });

/**
 * Change Org Feature Subscription
 *
 * Manually assign a subscription tier to a single (org, feature) pair.
 *
 * This is an administrative override — no Stripe is involved.
 *
 * - ``plan_tier="free"`` moves the org to the free tier (status='free',
 * hard-blocked at the feature's ``free_event_limit``).
 * - Any other tier sets status='active' and sets ``monthly_cap`` to
 * the canonical cap for that tier.
 * - ``price_per_unit`` controls overage billing.  Pass ``null`` to hard-block
 * at cap (default for free).  Pass a value (e.g. 0.001) for metered overage.
 */
export const changeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatch =
    <ThrowOnError extends boolean = false>(
        options: Options<
            ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchData,
            ThrowOnError
        >
    ): RequestResult<
        ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponses,
        ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchErrors,
        ThrowOnError
    > =>
        (options.client ?? client).patch<
            ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponses,
            ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/admin/organizations/{org_id}/features/{feature}/subscription",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * List Subscription Audit
 *
 * Return the plan-override history for an organisation, newest first.
 *
 * Unpaginated: an override is a manual platform-admin action, so a single
 * organisation accumulates a handful of rows. Add a limit/cursor here if that
 * ever stops being true.
 */
export const listSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGet =
    <ThrowOnError extends boolean = false>(
        options: Options<
            ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetData,
            ThrowOnError
        >
    ): RequestResult<
        ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponses,
        ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetErrors,
        ThrowOnError
    > =>
        (options.client ?? client).get<
            ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponses,
            ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/admin/organizations/{org_id}/subscription-audit",
            ...options,
        });

/**
 * List Subscriptions
 *
 * Return all feature subscriptions for all organisations (platform admin only).
 *
 * Use ``status`` and ``feature`` query params to filter results.
 * Pagination is supported via ``page`` (0-indexed) and ``page_size``.
 */
export const listSubscriptionsAdminSubscriptionsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<ListSubscriptionsAdminSubscriptionsGetData, ThrowOnError>
): RequestResult<
    ListSubscriptionsAdminSubscriptionsGetResponses,
    ListSubscriptionsAdminSubscriptionsGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        ListSubscriptionsAdminSubscriptionsGetResponses,
        ListSubscriptionsAdminSubscriptionsGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/admin/subscriptions",
        ...options,
    });

/**
 * Start
 *
 * List task evaluations for a specific task name.
 *
 * Args:
 * request: The request containing the task name to filter evaluations by
 *
 * Returns:
 * A TaskEvaluationListResponse containing matching evaluation results.
 */
export const startAiEvaluationGetTaskEvaluationsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartAiEvaluationGetTaskEvaluationsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartAiEvaluationGetTaskEvaluationsStartPostResponses,
    StartAiEvaluationGetTaskEvaluationsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartAiEvaluationGetTaskEvaluationsStartPostResponses,
        StartAiEvaluationGetTaskEvaluationsStartPostErrors,
        ThrowOnError
    >({
        url: "/ai/evaluation/get_task_evaluations/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get the supported providers for a specific task type.
 *
 * Args:
 * request: The request containing the task type to get providers for
 *
 * Returns:
 * A SupportedProvidersResponse containing the list of supported providers
 */
export const startAiTaskMgtGetTaskProvidersStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartAiTaskMgtGetTaskProvidersStartPostData, ThrowOnError>
): RequestResult<
    StartAiTaskMgtGetTaskProvidersStartPostResponses,
    StartAiTaskMgtGetTaskProvidersStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartAiTaskMgtGetTaskProvidersStartPostResponses,
        StartAiTaskMgtGetTaskProvidersStartPostErrors,
        ThrowOnError
    >({
        url: "/ai/task_mgt/get_task_providers/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Run a task evaluation and return the result as a streaming response.
 *
 * Args:
 * request: The task evaluation request containing task type, config, and model settings
 *
 * Returns:
 * A streaming response with the task evaluation results
 */
export const startAiTaskMgtRunTaskStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartAiTaskMgtRunTaskStartPostData, ThrowOnError>
): RequestResult<
    StartAiTaskMgtRunTaskStartPostResponses,
    StartAiTaskMgtRunTaskStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartAiTaskMgtRunTaskStartPostResponses,
        StartAiTaskMgtRunTaskStartPostErrors,
        ThrowOnError
    >({
        url: "/ai/task_mgt/run_task/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Current
 *
 * What happened to my last question here — the answer, or how far it has got.
 *
 * ``null`` when there is nothing: never asked, expired, or the store is
 * unreachable. All three mean the same thing to a box that is opening.
 *
 * This is what makes closing the box survivable. Nothing is identified by a
 * run id, so a browser that has forgotten everything can still find its way
 * back to an answer it asked for.
 */
export const currentAskAskMgtAnswerQuestionCurrentGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        CurrentAskAskMgtAnswerQuestionCurrentGetData,
        ThrowOnError
    >
): RequestResult<
    CurrentAskAskMgtAnswerQuestionCurrentGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        CurrentAskAskMgtAnswerQuestionCurrentGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/ask/ask_mgt/answer_question/current",
        ...options,
    });

/**
 * Start
 *
 * Ask one question about this stek. Returns as soon as it has been accepted.
 *
 * Read-only against the shared model, which is not the same as read-only:
 * asked while the caller is standing in an open draft — the `x-thread-revision`
 * header names it — the box can create, change, move and delete entities on
 * that draft's branch, in the caller's name. Nothing it does reaches the
 * shared version; accepting the draft is what does that, and that is somebody
 * else's request. The stek comes from the header rather than the body, so the
 * question a caller sends can never widen what it is asked about.
 *
 * **The answer is not in this response.** The run happens in a worker and the
 * reply here is the record of it having started — status, question, start
 * time. The answer arrives on the event stream, or is fetched from ``current``
 * whenever the box next opens. That is the point of the ticket behind this: the
 * request used to stay open for the length of a model run, holding one of ten
 * pooled connections idle in a transaction for most of a minute.
 *
 * ``query`` rather than ``execute``: it passes the shared context and opens no
 * SAVEPOINT, where ``execute`` would wrap this in a UnitOfWork. Nothing behind
 * it writes to the database at all now — the handoff is a Valkey write and an
 * enqueue.
 *
 * It also access-checks every typed id it is handed, and ``StekId`` is one — so
 * the stek is confirmed to belong to the caller's organization before any of
 * this runs.
 */
export const startAskAskMgtAnswerQuestionStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartAskAskMgtAnswerQuestionStartPostData, ThrowOnError>
): RequestResult<
    StartAskAskMgtAnswerQuestionStartPostResponses,
    StartAskAskMgtAnswerQuestionStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartAskAskMgtAnswerQuestionStartPostResponses,
        StartAskAskMgtAnswerQuestionStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/ask/ask_mgt/answer_question/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Open the box already talking about one of this stek's own findings.
 *
 * The body carries **an identity, never a sentence.** What the landing page
 * drew on the card was rendered when the page was read; the finding behind it
 * may have been fixed since. So the identity is all that crosses, the finding
 * is looked up again on this side, and the question is written from what comes
 * back. A stale card cannot put words in the box's mouth.
 *
 * ``issue_key`` narrows the group to one finding: the triage pane's reader
 * clicked a row, not a card, and the box should open on that row.
 *
 * Answers exactly as ``answer_question/start`` does, with the same shape and
 * the same meaning — the run, not the answer. Everything after this point is
 * an ordinary run, so the event stream, ``current`` and the conversation all
 * behave identically. A **404** means the finding is gone, and the copy on it
 * is written for a reader.
 *
 * A second endpoint rather than a flag on the first, because the two take
 * different things and mean different things. One is handed a question; this
 * one writes the question itself, and that difference is the whole of
 * requirement 10.
 */
export const startAskAskMgtAskAboutSuggestionStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartAskAskMgtAskAboutSuggestionStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartAskAskMgtAskAboutSuggestionStartPostResponses,
    StartAskAskMgtAskAboutSuggestionStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartAskAskMgtAskAboutSuggestionStartPostResponses,
        StartAskAskMgtAskAboutSuggestionStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/ask/ask_mgt/ask_about_suggestion/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * What gotoko has noticed about one entity — for the box, opened on its page.
 *
 * Answers with the landing page's own ``Suggestion`` shape, at most two,
 * filtered to findings that touch this entity. The same shape on purpose: a
 * prompt here and a card there are one thing, and clicking either hands the
 * same identity to ``ask_about_suggestion/start``.
 *
 * An empty list is the ordinary answer — nothing noticed, or nobody watching —
 * and never an error. The box shows nothing and says nothing.
 */
export const startAskAskMgtNoticedAboutStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartAskAskMgtNoticedAboutStartPostData, ThrowOnError>
): RequestResult<
    StartAskAskMgtNoticedAboutStartPostResponses,
    StartAskAskMgtNoticedAboutStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartAskAskMgtNoticedAboutStartPostResponses,
        StartAskAskMgtNoticedAboutStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/ask/ask_mgt/noticed_about/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Ask Events
 *
 * Stream this caller's ask-run events for this stek.
 *
 * Authorization is the same ``stek.user`` check the box's own endpoints
 * enforce, run here against a short-lived session that is released before the
 * stream starts. It is done by calling the read task itself rather than by
 * reimplementing the gate: a stream that could be opened where the read is
 * refused would be a way around the read.
 */
export const askEventsAskEventsGet = <ThrowOnError extends boolean = false>(
    options?: Options<AskEventsAskEventsGetData, ThrowOnError>
): RequestResult<AskEventsAskEventsGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        AskEventsAskEventsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/ask/events",
        ...options,
    });

/**
 * Start
 *
 * Add an artefact to an entity.
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementAddArtefactStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementAddArtefactStartPostResponses,
    StartBizArtefactManagementAddArtefactStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementAddArtefactStartPostResponses,
        StartBizArtefactManagementAddArtefactStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/add_artefact/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Add artefact group to an entity
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * name: str - The name of the artefact group
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactGroupStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementAddArtefactGroupStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementAddArtefactGroupStartPostResponses,
    StartBizArtefactManagementAddArtefactGroupStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementAddArtefactGroupStartPostResponses,
        StartBizArtefactManagementAddArtefactGroupStartPostErrors,
        ThrowOnError
    >({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/add_artefact_group/start",
        ...options,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get the artefact in the given location
 *
 * Request params:
 * - artefact_id: str - The identity of the artefact to get
 * - revision: str - Optional revision of the artefact to get
 */
export const startBizArtefactManagementGetArtefactStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementGetArtefactStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementGetArtefactStartPostResponses,
    StartBizArtefactManagementGetArtefactStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementGetArtefactStartPostResponses,
        StartBizArtefactManagementGetArtefactStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/get_artefact/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get artefact tree for given Entity containing directories and files
 */
export const startBizArtefactManagementGetArtefactsTreeStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementGetArtefactsTreeStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementGetArtefactsTreeStartPostResponses,
    StartBizArtefactManagementGetArtefactsTreeStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementGetArtefactsTreeStartPostResponses,
        StartBizArtefactManagementGetArtefactsTreeStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/get_artefacts_tree/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get the history of a given artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to get the history of
 * - limit?: int - The maximum number of history items to return, defaults to 10
 * - offset?: int - The number of history items to skip, defaults to 0
 */
export const startBizArtefactManagementGetHistoryStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementGetHistoryStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementGetHistoryStartPostResponses,
    StartBizArtefactManagementGetHistoryStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementGetHistoryStartPostResponses,
        StartBizArtefactManagementGetHistoryStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/get_history/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Remove an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementRemoveArtefactStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementRemoveArtefactStartPostResponses,
    StartBizArtefactManagementRemoveArtefactStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementRemoveArtefactStartPostResponses,
        StartBizArtefactManagementRemoveArtefactStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/remove_artefact/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Remove an Artefact group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact group to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactGroupStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementRemoveArtefactGroupStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementRemoveArtefactGroupStartPostResponses,
    StartBizArtefactManagementRemoveArtefactGroupStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementRemoveArtefactGroupStartPostResponses,
        StartBizArtefactManagementRemoveArtefactGroupStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/remove_artefact_group/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Rename an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to rename
 * - name: str - The new name of the Artefact
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 *
 * @deprecated
 */
export const startBizArtefactManagementRenameArtefactStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementRenameArtefactStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementRenameArtefactStartPostResponses,
    StartBizArtefactManagementRenameArtefactStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementRenameArtefactStartPostResponses,
        StartBizArtefactManagementRenameArtefactStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/rename_artefact/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Rename an Artefact Group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact Group to rename
 * - name: str - The new name of the Artefact Group
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRenameArtefactGroupStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementRenameArtefactGroupStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementRenameArtefactGroupStartPostResponses,
    StartBizArtefactManagementRenameArtefactGroupStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementRenameArtefactGroupStartPostResponses,
        StartBizArtefactManagementRenameArtefactGroupStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/rename_artefact_group/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Restore an Artefact from the history.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - revision?: str - The revision to restore the artefact from
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRestoreHistoricalArtefactStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementRestoreHistoricalArtefactStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses,
    StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses,
        StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/restore_historical_artefact/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update an Artefact. Any parameters given will be updated.
 *
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update.
 * content: File - The file contents to update.
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}".
 * user_email: str - The email of the user making the request.
 */
export const startBizArtefactManagementUpdateArtefactStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementUpdateArtefactStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementUpdateArtefactStartPostResponses,
    StartBizArtefactManagementUpdateArtefactStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementUpdateArtefactStartPostResponses,
        StartBizArtefactManagementUpdateArtefactStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/update_artefact/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Add a file artefact to an entity
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 *
 * @deprecated
 */
export const startBizArtefactManagementUpdateArtefactContentStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizArtefactManagementUpdateArtefactContentStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartBizArtefactManagementUpdateArtefactContentStartPostResponses,
    StartBizArtefactManagementUpdateArtefactContentStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizArtefactManagementUpdateArtefactContentStartPostResponses,
        StartBizArtefactManagementUpdateArtefactContentStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/artefact_management/update_artefact_content/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Generate an entity description
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateDescriptionPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData,
        ThrowOnError,
        StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse
    >
): Promise<
    ServerSentEventsResult<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses>
> =>
    (options.client ?? client).sse.post<
        StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses,
        StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/generate_description",
        ...options,
    });

/**
 * Start
 *
 * Newest-first change history of the entity or anything nested under it.
 *
 * Unlike ``/{attribute}/history`` (one field's file), this is the git history
 * of the entity's whole subtree — its ``_meta.json`` + artefacts + nested
 * children — so ``history[0]`` is "last changed by X". For a stek this is the
 * merged timeline across its per-domain repos.
 *
 * Request params:
 * - limit: int - The number of history items to return
 * - offset: int - The number of history items to skip
 */
export const startBizEntitiesEntityTypeEntityIdHistoryGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdHistoryGetData,
        ThrowOnError
    >
): RequestResult<
    StartBizEntitiesEntityTypeEntityIdHistoryGetResponses,
    StartBizEntitiesEntityTypeEntityIdHistoryGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        StartBizEntitiesEntityTypeEntityIdHistoryGetResponses,
        StartBizEntitiesEntityTypeEntityIdHistoryGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/history",
        ...options,
    });

/**
 * Start
 *
 * Get entity info
 */
export const startBizEntitiesEntityTypeEntityIdInfoGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdInfoGetData,
        ThrowOnError
    >
): RequestResult<
    StartBizEntitiesEntityTypeEntityIdInfoGetResponses,
    StartBizEntitiesEntityTypeEntityIdInfoGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        StartBizEntitiesEntityTypeEntityIdInfoGetResponses,
        StartBizEntitiesEntityTypeEntityIdInfoGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/info",
        ...options,
    });

/**
 * Start
 *
 * Read-only snapshot of the entity and its children at ``revision``.
 *
 * Returns the whole entity subtree — description-bearing children, roles, terms,
 * products, business entities, application entities, or a process element's
 * linked refs — as of ``revision``, so the frontend can render the entity
 * exactly as it was at that historical version.
 */
export const startBizEntitiesEntityTypeEntityIdSnapshotGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdSnapshotGetData,
        ThrowOnError
    >
): RequestResult<
    StartBizEntitiesEntityTypeEntityIdSnapshotGetResponses,
    StartBizEntitiesEntityTypeEntityIdSnapshotGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        StartBizEntitiesEntityTypeEntityIdSnapshotGetResponses,
        StartBizEntitiesEntityTypeEntityIdSnapshotGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/snapshot",
        ...options,
    });

/**
 * Start
 *
 * Get the entity in the given location using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 */
export const startBizEntitiesEntityTypeEntityIdAttributeGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdAttributeGetData,
        ThrowOnError
    >
): RequestResult<
    StartBizEntitiesEntityTypeEntityIdAttributeGetResponses,
    StartBizEntitiesEntityTypeEntityIdAttributeGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        StartBizEntitiesEntityTypeEntityIdAttributeGetResponses,
        StartBizEntitiesEntityTypeEntityIdAttributeGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/{attribute}",
        ...options,
    });

/**
 * Start
 *
 * Get the entity history using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - limit: int - The number of history items to return
 * - offset: int - The number of history items to skip
 */
export const startBizEntitiesEntityTypeEntityIdAttributeHistoryGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData,
        ThrowOnError
    >
): RequestResult<
    StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses,
    StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses,
        StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/{attribute}/history",
        ...options,
    });

/**
 * Start
 *
 * Restore an entity to a previous version.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - revision: str - The revision to restore
 */
export const startBizEntitiesEntityTypeEntityIdAttributeRestorePost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData,
        ThrowOnError
    >
): RequestResult<
    StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses,
    StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses,
        StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/biz/entities/{entity_type}/{entity_id}/{attribute}/restore",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * What the stek says about how its data is handled, against what is required.
 *
 * ``scope_anchors``/``scope_selector`` narrow the question to part of the
 * business; empty means the whole stek. ``view`` chooses which world is being
 * asked about - the documented current state by default, never blended with
 * planned changes.
 *
 * ``thread_preview`` is true when the read resolved at a thread branch: the
 * answer is that thread's preview, and master's cards are untouched.
 */
export const startComplianceComplianceMgtGetComplianceStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartComplianceComplianceMgtGetComplianceStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceComplianceMgtGetComplianceStartPostResponses,
    StartComplianceComplianceMgtGetComplianceStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartComplianceComplianceMgtGetComplianceStartPostResponses,
        StartComplianceComplianceMgtGetComplianceStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/compliance_mgt/get_compliance/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Start
 *
 * The exact question, the applicable requirement and its definition, the
 * per-scope breakdown, the supporting and contradicting passages with their
 * sources, and what is still unknown.
 */
export const startComplianceComplianceMgtGetTopicDetailStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceComplianceMgtGetTopicDetailStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceComplianceMgtGetTopicDetailStartPostResponses,
    StartComplianceComplianceMgtGetTopicDetailStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceComplianceMgtGetTopicDetailStartPostResponses,
        StartComplianceComplianceMgtGetTopicDetailStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/compliance_mgt/get_topic_detail/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Read every source that changed since the last run and store its claims.
 *
 * An unchanged source keeps the claims it already has and costs nothing. A
 * batch whose analysis fails marks its own sources unanalysed rather than
 * failing the run - "we could not read this" is a state the page shows, and it
 * is not the same as "this document said nothing".
 *
 * One run at a time per stek: a second call while one is in progress is
 * refused with 409 rather than queued behind it.
 */
export const startComplianceComplianceMgtRefreshComplianceStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartComplianceComplianceMgtRefreshComplianceStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceComplianceMgtRefreshComplianceStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartComplianceComplianceMgtRefreshComplianceStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/compliance_mgt/refresh_compliance/start",
        ...options,
    });

/**
 * Start
 *
 * Record an answer as shared evidence and close the question for this person.
 *
 * The claims come back so the caller can show exactly what the answer was taken
 * to mean - and an answer that stated nothing the cards read comes back empty
 * rather than looking like it landed.
 */
export const startComplianceGapMgtAnswerGapStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartComplianceGapMgtAnswerGapStartPostData, ThrowOnError>
): RequestResult<
    StartComplianceGapMgtAnswerGapStartPostResponses,
    StartComplianceGapMgtAnswerGapStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceGapMgtAnswerGapStartPostResponses,
        StartComplianceGapMgtAnswerGapStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/gap_mgt/answer_gap/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * The gaps this person has not already answered, deferred past, or ruled
 * out - ordered by what the answer would unblock.
 */
export const startComplianceGapMgtGetPersonalGapsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartComplianceGapMgtGetPersonalGapsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceGapMgtGetPersonalGapsStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartComplianceGapMgtGetPersonalGapsStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/gap_mgt/get_personal_gaps/start",
        ...options,
    });

/**
 * Start
 *
 * Record that this person was asked, parked the question until
 * ``revisit_after``, or ruled it out with a reason. The answer is pinned to the
 * evidence it was given against, so it expires exactly when the question
 * genuinely becomes a new one.
 */
export const startComplianceGapMgtRecordGapFollowUpStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceGapMgtRecordGapFollowUpStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceGapMgtRecordGapFollowUpStartPostResponses,
    StartComplianceGapMgtRecordGapFollowUpStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceGapMgtRecordGapFollowUpStartPostResponses,
        StartComplianceGapMgtRecordGapFollowUpStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/gap_mgt/record_gap_follow_up/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Retire a requirement so it stops driving any card. The record stays, so a
 * merge from a branch that still carries it cannot bring it back.
 */
export const startComplianceRequirementMgtDeleteRequirementStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceRequirementMgtDeleteRequirementStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceRequirementMgtDeleteRequirementStartPostResponses,
    StartComplianceRequirementMgtDeleteRequirementStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceRequirementMgtDeleteRequirementStartPostResponses,
        StartComplianceRequirementMgtDeleteRequirementStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/requirement_mgt/delete_requirement/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Propose the requirements a document states, each quoting the sentence it
 * was read from. A proposal whose quote is not in the document is discarded.
 */
export const startComplianceRequirementMgtExtractRequirementsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceRequirementMgtExtractRequirementsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceRequirementMgtExtractRequirementsStartPostResponses,
    StartComplianceRequirementMgtExtractRequirementsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceRequirementMgtExtractRequirementsStartPostResponses,
        StartComplianceRequirementMgtExtractRequirementsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/requirement_mgt/extract_requirements/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Write what must be true, for which parts of the business.
 *
 * ``condition`` may only use the keys the topic declares - an unknown key is
 * rejected rather than ignored, because an ignored condition is
 * indistinguishable from a satisfied one.
 */
export const startComplianceRequirementMgtSetRequirementStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceRequirementMgtSetRequirementStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceRequirementMgtSetRequirementStartPostResponses,
    StartComplianceRequirementMgtSetRequirementStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceRequirementMgtSetRequirementStartPostResponses,
        StartComplianceRequirementMgtSetRequirementStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/requirement_mgt/set_requirement/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Accept an exception for a named scope, or withdraw one.
 */
export const startComplianceRequirementMgtSetRequirementExceptionStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceRequirementMgtSetRequirementExceptionStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceRequirementMgtSetRequirementExceptionStartPostResponses,
    StartComplianceRequirementMgtSetRequirementExceptionStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceRequirementMgtSetRequirementExceptionStartPostResponses,
        StartComplianceRequirementMgtSetRequirementExceptionStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/requirement_mgt/set_requirement_exception/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Mark a custom question reviewed - the gate on it ever reporting support -
 * or retire it.
 */
export const startComplianceTopicMgtReviewCustomTopicStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceTopicMgtReviewCustomTopicStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceTopicMgtReviewCustomTopicStartPostResponses,
    StartComplianceTopicMgtReviewCustomTopicStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceTopicMgtReviewCustomTopicStartPostResponses,
        StartComplianceTopicMgtReviewCustomTopicStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/topic_mgt/review_custom_topic/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Write a question of your own, using the predicates the extractor knows.
 */
export const startComplianceTopicMgtSetCustomTopicStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartComplianceTopicMgtSetCustomTopicStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartComplianceTopicMgtSetCustomTopicStartPostResponses,
    StartComplianceTopicMgtSetCustomTopicStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartComplianceTopicMgtSetCustomTopicStartPostResponses,
        StartComplianceTopicMgtSetCustomTopicStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/compliance/topic_mgt/set_custom_topic/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new ApplicationEntity.
 */
export const startDevApplicationEntityMgtCreateApplicationEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationEntityMgtCreateApplicationEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponses,
    StartDevApplicationEntityMgtCreateApplicationEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponses,
        StartDevApplicationEntityMgtCreateApplicationEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_entity_mgt/create_application_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a ApplicationEntity.
 */
export const startDevApplicationEntityMgtDeleteApplicationEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationEntityMgtDeleteApplicationEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationEntityMgtDeleteApplicationEntityStartPostResponses,
    StartDevApplicationEntityMgtDeleteApplicationEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationEntityMgtDeleteApplicationEntityStartPostResponses,
        StartDevApplicationEntityMgtDeleteApplicationEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_entity_mgt/delete_application_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all ApplicationEntities for an Application plus related external ApplicationEntities.
 */
export const startDevApplicationEntityMgtGetApplicationEntitiesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationEntityMgtGetApplicationEntitiesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponses,
    StartDevApplicationEntityMgtGetApplicationEntitiesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponses,
        StartDevApplicationEntityMgtGetApplicationEntitiesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_entity_mgt/get_application_entities/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Link a ApplicationEntity to a BusinessEntity.
 */
export const startDevApplicationEntityMgtLinkBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationEntityMgtLinkBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationEntityMgtLinkBusinessEntityStartPostResponses,
    StartDevApplicationEntityMgtLinkBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationEntityMgtLinkBusinessEntityStartPostResponses,
        StartDevApplicationEntityMgtLinkBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_entity_mgt/link_business_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Unlink a ApplicationEntity from its BusinessEntity.
 */
export const startDevApplicationEntityMgtUnlinkBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostResponses,
    StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostResponses,
        StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_entity_mgt/unlink_business_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a ApplicationEntity's name and, optionally, its relationships (atomic replace).
 */
export const startDevApplicationEntityMgtUpdateApplicationEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationEntityMgtUpdateApplicationEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationEntityMgtUpdateApplicationEntityStartPostResponses,
    StartDevApplicationEntityMgtUpdateApplicationEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationEntityMgtUpdateApplicationEntityStartPostResponses,
        StartDevApplicationEntityMgtUpdateApplicationEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_entity_mgt/update_application_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Replace the entity's documented columns.
 *
 * multipart/form-data, because the definition is a file. Its own endpoint
 * rather than a field on ``update_application_entity``: that one is a plain
 * JSON body, and folding a file into it would make every existing caller
 * multipart.
 */
export const startDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostResponses,
        StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostResponses,
            StartDevApplicationEntityMgtUpdateApplicationEntityAttributesStartPostErrors,
            ThrowOnError
        >({
            ...formDataBodySerializer,
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/dev/application_entity_mgt/update_application_entity_attributes/start",
            ...options,
            headers: {
                "Content-Type": null,
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Record that ``application_id`` depends on ``target_application_id``.
 *
 * ``technology`` may be a protocol (REST, OIDC, SMTP) but also "manual" or
 * "export/import" — manual flows are part of the landscape.
 */
export const startDevApplicationMgtAddApplicationDependencyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtAddApplicationDependencyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtAddApplicationDependencyStartPostResponses,
    StartDevApplicationMgtAddApplicationDependencyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtAddApplicationDependencyStartPostResponses,
        StartDevApplicationMgtAddApplicationDependencyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/add_application_dependency/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new Application.
 */
export const startDevApplicationMgtCreateApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtCreateApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtCreateApplicationStartPostResponses,
    StartDevApplicationMgtCreateApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtCreateApplicationStartPostResponses,
        StartDevApplicationMgtCreateApplicationStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/create_application/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a Application.
 */
export const startDevApplicationMgtDeleteApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtDeleteApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtDeleteApplicationStartPostResponses,
    StartDevApplicationMgtDeleteApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtDeleteApplicationStartPostResponses,
        StartDevApplicationMgtDeleteApplicationStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/delete_application/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get an Application by identity.
 */
export const startDevApplicationMgtGetApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationStartPostResponses,
    StartDevApplicationMgtGetApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationStartPostResponses,
        StartDevApplicationMgtGetApplicationStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_application/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get the explicit dependencies of an Application plus the derived (ghost)
 * edges it participates in.
 */
export const startDevApplicationMgtGetApplicationDependenciesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationDependenciesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationDependenciesStartPostResponses,
    StartDevApplicationMgtGetApplicationDependenciesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationDependenciesStartPostResponses,
        StartDevApplicationMgtGetApplicationDependenciesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_application_dependencies/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all Applications linked to any task in the given Domain's subtree.
 */
export const startDevApplicationMgtGetApplicationsByDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationsByDomainStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsByDomainStartPostResponses,
    StartDevApplicationMgtGetApplicationsByDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationsByDomainStartPostResponses,
        StartDevApplicationMgtGetApplicationsByDomainStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_by_domain/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all Applications linked to any task in the given Process.
 */
export const startDevApplicationMgtGetApplicationsByProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationsByProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsByProcessStartPostResponses,
    StartDevApplicationMgtGetApplicationsByProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationsByProcessStartPostResponses,
        StartDevApplicationMgtGetApplicationsByProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_by_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all Applications linked to any task in the given Product's processes.
 */
export const startDevApplicationMgtGetApplicationsByProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationsByProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsByProductStartPostResponses,
    StartDevApplicationMgtGetApplicationsByProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationsByProductStartPostResponses,
        StartDevApplicationMgtGetApplicationsByProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_by_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all Applications for a Stek.
 */
export const startDevApplicationMgtGetApplicationsByStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevApplicationMgtGetApplicationsByStekStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsByStekStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevApplicationMgtGetApplicationsByStekStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_by_stek/start",
        ...options,
    });

/**
 * Start
 *
 * Get all Applications for a Stek, each with its ApplicationEntities, in one call.
 */
export const startDevApplicationMgtGetApplicationsByStekWithEntitiesStartPost =
    <ThrowOnError extends boolean = false>(
        options?: Options<
            StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponses,
        unknown,
        ThrowOnError
    > =>
        (options?.client ?? client).post<
            StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponses,
            unknown,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/dev/application_mgt/get_applications_by_stek_with_entities/start",
            ...options,
        });

/**
 * Start
 *
 * Get the Applications of every Domain in the Stek, keyed by domain id.
 */
export const startDevApplicationMgtGetApplicationsGroupedByDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponses,
    StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponses,
        StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_grouped_by_domain/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get, per Process in the Product, the linked Applications, keyed by process id.
 */
export const startDevApplicationMgtGetApplicationsGroupedByProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponses,
    StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponses,
        StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_grouped_by_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get, per Product in the Domain, the linked Applications, keyed by product id.
 */
export const startDevApplicationMgtGetApplicationsGroupedByProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtGetApplicationsGroupedByProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponses,
    StartDevApplicationMgtGetApplicationsGroupedByProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponses,
        StartDevApplicationMgtGetApplicationsGroupedByProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_applications_grouped_by_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Compute the derived dependency edges of the whole landscape. Explicit
 * edges ride on the Applications themselves (``dependencies``).
 */
export const startDevApplicationMgtGetDerivedDependenciesByStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevApplicationMgtGetDerivedDependenciesByStekStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetDerivedDependenciesByStekStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevApplicationMgtGetDerivedDependenciesByStekStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_derived_dependencies_by_stek/start",
        ...options,
    });

/**
 * Start
 *
 * Derive the external communication map: message flows crossing the
 * organisation boundary, grouped by typed ExternalParty, plus untyped pool
 * names as "create party" suggestions.
 */
export const startDevApplicationMgtGetExternalCommunicationMapStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevApplicationMgtGetExternalCommunicationMapStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetExternalCommunicationMapStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevApplicationMgtGetExternalCommunicationMapStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_external_communication_map/start",
        ...options,
    });

/**
 * Start
 *
 * Read the stek's pool-triage decision records.
 */
export const startDevApplicationMgtGetPoolTriageDecisionsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevApplicationMgtGetPoolTriageDecisionsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_pool_triage_decisions/start",
        ...options,
    });

/**
 * Start
 *
 * Derive triage suggestions for every unresolved external pool:
 * recommend / party_type / confidence / safe / reason, plus the
 * deterministic name-match evidence. Fresh results persist per stek with an
 * evidence fingerprint, so suggestions survive reloads and the model only
 * runs for new/changed pools. AI suggests, the user decides.
 */
export const startDevApplicationMgtGetPoolTriageSuggestionsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevApplicationMgtGetPoolTriageSuggestionsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_pool_triage_suggestions/start",
        ...options,
    });

/**
 * Start
 *
 * List every role of the stek with its domain.
 */
export const startDevApplicationMgtGetStekRolesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevApplicationMgtGetStekRolesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtGetStekRolesStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevApplicationMgtGetStekRolesStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/get_stek_roles/start",
        ...options,
    });

/**
 * Start
 *
 * Link a ProcessTask to an Application.
 *
 * ``mode`` says how the application relates to the task: ``automates`` (the
 * software performs it), ``supports`` (a human performs it in the software —
 * the default) or ``records`` (the software only captures the outcome).
 */
export const startDevApplicationMgtLinkProcessTaskToApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtLinkProcessTaskToApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtLinkProcessTaskToApplicationStartPostResponses,
    StartDevApplicationMgtLinkProcessTaskToApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtLinkProcessTaskToApplicationStartPostResponses,
        StartDevApplicationMgtLinkProcessTaskToApplicationStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/link_process_task_to_application/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Promote the pool to internal roles across every domain whose
 * processes exchange messages with it; the roles are associated as one
 * identity and the pool leaves the external communication map. An explicit
 * ``role_id`` links the pool to that existing role instead — it anchors the
 * association and names the roles created in the other domains.
 * ``rename_from`` unifies sibling spellings of the same function: they are
 * renamed to ``pool_name`` inside their BPMN definitions first, and the
 * merged pool resolves as one decision (the rename is never undone).
 * ``proposal_fingerprint`` (from ``propose_pool_resolution``) pins the
 * resolution to its preview — drift aborts with a conflict.
 * ``convert_to_lane`` additionally remodels the pool as a lane of the
 * organisation's own pool in the same transaction (the one-click accept);
 * it requires the fingerprint.
 */
export const startDevApplicationMgtPromotePoolToRoleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtPromotePoolToRoleStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtPromotePoolToRoleStartPostResponses,
    StartDevApplicationMgtPromotePoolToRoleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtPromotePoolToRoleStartPostResponses,
        StartDevApplicationMgtPromotePoolToRoleStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/promote_pool_to_role/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Preview the BPMN changes of resolving the pool internally: the
 * sibling rename applied on resolve (fingerprint-pinned) composed with the
 * eventual lane restructure draft.
 */
export const startDevApplicationMgtProposePoolResolutionStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtProposePoolResolutionStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtProposePoolResolutionStartPostResponses,
    StartDevApplicationMgtProposePoolResolutionStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtProposePoolResolutionStartPostResponses,
        StartDevApplicationMgtProposePoolResolutionStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/propose_pool_resolution/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Remove a dependency edge (callable from either endpoint).
 */
export const startDevApplicationMgtRemoveApplicationDependencyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtRemoveApplicationDependencyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtRemoveApplicationDependencyStartPostResponses,
    StartDevApplicationMgtRemoveApplicationDependencyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtRemoveApplicationDependencyStartPostResponses,
        StartDevApplicationMgtRemoveApplicationDependencyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/remove_application_dependency/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Map the pool to an existing application. ``absorb_matching_roles``
 * additionally claims every same-named Role into the application's
 * ``actor_role_ids`` (the role→application conversion).
 * ``convert_to_lane`` additionally remodels the pool as a lane linked to
 * the application in the same transaction (the one-click accept of the
 * internal-scope stack); it requires the ``proposal_fingerprint`` from
 * ``propose_pool_resolution`` — drift aborts with a conflict.
 */
export const startDevApplicationMgtResolvePoolAsApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtResolvePoolAsApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtResolvePoolAsApplicationStartPostResponses,
    StartDevApplicationMgtResolvePoolAsApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtResolvePoolAsApplicationStartPostResponses,
        StartDevApplicationMgtResolvePoolAsApplicationStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/resolve_pool_as_application/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Resolve the pool as an external party: pass ``party_id`` to claim the
 * pool as an alias of an existing party, or ``name``/``party_type``/
 * ``description`` (all defaulted from the pool) to create one.
 */
export const startDevApplicationMgtResolvePoolAsPartyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtResolvePoolAsPartyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtResolvePoolAsPartyStartPostResponses,
    StartDevApplicationMgtResolvePoolAsPartyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtResolvePoolAsPartyStartPostResponses,
        StartDevApplicationMgtResolvePoolAsPartyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/resolve_pool_as_party/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Record that the pool references the given internal entity
 * (``entity_kind``: organisation | domain | product | process).
 */
export const startDevApplicationMgtResolvePoolAsReferenceStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtResolvePoolAsReferenceStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtResolvePoolAsReferenceStartPostResponses,
    StartDevApplicationMgtResolvePoolAsReferenceStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtResolvePoolAsReferenceStartPostResponses,
        StartDevApplicationMgtResolvePoolAsReferenceStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/resolve_pool_as_reference/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Set ``app_scope`` on the pool's active application decision record.
 */
export const startDevApplicationMgtSetPoolAppScopeStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtSetPoolAppScopeStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtSetPoolAppScopeStartPostResponses,
    StartDevApplicationMgtSetPoolAppScopeStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtSetPoolAppScopeStartPostResponses,
        StartDevApplicationMgtSetPoolAppScopeStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/set_pool_app_scope/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Unlink a ProcessTask from an Application.
 */
export const startDevApplicationMgtUnlinkProcessTaskFromApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostResponses,
    StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostResponses,
        StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/unlink_process_task_from_application/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Retract the pool's active decision; returns the retracted record.
 */
export const startDevApplicationMgtUnresolvePoolStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtUnresolvePoolStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtUnresolvePoolStartPostResponses,
    StartDevApplicationMgtUnresolvePoolStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtUnresolvePoolStartPostResponses,
        StartDevApplicationMgtUnresolvePoolStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/unresolve_pool/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update an Application's name, variant, responsible role, and/or description.
 *
 * `responsible_role_id`: omit to leave unchanged; pass null to clear the role.
 */
export const startDevApplicationMgtUpdateApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtUpdateApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtUpdateApplicationStartPostResponses,
    StartDevApplicationMgtUpdateApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtUpdateApplicationStartPostResponses,
        StartDevApplicationMgtUpdateApplicationStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/update_application/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update fields of a dependency edge in place (callable from either endpoint).
 *
 * Omitted fields stay unchanged; ``clear_technology`` clears the technology
 * explicitly.
 */
export const startDevApplicationMgtUpdateApplicationDependencyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevApplicationMgtUpdateApplicationDependencyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevApplicationMgtUpdateApplicationDependencyStartPostResponses,
    StartDevApplicationMgtUpdateApplicationDependencyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevApplicationMgtUpdateApplicationDependencyStartPostResponses,
        StartDevApplicationMgtUpdateApplicationDependencyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/application_mgt/update_application_dependency/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a build ticket covering ``change_keys`` (drift keys from
 * ``get_drift``). The ticket is numbered ``max + 1`` per stek and opens in
 * status ``open``; nothing is frozen until it is marked built.
 */
export const startDevBuildMgtCreateBuildTicketStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevBuildMgtCreateBuildTicketStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevBuildMgtCreateBuildTicketStartPostResponses,
    StartDevBuildMgtCreateBuildTicketStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevBuildMgtCreateBuildTicketStartPostResponses,
        StartDevBuildMgtCreateBuildTicketStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/create_build_ticket/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Tombstone the ticket. Its number is never reused and its changes fall
 * straight back to "loose", where the next ``get_drift`` re-suggests them.
 */
export const startDevBuildMgtDeleteBuildTicketStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevBuildMgtDeleteBuildTicketStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevBuildMgtDeleteBuildTicketStartPostResponses,
    StartDevBuildMgtDeleteBuildTicketStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevBuildMgtDeleteBuildTicketStartPostResponses,
        StartDevBuildMgtDeleteBuildTicketStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/delete_build_ticket/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Say what actually changed about one drift row.
 *
 * ``key`` is the drift key exactly as ``get_drift`` reports it on each change
 * (``<domain_id>/<relpath>``). Three sections come back, one per facet: the
 * entity's own ``_meta.json`` fields with human labels, a process's diagram
 * change stated as elements added / removed / updated, and its description and
 * document artefacts — text-diffed where there is text, reported as a replaced
 * file with sizes where git holds only an LFS pointer. The "before" side is
 * the entity as it was last marked built.
 */
export const startDevBuildMgtGetChangeDetailStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDevBuildMgtGetChangeDetailStartPostData, ThrowOnError>
): RequestResult<
    StartDevBuildMgtGetChangeDetailStartPostResponses,
    StartDevBuildMgtGetChangeDetailStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevBuildMgtGetChangeDetailStartPostResponses,
        StartDevBuildMgtGetChangeDetailStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/get_change_detail/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Derive what the plan says that the systems do not do yet: every entity
 * added, changed or removed since it was last marked built, the build
 * tickets those changes are grouped into, the suggested tickets for what is
 * still loose, and the headline counts.
 *
 * ``ledger.seeded_at`` is null until somebody has marked everything built;
 * until then the whole design counts as waiting.
 */
export const startDevBuildMgtGetDriftStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartDevBuildMgtGetDriftStartPostData, ThrowOnError>
): RequestResult<
    StartDevBuildMgtGetDriftStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevBuildMgtGetDriftStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/get_drift/start",
        ...options,
    });

/**
 * Start
 *
 * Record every live entity's current content as its built watermark. The
 * design is unchanged; only the ledger moves. Existing tickets stay as they
 * are — an open ticket whose changes now match the ledger simply stops
 * drifting. Idempotent.
 */
export const startDevBuildMgtMarkAllBuiltStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartDevBuildMgtMarkAllBuiltStartPostData, ThrowOnError>
): RequestResult<
    StartDevBuildMgtMarkAllBuiltStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevBuildMgtMarkAllBuiltStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/mark_all_built/start",
        ...options,
    });

/**
 * Start
 *
 * Freeze (``built=true``) or clear (``built=false``) the fingerprints of
 * every change the ticket covers. A frozen entity that is designed again
 * comes back on its own as ``changed_since_built``.
 */
export const startDevBuildMgtSetBuildTicketBuiltStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevBuildMgtSetBuildTicketBuiltStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevBuildMgtSetBuildTicketBuiltStartPostResponses,
    StartDevBuildMgtSetBuildTicketBuiltStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevBuildMgtSetBuildTicketBuiltStartPostResponses,
        StartDevBuildMgtSetBuildTicketBuiltStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/set_build_ticket_built/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update the ticket's title, its change set, or both. Keys that stay keep
 * their frozen ``built_fingerprint``, so regrouping a built ticket does not
 * silently un-build what was already built.
 */
export const startDevBuildMgtUpdateBuildTicketStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevBuildMgtUpdateBuildTicketStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevBuildMgtUpdateBuildTicketStartPostResponses,
    StartDevBuildMgtUpdateBuildTicketStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevBuildMgtUpdateBuildTicketStartPostResponses,
        StartDevBuildMgtUpdateBuildTicketStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/build_mgt/update_build_ticket/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new ExternalParty.
 */
export const startDevExternalPartyMgtCreateExternalPartyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevExternalPartyMgtCreateExternalPartyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevExternalPartyMgtCreateExternalPartyStartPostResponses,
    StartDevExternalPartyMgtCreateExternalPartyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevExternalPartyMgtCreateExternalPartyStartPostResponses,
        StartDevExternalPartyMgtCreateExternalPartyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/external_party_mgt/create_external_party/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete an ExternalParty.
 */
export const startDevExternalPartyMgtDeleteExternalPartyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevExternalPartyMgtDeleteExternalPartyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevExternalPartyMgtDeleteExternalPartyStartPostResponses,
    StartDevExternalPartyMgtDeleteExternalPartyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevExternalPartyMgtDeleteExternalPartyStartPostResponses,
        StartDevExternalPartyMgtDeleteExternalPartyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/external_party_mgt/delete_external_party/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all ExternalParties for a Stek.
 */
export const startDevExternalPartyMgtGetExternalPartiesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevExternalPartyMgtGetExternalPartiesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevExternalPartyMgtGetExternalPartiesStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevExternalPartyMgtGetExternalPartiesStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/external_party_mgt/get_external_parties/start",
        ...options,
    });

/**
 * Start
 *
 * Update an ExternalParty.
 *
 * Omitted fields stay unchanged; ``aliases`` replaces the whole list when
 * provided; ``clear_description`` clears the description explicitly (a null
 * ``description`` alone means "leave unchanged").
 */
export const startDevExternalPartyMgtUpdateExternalPartyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevExternalPartyMgtUpdateExternalPartyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevExternalPartyMgtUpdateExternalPartyStartPostResponses,
    StartDevExternalPartyMgtUpdateExternalPartyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevExternalPartyMgtUpdateExternalPartyStartPostResponses,
        StartDevExternalPartyMgtUpdateExternalPartyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/external_party_mgt/update_external_party/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Add the previewed pool and its message flows, then resolve the pool as
 * an external party (linked via ``party_id``, or created from ``name`` /
 * ``party_type`` / ``description``); returns the decision record.
 */
export const startDevTriageMgtAddExternalPoolStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtAddExternalPoolStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtAddExternalPoolStartPostResponses,
    StartDevTriageMgtAddExternalPoolStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtAddExternalPoolStartPostResponses,
        StartDevTriageMgtAddExternalPoolStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/add_external_pool/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Convert the given lanes into black-box pools; returns the rewritten
 * processes.
 */
export const startDevTriageMgtConvertLaneToPoolStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtConvertLaneToPoolStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtConvertLaneToPoolStartPostResponses,
    StartDevTriageMgtConvertLaneToPoolStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtConvertLaneToPoolStartPostResponses,
        StartDevTriageMgtConvertLaneToPoolStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/convert_lane_to_pool/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Convert the pool into a lane of the org's own pool across every
 * definition holding it; returns the rewritten processes.
 */
export const startDevTriageMgtConvertPoolToLaneStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtConvertPoolToLaneStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtConvertPoolToLaneStartPostResponses,
    StartDevTriageMgtConvertPoolToLaneStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtConvertPoolToLaneStartPostResponses,
        StartDevTriageMgtConvertPoolToLaneStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/convert_pool_to_lane/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Dismiss the issue (``issue_key`` = ``<issue_type>:<subject>``),
 * pinning the evidence ``fingerprint`` the dismissal was taken on.
 */
export const startDevTriageMgtDismissTriageIssueStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtDismissTriageIssueStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtDismissTriageIssueStartPostResponses,
    StartDevTriageMgtDismissTriageIssueStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtDismissTriageIssueStartPostResponses,
        StartDevTriageMgtDismissTriageIssueStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/dismiss_triage_issue/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * The process's runtime triage issues (never-taken, roll-out-gap), with
 * dismissals applied. Empty when no runtime rule is enabled for the org.
 */
export const startDevTriageMgtGetProcessTriageIssuesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtGetProcessTriageIssuesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtGetProcessTriageIssuesStartPostResponses,
    StartDevTriageMgtGetProcessTriageIssuesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtGetProcessTriageIssuesStartPostResponses,
        StartDevTriageMgtGetProcessTriageIssuesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/get_process_triage_issues/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Derive the stek's triage issues: per-diagram BPMN lint (standard
 * misalignments, hygiene) plus cross-diagram consistency (lane-alias
 * clusters, system lanes bound through stand-in roles). Issues are derived
 * evidence — resolving one means fixing the diagram (or dismissing the
 * issue), after which it disappears on its own.
 */
export const startDevTriageMgtGetTriageIssuesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDevTriageMgtGetTriageIssuesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtGetTriageIssuesStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDevTriageMgtGetTriageIssuesStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/get_triage_issues/start",
        ...options,
    });

/**
 * Start
 *
 * Stamp the application link on the given lanes (addressed as
 * process id + lane bpmn id, resolved through the stek's own processes);
 * returns the processes whose definitions were rewritten.
 */
export const startDevTriageMgtLinkLanesToApplicationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtLinkLanesToApplicationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtLinkLanesToApplicationStartPostResponses,
    StartDevTriageMgtLinkLanesToApplicationStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtLinkLanesToApplicationStartPostResponses,
        StartDevTriageMgtLinkLanesToApplicationStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/link_lanes_to_application/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Derive the restructure proposal (per-process after-XML, change
 * summary, removed elements) for a stacked-resolution issue.
 */
export const startDevTriageMgtProposeRestructureStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtProposeRestructureStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtProposeRestructureStartPostResponses,
    StartDevTriageMgtProposeRestructureStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtProposeRestructureStartPostResponses,
        StartDevTriageMgtProposeRestructureStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/propose_restructure/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Retract the issue key's active dismissal so it queues again.
 */
export const startDevTriageMgtReopenTriageIssueStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtReopenTriageIssueStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtReopenTriageIssueStartPostResponses,
    StartDevTriageMgtReopenTriageIssueStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtReopenTriageIssueStartPostResponses,
        StartDevTriageMgtReopenTriageIssueStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/reopen_triage_issue/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Resolve the named recipient as ``application`` (``application_id``),
 * ``internal_function`` (``role_id`` or a created role) or
 * ``internal_reference`` (``entity_kind`` + ``entity_id``).
 */
export const startDevTriageMgtResolveNamedRecipientStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDevTriageMgtResolveNamedRecipientStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDevTriageMgtResolveNamedRecipientStartPostResponses,
    StartDevTriageMgtResolveNamedRecipientStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtResolveNamedRecipientStartPostResponses,
        StartDevTriageMgtResolveNamedRecipientStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/resolve_named_recipient/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Rename every lane spelled as one of ``merge_names`` to
 * ``survivor_name`` across the stek's definitions; with ``role_id``, link
 * all lanes of the unified spelling to that role. Returns the processes
 * whose definitions were rewritten.
 */
export const startDevTriageMgtUnifyLanesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDevTriageMgtUnifyLanesStartPostData, ThrowOnError>
): RequestResult<
    StartDevTriageMgtUnifyLanesStartPostResponses,
    StartDevTriageMgtUnifyLanesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDevTriageMgtUnifyLanesStartPostResponses,
        StartDevTriageMgtUnifyLanesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/dev/triage_mgt/unify_lanes/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Convert a business entity into a domain term.
 */
export const startDomainBusinessEntityMgtConvertToDomainTermStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtConvertToDomainTermStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponses,
    StartDomainBusinessEntityMgtConvertToDomainTermStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponses,
        StartDomainBusinessEntityMgtConvertToDomainTermStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/convert_to_domain_term/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new business entity.
 *
 * This endpoint supports multipart/form-data for file uploads (description, definition)
 * and JSON data for relationships. The relationships parameter should be a JSON.stringify()
 * of an array of relationship objects.
 *
 * The relationships JSON structure should match the BusinessEntityRelationshipsFormData schema.
 */
export const startDomainBusinessEntityMgtCreateBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses,
        StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/create_business_entity/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new business rule for a business entity.
 */
export const startDomainBusinessEntityMgtCreateBusinessRuleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtCreateBusinessRuleStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtCreateBusinessRuleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponses,
        StartDomainBusinessEntityMgtCreateBusinessRuleStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/create_business_rule/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a business entity.
 */
export const startDomainBusinessEntityMgtDeleteBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses,
        StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/delete_business_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a business rule.
 */
export const startDomainBusinessEntityMgtDeleteBusinessRuleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostResponses,
        StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/delete_business_rule/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get a list of business entities belonging to a domain
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/get_business_entities/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all BusinessEntities referenced by tasks in the given Process.
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponses,
            StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/domain/business_entity_mgt/get_business_entities_by_process/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get all BusinessEntities referenced by tasks across the given Product's processes.
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponses,
            StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/domain/business_entity_mgt/get_business_entities_by_product/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get the BusinessEntities of every Domain in the Stek, keyed by domain id.
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponses,
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/domain/business_entity_mgt/get_business_entities_grouped_by_domain/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get, per Process in the Product, the referenced BusinessEntities, keyed by process id.
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponses,
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/domain/business_entity_mgt/get_business_entities_grouped_by_process/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get, per Product in the Domain, the referenced BusinessEntities, keyed by product id.
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponses,
            StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/domain/business_entity_mgt/get_business_entities_grouped_by_product/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get a business entity.
 */
export const startDomainBusinessEntityMgtGetBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtGetBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/get_business_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get a business rule by its identity.
 */
export const startDomainBusinessEntityMgtGetBusinessRuleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtGetBusinessRuleStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtGetBusinessRuleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponses,
        StartDomainBusinessEntityMgtGetBusinessRuleStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/get_business_rule/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * List every cross-domain linked concept in a stek (each listed once).
 */
export const startDomainBusinessEntityMgtGetCrossDomainLinksStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponses,
    StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponses,
        StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/get_cross_domain_links/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * List business entities in other domains (valid cross-domain link targets).
 */
export const startDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponses,
        StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponses,
            StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/domain/business_entity_mgt/get_linkable_business_entities/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * List all business rules for a business entity (metadata only — no content).
 */
export const startDomainBusinessEntityMgtListBusinessRulesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtListBusinessRulesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtListBusinessRulesStartPostResponses,
    StartDomainBusinessEntityMgtListBusinessRulesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtListBusinessRulesStartPostResponses,
        StartDomainBusinessEntityMgtListBusinessRulesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/list_business_rules/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Remove the linked concept between two business entities (from either side).
 */
export const startDomainBusinessEntityMgtRemoveLinkedConceptStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponses,
    StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponses,
        StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/remove_linked_concept/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a business entity details and/or definition.
 *
 * This endpoint supports multipart/form-data for file uploads (description, definition)
 * and JSON data for relationships. The relationships parameter should be a JSON.stringify()
 * of an array of relationship objects.
 *
 * The relationships JSON structure should match the BusinessEntityRelationshipsFormData schema.
 */
export const startDomainBusinessEntityMgtUpdateBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses,
    StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses,
        StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/update_business_entity/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update the title and/or content of a business rule.
 */
export const startDomainBusinessEntityMgtUpdateBusinessRuleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponses,
    StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponses,
        StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/update_business_rule/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Replace a business entity's outgoing linked concepts (cross-domain only, atomic).
 */
export const startDomainBusinessEntityMgtUpdateLinkedConceptsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponses,
    StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponses,
        StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/business_entity_mgt/update_linked_concepts/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new Domain
 */
export const startDomainDomainMgtCreateDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainMgtCreateDomainStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainMgtCreateDomainStartPostResponses,
    StartDomainDomainMgtCreateDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainMgtCreateDomainStartPostResponses,
        StartDomainDomainMgtCreateDomainStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_mgt/create_domain/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a Domain
 */
export const startDomainDomainMgtDeleteDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainMgtDeleteDomainStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainMgtDeleteDomainStartPostResponses,
    StartDomainDomainMgtDeleteDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainMgtDeleteDomainStartPostResponses,
        StartDomainDomainMgtDeleteDomainStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_mgt/delete_domain/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Domain
 */
export const startDomainDomainMgtGetDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDomainDomainMgtGetDomainStartPostData, ThrowOnError>
): RequestResult<
    StartDomainDomainMgtGetDomainStartPostResponses,
    StartDomainDomainMgtGetDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainMgtGetDomainStartPostResponses,
        StartDomainDomainMgtGetDomainStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_mgt/get_domain/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Domains by Stek
 */
export const startDomainDomainMgtGetDomainsByStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartDomainDomainMgtGetDomainsByStekStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainMgtGetDomainsByStekStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartDomainDomainMgtGetDomainsByStekStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_mgt/get_domains_by_stek/start",
        ...options,
    });

/**
 * Start
 *
 * Update a domain.
 */
export const startDomainDomainMgtUpdateDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainMgtUpdateDomainStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainMgtUpdateDomainStartPostResponses,
    StartDomainDomainMgtUpdateDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainMgtUpdateDomainStartPostResponses,
        StartDomainDomainMgtUpdateDomainStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_mgt/update_domain/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update domain orders.
 */
export const startDomainDomainMgtUpdateDomainOrdersStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainMgtUpdateDomainOrdersStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainMgtUpdateDomainOrdersStartPostResponses,
    StartDomainDomainMgtUpdateDomainOrdersStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainMgtUpdateDomainOrdersStartPostResponses,
        StartDomainDomainMgtUpdateDomainOrdersStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_mgt/update_domain_orders/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Convert a domain term into a business entity.
 */
export const startDomainDomainTermMgtConvertToBusinessEntityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainTermMgtConvertToBusinessEntityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponses,
    StartDomainDomainTermMgtConvertToBusinessEntityStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponses,
        StartDomainDomainTermMgtConvertToBusinessEntityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_term_mgt/convert_to_business_entity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new domain term.
 */
export const startDomainDomainTermMgtCreateDomainTermStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainTermMgtCreateDomainTermStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainTermMgtCreateDomainTermStartPostResponses,
    StartDomainDomainTermMgtCreateDomainTermStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainTermMgtCreateDomainTermStartPostResponses,
        StartDomainDomainTermMgtCreateDomainTermStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_term_mgt/create_domain_term/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a domain term.
 */
export const startDomainDomainTermMgtDeleteDomainTermStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainTermMgtDeleteDomainTermStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainTermMgtDeleteDomainTermStartPostResponses,
    StartDomainDomainTermMgtDeleteDomainTermStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainTermMgtDeleteDomainTermStartPostResponses,
        StartDomainDomainTermMgtDeleteDomainTermStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_term_mgt/delete_domain_term/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get a domain term.
 */
export const startDomainDomainTermMgtGetDomainTermStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainTermMgtGetDomainTermStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainTermMgtGetDomainTermStartPostResponses,
    StartDomainDomainTermMgtGetDomainTermStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainTermMgtGetDomainTermStartPostResponses,
        StartDomainDomainTermMgtGetDomainTermStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_term_mgt/get_domain_term/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all domain terms in a domain.
 */
export const startDomainDomainTermMgtGetDomainTermsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainTermMgtGetDomainTermsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainTermMgtGetDomainTermsStartPostResponses,
    StartDomainDomainTermMgtGetDomainTermsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainTermMgtGetDomainTermsStartPostResponses,
        StartDomainDomainTermMgtGetDomainTermsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_term_mgt/get_domain_terms/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a domain term.
 */
export const startDomainDomainTermMgtUpdateDomainTermStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartDomainDomainTermMgtUpdateDomainTermStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartDomainDomainTermMgtUpdateDomainTermStartPostResponses,
    StartDomainDomainTermMgtUpdateDomainTermStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainDomainTermMgtUpdateDomainTermStartPostResponses,
        StartDomainDomainTermMgtUpdateDomainTermStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/domain_term_mgt/update_domain_term/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create Role in Domain
 */
export const startDomainRoleMgtCreateRoleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDomainRoleMgtCreateRoleStartPostData, ThrowOnError>
): RequestResult<
    StartDomainRoleMgtCreateRoleStartPostResponses,
    StartDomainRoleMgtCreateRoleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainRoleMgtCreateRoleStartPostResponses,
        StartDomainRoleMgtCreateRoleStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/role_mgt/create_role/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete Role
 */
export const startDomainRoleMgtDeleteRoleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDomainRoleMgtDeleteRoleStartPostData, ThrowOnError>
): RequestResult<
    StartDomainRoleMgtDeleteRoleStartPostResponses,
    StartDomainRoleMgtDeleteRoleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainRoleMgtDeleteRoleStartPostResponses,
        StartDomainRoleMgtDeleteRoleStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/role_mgt/delete_role/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Role
 */
export const startDomainRoleMgtGetRoleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDomainRoleMgtGetRoleStartPostData, ThrowOnError>
): RequestResult<
    StartDomainRoleMgtGetRoleStartPostResponses,
    StartDomainRoleMgtGetRoleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainRoleMgtGetRoleStartPostResponses,
        StartDomainRoleMgtGetRoleStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/role_mgt/get_role/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all Role(s) for provided Domain
 */
export const startDomainRoleMgtGetRolesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDomainRoleMgtGetRolesStartPostData, ThrowOnError>
): RequestResult<
    StartDomainRoleMgtGetRolesStartPostResponses,
    StartDomainRoleMgtGetRolesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainRoleMgtGetRolesStartPostResponses,
        StartDomainRoleMgtGetRolesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/role_mgt/get_roles/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a Role.
 */
export const startDomainRoleMgtUpdateRoleStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartDomainRoleMgtUpdateRoleStartPostData, ThrowOnError>
): RequestResult<
    StartDomainRoleMgtUpdateRoleStartPostResponses,
    StartDomainRoleMgtUpdateRoleStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartDomainRoleMgtUpdateRoleStartPostResponses,
        StartDomainRoleMgtUpdateRoleStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/domain/role_mgt/update_role/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Healthcheck
 */
export const healthcheckHealthcheckGet = <ThrowOnError extends boolean = false>(
    options?: Options<HealthcheckHealthcheckGetData, ThrowOnError>
): RequestResult<HealthcheckHealthcheckGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        HealthcheckHealthcheckGetResponses,
        unknown,
        ThrowOnError
    >({ url: "/healthcheck", ...options });

/**
 * Start
 *
 * Derive this person's landing page for this stek.
 *
 * Everything on it is grouped from triage findings the stek already has:
 * hygiene dropped, the rest grouped by rule type into at most three plain
 * statements, each carrying what it covers and what kind of fix it has.
 * Nothing here detects anything new, and nothing here changes anything —
 * acting on a suggestion runs through the ask box and then a thread.
 */
export const startHomeHomeMgtGetPersonalHomeStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartHomeHomeMgtGetPersonalHomeStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartHomeHomeMgtGetPersonalHomeStartPostResponses,
    StartHomeHomeMgtGetPersonalHomeStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartHomeHomeMgtGetPersonalHomeStartPostResponses,
        StartHomeHomeMgtGetPersonalHomeStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/home/home_mgt/get_personal_home/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Enter Preview
 *
 * Mint a gate entry URL for the authenticated org member.
 */
export const enterPreviewIntegrationsDevPreviewEnterHostGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        EnterPreviewIntegrationsDevPreviewEnterHostGetData,
        ThrowOnError
    >
): RequestResult<
    EnterPreviewIntegrationsDevPreviewEnterHostGetResponses,
    EnterPreviewIntegrationsDevPreviewEnterHostGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        EnterPreviewIntegrationsDevPreviewEnterHostGetResponses,
        EnterPreviewIntegrationsDevPreviewEnterHostGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/integrations/dev-preview/enter/{host}",
        ...options,
    });

/**
 * Preview Jwks
 *
 * The JWKS the preview-gate verifies entry tokens against.
 */
export const previewJwksIntegrationsDevPreviewJwksJsonGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        PreviewJwksIntegrationsDevPreviewJwksJsonGetData,
        ThrowOnError
    >
): RequestResult<
    PreviewJwksIntegrationsDevPreviewJwksJsonGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        PreviewJwksIntegrationsDevPreviewJwksJsonGetResponses,
        unknown,
        ThrowOnError
    >({ url: "/integrations/dev-preview/jwks.json", ...options });

/**
 * Register Session
 *
 * Arm (or re-arm) a preview session for a worker dev stack.
 */
export const registerSessionIntegrationsDevPreviewSessionsPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        RegisterSessionIntegrationsDevPreviewSessionsPostData,
        ThrowOnError
    >
): RequestResult<
    RegisterSessionIntegrationsDevPreviewSessionsPostResponses,
    RegisterSessionIntegrationsDevPreviewSessionsPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        RegisterSessionIntegrationsDevPreviewSessionsPostResponses,
        RegisterSessionIntegrationsDevPreviewSessionsPostErrors,
        ThrowOnError
    >({
        url: "/integrations/dev-preview/sessions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Session Status
 *
 * Liveness check for the preview-gate (cached caller-side).
 *
 * Authenticated by the gate's dedicated read-only status token — and only
 * that token. The public-facing gate host never holds session-management
 * (register/heartbeat/revoke) authority, and a relay token deliberately
 * does not work here either: each credential is bound to exactly its role.
 *
 * A session of an organization that no longer holds a live relay token
 * reads inactive: revoking the token ends the gate's serving of it too.
 */
export const sessionStatusIntegrationsDevPreviewSessionsHostGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        SessionStatusIntegrationsDevPreviewSessionsHostGetData,
        ThrowOnError
    >
): RequestResult<
    SessionStatusIntegrationsDevPreviewSessionsHostGetResponses,
    SessionStatusIntegrationsDevPreviewSessionsHostGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        SessionStatusIntegrationsDevPreviewSessionsHostGetResponses,
        SessionStatusIntegrationsDevPreviewSessionsHostGetErrors,
        ThrowOnError
    >({ url: "/integrations/dev-preview/sessions/{host}", ...options });

/**
 * Session Heartbeat
 *
 * Reconcile + activity report from the preview relay, one round trip.
 *
 * Slide-on-use: an actively-visited session never dies mid-use. When the
 * reported activity is fresh and the session is inside its extension
 * window, expiry slides to now + slide_seconds — deliberately allowed
 * past the registration clamp. Activity only exists behind the gate
 * (org-member SSO), so a session that keeps sliding is by definition a
 * session org members keep using; one they abandon dies of disuse within
 * slide_seconds. Revocation remains the kill switch.
 */
export const sessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostData,
        ThrowOnError
    >
): RequestResult<
    SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponses,
    SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponses,
        SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostErrors,
        ThrowOnError
    >({
        url: "/integrations/dev-preview/sessions/{host}/heartbeat",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Revoke Session
 *
 * Kill switch; idempotent.
 */
export const revokeSessionIntegrationsDevPreviewSessionsHostRevokePost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostData,
        ThrowOnError
    >
): RequestResult<
    RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponses,
    RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponses,
        RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostErrors,
        ThrowOnError
    >({ url: "/integrations/dev-preview/sessions/{host}/revoke", ...options });

/**
 * Mcp Streamable Http Handler
 *
 * Handle MCP Streamable HTTP requests.
 *
 * Supports:
 * - POST: Send JSON-RPC messages (with SSE response for streaming)
 * - GET: Establish standalone SSE stream for server-to-client messages
 * - DELETE: Terminate session
 *
 * All requests require OAuth2 authentication via Bearer token.
 */
export const mcpStreamableHttpDelete = <ThrowOnError extends boolean = false>(
    options?: Options<McpStreamableHttpDeleteData, ThrowOnError>
): RequestResult<McpStreamableHttpDeleteResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).delete<
        McpStreamableHttpDeleteResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "HTTPBearer",
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/integrations/mcp",
        ...options,
    });

/**
 * Mcp Streamable Http Handler
 *
 * Handle MCP Streamable HTTP requests.
 *
 * Supports:
 * - POST: Send JSON-RPC messages (with SSE response for streaming)
 * - GET: Establish standalone SSE stream for server-to-client messages
 * - DELETE: Terminate session
 *
 * All requests require OAuth2 authentication via Bearer token.
 */
export const mcpStreamableHttpGet = <ThrowOnError extends boolean = false>(
    options?: Options<McpStreamableHttpGetData, ThrowOnError>
): RequestResult<McpStreamableHttpGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        McpStreamableHttpGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "HTTPBearer",
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/integrations/mcp",
        ...options,
    });

/**
 * Mcp Streamable Http Handler
 *
 * Handle MCP Streamable HTTP requests.
 *
 * Supports:
 * - POST: Send JSON-RPC messages (with SSE response for streaming)
 * - GET: Establish standalone SSE stream for server-to-client messages
 * - DELETE: Terminate session
 *
 * All requests require OAuth2 authentication via Bearer token.
 */
export const mcpStreamableHttpPost = <ThrowOnError extends boolean = false>(
    options?: Options<McpStreamableHttpPostData, ThrowOnError>
): RequestResult<McpStreamableHttpPostResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).post<
        McpStreamableHttpPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "HTTPBearer",
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/integrations/mcp",
        ...options,
    });

/**
 * Whoami
 *
 * Who this credential is and what it may do.
 */
export const mcpWhoami = <ThrowOnError extends boolean = false>(
    options?: Options<McpWhoamiData, ThrowOnError>
): RequestResult<McpWhoamiResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<McpWhoamiResponses, unknown, ThrowOnError>({
        security: [
            {
                key: "HTTPBearer",
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/integrations/mcp/whoami",
        ...options,
    });

/**
 * Disconnect
 *
 * Disconnect: withdraw the grant at the provider, then forget the token.
 */
export const disconnectIntegrationsOauth2ClientConnectionIntegrationTypeDelete =
    <ThrowOnError extends boolean = false>(
        options: Options<
            DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteData,
            ThrowOnError
        >
    ): RequestResult<
        DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteResponses,
        DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteErrors,
        ThrowOnError
    > =>
        (options.client ?? client).delete<
            DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteResponses,
            DisconnectIntegrationsOauth2ClientConnectionIntegrationTypeDeleteErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/integrations/oauth2/client/connection/{integration_type}",
            ...options,
        });

/**
 * Connection Status
 *
 * Whether you (or, for stek-wide providers, the stek) are connected.
 */
export const connectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGet =
    <ThrowOnError extends boolean = false>(
        options: Options<
            ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetData,
            ThrowOnError
        >
    ): RequestResult<
        ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetResponses,
        ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetErrors,
        ThrowOnError
    > =>
        (options.client ?? client).get<
            ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetResponses,
            ConnectionStatusIntegrationsOauth2ClientConnectionIntegrationTypeGetErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/integrations/oauth2/client/connection/{integration_type}",
            ...options,
        });

/**
 * List Folders
 *
 * The top of your Drive, or the folders inside `parent`. Your limits do not apply.
 */
export const listFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGet =
    <ThrowOnError extends boolean = false>(
        options: Options<
            ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetData,
            ThrowOnError
        >
    ): RequestResult<
        ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetResponses,
        ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetErrors,
        ThrowOnError
    > =>
        (options.client ?? client).get<
            ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetResponses,
            ListFoldersIntegrationsOauth2ClientConnectionIntegrationTypeFoldersGetErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/integrations/oauth2/client/connection/{integration_type}/folders",
            ...options,
        });

/**
 * Set Limits
 *
 * Replace the limits on what the agent may open.
 */
export const setLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPut =
    <ThrowOnError extends boolean = false>(
        options: Options<
            SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutData,
            ThrowOnError
        >
    ): RequestResult<
        SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutResponses,
        SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutErrors,
        ThrowOnError
    > =>
        (options.client ?? client).put<
            SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutResponses,
            SetLimitsIntegrationsOauth2ClientConnectionIntegrationTypeLimitsPutErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/integrations/oauth2/client/connection/{integration_type}/limits",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Prepare
 *
 * Begin OAuth2 authorization flow.
 *
 * This endpoint is called by the frontend to start the authorization flow.
 * It uses Authlib to generate the authorization URL and redirect the user.
 *
 * Args:
 * integration_type: Type of integration (e.g., "clickup")
 * redirect_uri: The URI to redirect to after authorization (optional)
 *
 * Returns:
 * PrepareResponse with the authorization URL
 *
 * Raises:
 * HTTPException: If organization not found or integration type not supported
 */
export const prepareIntegrationsOauth2ClientPrepareIntegrationTypeGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetData,
        ThrowOnError
    >
): RequestResult<
    PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses,
    PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses,
        PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/integrations/oauth2/client/prepare/{integration_type}",
        ...options,
    });

/**
 * Exchange Token
 *
 * Exchange authorization code for an access token.
 *
 * Endpoint used by the frontend to exchange the authorization code for a token.
 *
 * Args:
 * token_request: Contains code, state, integration_type, and redirect_uri from the frontend
 *
 * Returns:
 * JSONResponse with success message
 *
 * Raises:
 * HTTPException: If organization not found, token exchange fails, etc.
 */
export const exchangeTokenIntegrationsOauth2ClientTokenPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        ExchangeTokenIntegrationsOauth2ClientTokenPostData,
        ThrowOnError
    >
): RequestResult<
    ExchangeTokenIntegrationsOauth2ClientTokenPostResponses,
    ExchangeTokenIntegrationsOauth2ClientTokenPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        ExchangeTokenIntegrationsOauth2ClientTokenPostResponses,
        ExchangeTokenIntegrationsOauth2ClientTokenPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/integrations/oauth2/client/token",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Authorize Request
 *
 * OAuth2 authorization endpoint.
 *
 * Validates the authorization request, then writes a short-lived server-side
 * consent snapshot to Valkey. The frontend receives only a consent_request_id
 * so it never handles raw OAuth parameters directly.
 */
export const authorizeRequestIntegrationsOauth2ServerAuthorizeGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetData,
        ThrowOnError
    >
): RequestResult<
    AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses,
    AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses,
        AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors,
        ThrowOnError
    >({ url: "/integrations/oauth2/server/authorize", ...options });

/**
 * Generate Authorization Code
 *
 * Complete OAuth2 authorization after user consent.
 *
 * Loads the server-side consent snapshot identified by consent_request_id,
 * authenticates the user, computes approved scopes, and generates the
 * authorization code. All OAuth2 parameters come from the server-side snapshot
 * — none are accepted from form fields — so the frontend cannot tamper with
 * client_id, redirect_uri, scope, or PKCE values.
 */
export const generateAuthorizationCodeIntegrationsOauth2ServerAuthorizePost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostData,
        ThrowOnError
    >
): RequestResult<
    GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses,
    GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses,
        GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors,
        ThrowOnError
    >({
        ...urlSearchParamsBodySerializer,
        url: "/integrations/oauth2/server/authorize",
        ...options,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...options.headers,
        },
    });

/**
 * Get Consent Context
 *
 * Return safe display data for the OAuth consent UI.
 *
 * Loads the server-side consent snapshot and returns only fields safe for
 * display. The full snapshot (code_challenge, all_redirect_uris, PKCE data)
 * remains server-side and is never exposed to the browser.
 */
export const getConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGet =
    <ThrowOnError extends boolean = false>(
        options: Options<
            GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetData,
            ThrowOnError
        >
    ): RequestResult<
        GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponses,
        GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetErrors,
        ThrowOnError
    > =>
        (options.client ?? client).get<
            GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponses,
            GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetErrors,
            ThrowOnError
        >({
            url: "/integrations/oauth2/server/consent/{consent_request_id}",
            ...options,
        });

/**
 * Register Client
 *
 * OAuth2 dynamic client registration endpoint.
 *
 * Stores client registration data securely in Valkey with TTL.
 * The redirect_uris will be validated during authorization to prevent
 * authorization code interception attacks per OAuth2 security requirements.
 *
 * Security measures:
 * - Rate limiting: Maximum registrations per real client IP per window
 * - Client name validation: Length limit, character whitelist, no control chars
 * - Redirect URI validation:
 * - HTTP only allowed for localhost (when enabled in settings)
 * - HTTPS required for non-localhost
 * - Private IP addresses blocked (defense-in-depth)
 * - Cloud metadata endpoints blocked
 * - Control characters rejected
 * - Length limit enforced
 * - Pending registrations expire after 1 hour
 *
 * Error responses follow RFC 7591 format with 'error' and 'error_description'.
 */
export const registerClientIntegrationsOauth2ServerRegisterPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        RegisterClientIntegrationsOauth2ServerRegisterPostData,
        ThrowOnError
    >
): RequestResult<
    RegisterClientIntegrationsOauth2ServerRegisterPostResponses,
    RegisterClientIntegrationsOauth2ServerRegisterPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        RegisterClientIntegrationsOauth2ServerRegisterPostResponses,
        RegisterClientIntegrationsOauth2ServerRegisterPostErrors,
        ThrowOnError
    >({
        url: "/integrations/oauth2/server/register",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Revoke Token
 *
 * OAuth2 token revocation endpoint.
 *
 * Revokes access or refresh tokens to prevent further use.
 * For refresh tokens, revokes both current and previous tokens.
 * Returns 200 OK for successful revocation or invalid tokens per RFC 7009.
 * Returns 400 for malformed requests (e.g., missing required parameters).
 */
export const revokeTokenIntegrationsOauth2ServerRevokePost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        RevokeTokenIntegrationsOauth2ServerRevokePostData,
        ThrowOnError
    >
): RequestResult<
    RevokeTokenIntegrationsOauth2ServerRevokePostResponses,
    RevokeTokenIntegrationsOauth2ServerRevokePostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        RevokeTokenIntegrationsOauth2ServerRevokePostResponses,
        RevokeTokenIntegrationsOauth2ServerRevokePostErrors,
        ThrowOnError
    >({
        url: "/integrations/oauth2/server/revoke",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Token Endpoint
 *
 * OAuth2 token endpoint.
 *
 * Exchanges authorization codes for access tokens or refreshes tokens.
 * Supports both authorization_code and refresh_token grant types.
 */
export const tokenEndpointIntegrationsOauth2ServerTokenPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        TokenEndpointIntegrationsOauth2ServerTokenPostData,
        ThrowOnError
    >
): RequestResult<
    TokenEndpointIntegrationsOauth2ServerTokenPostResponses,
    TokenEndpointIntegrationsOauth2ServerTokenPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        TokenEndpointIntegrationsOauth2ServerTokenPostResponses,
        TokenEndpointIntegrationsOauth2ServerTokenPostErrors,
        ThrowOnError
    >({
        ...urlSearchParamsBodySerializer,
        url: "/integrations/oauth2/server/token",
        ...options,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...options.headers,
        },
    });

/**
 * Set Attention Probe Enabled
 *
 * Turn the attention probe on or off.
 *
 * The sub-switch under the master: off stops only what the browser reports
 * (dwell, element focus). Server-inferred visits continue — the settings copy
 * says so — and are governed by `personal_memory_enabled` instead.
 */
export const setAttentionProbeEnabledMeAttentionProbeEnabledPut = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        SetAttentionProbeEnabledMeAttentionProbeEnabledPutData,
        ThrowOnError
    >
): RequestResult<
    SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponses,
    SetAttentionProbeEnabledMeAttentionProbeEnabledPutErrors,
    ThrowOnError
> =>
    (options.client ?? client).put<
        SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponses,
        SetAttentionProbeEnabledMeAttentionProbeEnabledPutErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/attention-probe-enabled",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Record Attention Events
 *
 * The probe's only door. Fire-and-forget: every gate answers 204.
 *
 * Gates, in order: the org capability (`personal_agent` — an org that has not
 * opted in collects nothing); interactive principals only (a script replaying
 * dwell is not attention); the master switch (`personal_memory_enabled` off
 * means no collection at all); the probe switch (`attention_probe_enabled`
 * off means the browser-reported layer specifically is unwanted). A batch
 * dropped by a gate is not an error — the client may race a toggle, and the
 * probe must never surface a failure the user can see.
 */
export const recordAttentionEventsMeAttentionEventsPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        RecordAttentionEventsMeAttentionEventsPostData,
        ThrowOnError
    >
): RequestResult<
    RecordAttentionEventsMeAttentionEventsPostResponses,
    RecordAttentionEventsMeAttentionEventsPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        RecordAttentionEventsMeAttentionEventsPostResponses,
        RecordAttentionEventsMeAttentionEventsPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/attention/events",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * List Memory
 *
 * Everything remembered about you, across every organisation.
 */
export const listMemoryMeMemoryGet = <ThrowOnError extends boolean = false>(
    options?: Options<ListMemoryMeMemoryGetData, ThrowOnError>
): RequestResult<ListMemoryMeMemoryGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        ListMemoryMeMemoryGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/memory",
        ...options,
    });

/**
 * Delete Memory Entry
 *
 * Forget one thing. Scoped by owner, so an id you were not given does nothing.
 */
export const deleteMemoryEntryMeMemoryEntryIdDelete = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteMemoryEntryMeMemoryEntryIdDeleteData, ThrowOnError>
): RequestResult<
    DeleteMemoryEntryMeMemoryEntryIdDeleteResponses,
    DeleteMemoryEntryMeMemoryEntryIdDeleteErrors,
    ThrowOnError
> =>
    (options.client ?? client).delete<
        DeleteMemoryEntryMeMemoryEntryIdDeleteResponses,
        DeleteMemoryEntryMeMemoryEntryIdDeleteErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/memory/{entry_id}",
        ...options,
    });

/**
 * Wipe Context
 *
 * Erase your attention, chat spine, memory and asks.
 *
 * Returns a receipt saying what went and whether it finished — a wipe that
 * could not reach an ephemeral store reports that rather than claiming success.
 */
export const wipeContextMePersonalContextDelete = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<WipeContextMePersonalContextDeleteData, ThrowOnError>
): RequestResult<
    WipeContextMePersonalContextDeleteResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).delete<
        WipeContextMePersonalContextDeleteResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/personal-context",
        ...options,
    });

/**
 * Export Context
 *
 * Everything held about you, as portable JSON.
 */
export const exportContextMePersonalContextExportGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<ExportContextMePersonalContextExportGetData, ThrowOnError>
): RequestResult<
    ExportContextMePersonalContextExportGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        ExportContextMePersonalContextExportGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/personal-context/export",
        ...options,
    });

/**
 * Set Personal Memory Enabled
 *
 * Turn personal memory on or off.
 *
 * Off stops recall, the memory tools and the extractor. It does not erase what
 * is already there — that is what the wipe is for, and conflating the two would
 * make a reversible preference into an irreversible one.
 */
export const setPersonalMemoryEnabledMePersonalMemoryEnabledPut = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        SetPersonalMemoryEnabledMePersonalMemoryEnabledPutData,
        ThrowOnError
    >
): RequestResult<
    SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponses,
    SetPersonalMemoryEnabledMePersonalMemoryEnabledPutErrors,
    ThrowOnError
> =>
    (options.client ?? client).put<
        SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponses,
        SetPersonalMemoryEnabledMePersonalMemoryEnabledPutErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/personal-memory-enabled",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Personal Memory Settings
 *
 * The stored state of both off-switches.
 *
 * Exists so the settings page renders what is true rather than a client-side
 * default — for a privacy control, a guessed toggle position is a lie.
 */
export const getPersonalMemorySettingsMePersonalMemorySettingsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        GetPersonalMemorySettingsMePersonalMemorySettingsGetData,
        ThrowOnError
    >
): RequestResult<
    GetPersonalMemorySettingsMePersonalMemorySettingsGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetPersonalMemorySettingsMePersonalMemorySettingsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/me/personal-memory-settings",
        ...options,
    });

/**
 * Start
 *
 * Get activity metrics for the organizations the caller belongs to.
 *
 * Platform admins only (``User.is_platform_admin``) — this is platform-wide
 * operational insight, not an organization role. Called directly rather than
 * through ``service.query``: the platform-admin flag is not an org-scoped role.
 *
 * Args:
 * since_days: Lookback period (1-365 days)
 * include_user_details: Include per-user activity breakdown
 */
export const startOrganizationActivityMetricsGetOrganizationActivityStartGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartOrganizationActivityMetricsGetOrganizationActivityStartGetData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses,
    StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses,
        StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/activity_metrics/get_organization_activity/start",
        ...options,
    });

/**
 * Start
 *
 * Add an agent to the organization. Read-only (viewer) unless
 * `initial_cluster_roles` says otherwise; roles change later through the
 * same endpoint a member's do.
 */
export const startOrganizationAgentMgtCreateAgentStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtCreateAgentStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtCreateAgentStartPostResponses,
    StartOrganizationAgentMgtCreateAgentStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtCreateAgentStartPostResponses,
        StartOrganizationAgentMgtCreateAgentStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/create_agent/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Mint a token bound to this organization, one stek and the scopes the
 * server computes from the booleans. Write access is off by default and the
 * organization's policy can refuse it. A preview relay token
 * (``grant_dev_preview_access``) is for platform admins only. Copy the token
 * from this response; it is not shown again.
 */
export const startOrganizationAgentMgtCreateAgentTokenStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtCreateAgentTokenStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtCreateAgentTokenStartPostResponses,
    StartOrganizationAgentMgtCreateAgentTokenStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtCreateAgentTokenStartPostResponses,
        StartOrganizationAgentMgtCreateAgentTokenStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/create_agent_token/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startOrganizationAgentMgtDeleteAgentStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtDeleteAgentStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtDeleteAgentStartPostResponses,
    StartOrganizationAgentMgtDeleteAgentStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtDeleteAgentStartPostResponses,
        StartOrganizationAgentMgtDeleteAgentStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/delete_agent/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startOrganizationAgentMgtListAgentTokensStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtListAgentTokensStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtListAgentTokensStartPostResponses,
    StartOrganizationAgentMgtListAgentTokensStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtListAgentTokensStartPostResponses,
        StartOrganizationAgentMgtListAgentTokensStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/list_agent_tokens/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startOrganizationAgentMgtListAgentsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartOrganizationAgentMgtListAgentsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtListAgentsStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartOrganizationAgentMgtListAgentsStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/list_agents/start",
        ...options,
    });

/**
 * Start
 *
 * Every MCP client a person connected through OAuth consent — Claude
 * Code, claude.ai, Cursor, … — with the person it acts as, its stek, its
 * scopes and whether its tokens are still alive.
 */
export const startOrganizationAgentMgtListMcpConsumersStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartOrganizationAgentMgtListMcpConsumersStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtListMcpConsumersStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartOrganizationAgentMgtListMcpConsumersStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/list_mcp_consumers/start",
        ...options,
    });

/**
 * Start
 *
 * Re-grant with different scopes: the old token stops working and the new
 * raw token is in this response only.
 */
export const startOrganizationAgentMgtRegrantAgentTokenStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtRegrantAgentTokenStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtRegrantAgentTokenStartPostResponses,
    StartOrganizationAgentMgtRegrantAgentTokenStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtRegrantAgentTokenStartPostResponses,
        StartOrganizationAgentMgtRegrantAgentTokenStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/regrant_agent_token/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startOrganizationAgentMgtRevokeAgentTokenStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtRevokeAgentTokenStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtRevokeAgentTokenStartPostResponses,
    StartOrganizationAgentMgtRevokeAgentTokenStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtRevokeAgentTokenStartPostResponses,
        StartOrganizationAgentMgtRevokeAgentTokenStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/revoke_agent_token/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startOrganizationAgentMgtRevokeMcpConsumerStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtRevokeMcpConsumerStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtRevokeMcpConsumerStartPostResponses,
    StartOrganizationAgentMgtRevokeMcpConsumerStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtRevokeMcpConsumerStartPostResponses,
        StartOrganizationAgentMgtRevokeMcpConsumerStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/revoke_mcp_consumer/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startOrganizationAgentMgtUpdateAgentStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationAgentMgtUpdateAgentStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationAgentMgtUpdateAgentStartPostResponses,
    StartOrganizationAgentMgtUpdateAgentStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationAgentMgtUpdateAgentStartPostResponses,
        StartOrganizationAgentMgtUpdateAgentStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/agent_mgt/update_agent/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Domain
 */
export const startOrganizationOrganizationMgtGetOrganizationByNameStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses,
    StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses,
        StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/organization_mgt/get_organization_by_name/start",
        ...options,
    });

/**
 * Start
 *
 * Get a list of organizations that current logged-in user has access to.
 */
export const startOrganizationOrganizationMgtGetOrganizationsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartOrganizationOrganizationMgtGetOrganizationsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/organization/organization_mgt/get_organizations/start",
        ...options,
    });

/**
 * Start
 *
 * Get Lane
 */
export const startProcessLaneMgtGetLaneStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartProcessLaneMgtGetLaneStartPostData, ThrowOnError>
): RequestResult<
    StartProcessLaneMgtGetLaneStartPostResponses,
    StartProcessLaneMgtGetLaneStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessLaneMgtGetLaneStartPostResponses,
        StartProcessLaneMgtGetLaneStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/lane_mgt/get_lane/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Lane by BPMN ID.
 */
export const startProcessLaneMgtGetLaneByBpmnIdStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessLaneMgtGetLaneByBpmnIdStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses,
    StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses,
        StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/lane_mgt/get_lane_by_bpmn_id/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Lane by Role Id.
 */
export const startProcessLaneMgtGetLaneByRoleIdStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessLaneMgtGetLaneByRoleIdStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessLaneMgtGetLaneByRoleIdStartPostResponses,
    StartProcessLaneMgtGetLaneByRoleIdStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessLaneMgtGetLaneByRoleIdStartPostResponses,
        StartProcessLaneMgtGetLaneByRoleIdStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/lane_mgt/get_lane_by_role_id/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Lanes by Process.
 */
export const startProcessLaneMgtGetLanesByProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessLaneMgtGetLanesByProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessLaneMgtGetLanesByProcessStartPostResponses,
    StartProcessLaneMgtGetLanesByProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessLaneMgtGetLanesByProcessStartPostResponses,
        StartProcessLaneMgtGetLanesByProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/lane_mgt/get_lanes_by_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Archive Task
 */
export const startProcessProcessElementMgtArchiveProcessElementStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtArchiveProcessElementStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtArchiveProcessElementStartPostResponses,
    StartProcessProcessElementMgtArchiveProcessElementStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtArchiveProcessElementStartPostResponses,
        StartProcessProcessElementMgtArchiveProcessElementStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/archive_process_element/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete Event
 */
export const startProcessProcessElementMgtDeleteEventStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtDeleteEventStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtDeleteEventStartPostResponses,
    StartProcessProcessElementMgtDeleteEventStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtDeleteEventStartPostResponses,
        StartProcessProcessElementMgtDeleteEventStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/delete_event/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete Flow
 */
export const startProcessProcessElementMgtDeleteFlowStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtDeleteFlowStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtDeleteFlowStartPostResponses,
    StartProcessProcessElementMgtDeleteFlowStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtDeleteFlowStartPostResponses,
        StartProcessProcessElementMgtDeleteFlowStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/delete_flow/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete Gateway
 */
export const startProcessProcessElementMgtDeleteGatewayStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtDeleteGatewayStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtDeleteGatewayStartPostResponses,
    StartProcessProcessElementMgtDeleteGatewayStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtDeleteGatewayStartPostResponses,
        StartProcessProcessElementMgtDeleteGatewayStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/delete_gateway/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete Task
 */
export const startProcessProcessElementMgtDeleteTaskStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtDeleteTaskStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtDeleteTaskStartPostResponses,
    StartProcessProcessElementMgtDeleteTaskStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtDeleteTaskStartPostResponses,
        StartProcessProcessElementMgtDeleteTaskStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/delete_task/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Generate a React component for a process element.
 */
export const startProcessProcessElementMgtGenerateUserInterfaceStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtGenerateUserInterfaceStartPostData,
        ThrowOnError,
        StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponse
    >
): Promise<
    ServerSentEventsResult<StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses>
> =>
    (options.client ?? client).sse.post<
        StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses,
        StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/generate_user_interface/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Event.
 */
export const startProcessProcessElementMgtGetEventStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtGetEventStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtGetEventStartPostResponses,
    StartProcessProcessElementMgtGetEventStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtGetEventStartPostResponses,
        StartProcessProcessElementMgtGetEventStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/get_event/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Flow.
 */
export const startProcessProcessElementMgtGetFlowStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtGetFlowStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtGetFlowStartPostResponses,
    StartProcessProcessElementMgtGetFlowStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtGetFlowStartPostResponses,
        StartProcessProcessElementMgtGetFlowStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/get_flow/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Gateway.
 */
export const startProcessProcessElementMgtGetGatewayStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtGetGatewayStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtGetGatewayStartPostResponses,
    StartProcessProcessElementMgtGetGatewayStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtGetGatewayStartPostResponses,
        StartProcessProcessElementMgtGetGatewayStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/get_gateway/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Process Element by BPMN ID.
 */
export const startProcessProcessElementMgtGetProcessElementByBpmnIdStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses,
    StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses,
        StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/get_process_element_by_bpmn_id/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all process tasks that reference the given business entity.
 */
export const startProcessProcessElementMgtGetProcessElementsByEntityStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartProcessProcessElementMgtGetProcessElementsByEntityStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses,
        StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses,
            StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/process/process_element_mgt/get_process_elements_by_entity/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get Tasks by Process.
 */
export const startProcessProcessElementMgtGetProcessElementsByProcessStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses,
        StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses,
            StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/process/process_element_mgt/get_process_elements_by_process/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get the elements of every Process in the Domain, keyed by process id.
 */
export const startProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponses,
        StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponses,
            StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/process/process_element_mgt/get_process_elements_grouped_by_process/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get every ProcessTask in a Stek, in one call.
 */
export const startProcessProcessElementMgtGetProcessTasksByStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartProcessProcessElementMgtGetProcessTasksByStekStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponses,
    StartProcessProcessElementMgtGetProcessTasksByStekStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponses,
        StartProcessProcessElementMgtGetProcessTasksByStekStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/get_process_tasks_by_stek/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Start
 *
 * Get Task.
 */
export const startProcessProcessElementMgtGetTaskStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtGetTaskStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtGetTaskStartPostResponses,
    StartProcessProcessElementMgtGetTaskStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtGetTaskStartPostResponses,
        StartProcessProcessElementMgtGetTaskStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/get_task/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Unarchive Process Element.
 */
export const startProcessProcessElementMgtUnarchiveProcessElementStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtUnarchiveProcessElementStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses,
    StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses,
        StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/unarchive_process_element/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update event.
 */
export const startProcessProcessElementMgtUpdateEventStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtUpdateEventStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtUpdateEventStartPostResponses,
    StartProcessProcessElementMgtUpdateEventStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtUpdateEventStartPostResponses,
        StartProcessProcessElementMgtUpdateEventStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/update_event/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update flow.
 */
export const startProcessProcessElementMgtUpdateFlowStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtUpdateFlowStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtUpdateFlowStartPostResponses,
    StartProcessProcessElementMgtUpdateFlowStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtUpdateFlowStartPostResponses,
        StartProcessProcessElementMgtUpdateFlowStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/update_flow/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update gateway.
 */
export const startProcessProcessElementMgtUpdateGatewayStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtUpdateGatewayStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtUpdateGatewayStartPostResponses,
    StartProcessProcessElementMgtUpdateGatewayStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtUpdateGatewayStartPostResponses,
        StartProcessProcessElementMgtUpdateGatewayStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/update_gateway/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update entity references on a ProcessElement.
 */
export const startProcessProcessElementMgtUpdateProcessElementEntityRefsStartPost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostData,
            ThrowOnError
        >
    ): RequestResult<
        StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses,
        StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses,
            StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/process/process_element_mgt/update_process_element_entity_refs/start",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Update task.
 */
export const startProcessProcessElementMgtUpdateTaskStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtUpdateTaskStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtUpdateTaskStartPostResponses,
    StartProcessProcessElementMgtUpdateTaskStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtUpdateTaskStartPostResponses,
        StartProcessProcessElementMgtUpdateTaskStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/update_task/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update evidence annotation on a task.
 */
export const startProcessProcessElementMgtUpdateTaskEvidenceStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessElementMgtUpdateTaskEvidenceStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessElementMgtUpdateTaskEvidenceStartPostResponses,
    StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessElementMgtUpdateTaskEvidenceStartPostResponses,
        StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_element_mgt/update_task_evidence/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new Process
 */
export const startProcessProcessMgtCreateProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtCreateProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtCreateProcessStartPostResponses,
    StartProcessProcessMgtCreateProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtCreateProcessStartPostResponses,
        StartProcessProcessMgtCreateProcessStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/create_process/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a Process
 */
export const startProcessProcessMgtDeleteProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtDeleteProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtDeleteProcessStartPostResponses,
    StartProcessProcessMgtDeleteProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtDeleteProcessStartPostResponses,
        StartProcessProcessMgtDeleteProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/delete_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Deploy a Process to process engine.
 *
 * Returns:
 * resp (dict): Of the form:
 * {'deployment_id': str}
 */
export const startProcessProcessMgtDeployProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtDeployProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtDeployProcessStartPostResponses,
    StartProcessProcessMgtDeployProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtDeployProcessStartPostResponses,
        StartProcessProcessMgtDeployProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/deploy_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Process
 */
export const startProcessProcessMgtGetProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtGetProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtGetProcessStartPostResponses,
    StartProcessProcessMgtGetProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtGetProcessStartPostResponses,
        StartProcessProcessMgtGetProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/get_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 */
export const startProcessProcessMgtGetProcessDiagramStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtGetProcessDiagramStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtGetProcessDiagramStartPostResponses,
    StartProcessProcessMgtGetProcessDiagramStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtGetProcessDiagramStartPostResponses,
        StartProcessProcessMgtGetProcessDiagramStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/get_process_diagram/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get each Process's BPMN-preview thumbnail for the Product, keyed by process id.
 */
export const startProcessProcessMgtGetProcessThumbnailsByProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtGetProcessThumbnailsByProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponses,
    StartProcessProcessMgtGetProcessThumbnailsByProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponses,
        StartProcessProcessMgtGetProcessThumbnailsByProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/get_process_thumbnails_by_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Processes by Product.
 */
export const startProcessProcessMgtGetProcessesByProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtGetProcessesByProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtGetProcessesByProductStartPostResponses,
    StartProcessProcessMgtGetProcessesByProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtGetProcessesByProductStartPostResponses,
        StartProcessProcessMgtGetProcessesByProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/get_processes_by_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Move a Process to a new Product.
 */
export const startProcessProcessMgtMoveProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtMoveProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtMoveProcessStartPostResponses,
    StartProcessProcessMgtMoveProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtMoveProcessStartPostResponses,
        StartProcessProcessMgtMoveProcessStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/move_process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a process.
 */
export const startProcessProcessMgtUpdateProcessStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtUpdateProcessStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtUpdateProcessStartPostResponses,
    StartProcessProcessMgtUpdateProcessStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtUpdateProcessStartPostResponses,
        StartProcessProcessMgtUpdateProcessStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/update_process/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update process orders.
 */
export const startProcessProcessMgtUpdateProcessOrdersStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProcessProcessMgtUpdateProcessOrdersStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProcessProcessMgtUpdateProcessOrdersStartPostResponses,
    StartProcessProcessMgtUpdateProcessOrdersStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProcessProcessMgtUpdateProcessOrdersStartPostResponses,
        StartProcessProcessMgtUpdateProcessOrdersStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/process/process_mgt/update_process_orders/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new Product
 */
export const startProductProductMgtCreateProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtCreateProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtCreateProductStartPostResponses,
    StartProductProductMgtCreateProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtCreateProductStartPostResponses,
        StartProductProductMgtCreateProductStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/create_product/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a Product
 */
export const startProductProductMgtDeleteProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtDeleteProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtDeleteProductStartPostResponses,
    StartProductProductMgtDeleteProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtDeleteProductStartPostResponses,
        StartProductProductMgtDeleteProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/delete_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Product
 */
export const startProductProductMgtGetProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtGetProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtGetProductStartPostResponses,
    StartProductProductMgtGetProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtGetProductStartPostResponses,
        StartProductProductMgtGetProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/get_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Products by Domain
 */
export const startProductProductMgtGetProductsByDomainStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtGetProductsByDomainStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtGetProductsByDomainStartPostResponses,
    StartProductProductMgtGetProductsByDomainStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtGetProductsByDomainStartPostResponses,
        StartProductProductMgtGetProductsByDomainStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/get_products_by_domain/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Move a product to a new domain.
 */
export const startProductProductMgtMoveProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtMoveProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtMoveProductStartPostResponses,
    StartProductProductMgtMoveProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtMoveProductStartPostResponses,
        StartProductProductMgtMoveProductStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/move_product/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a Product
 */
export const startProductProductMgtUpdateProductStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtUpdateProductStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtUpdateProductStartPostResponses,
    StartProductProductMgtUpdateProductStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtUpdateProductStartPostResponses,
        StartProductProductMgtUpdateProductStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/update_product/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update product orders.
 */
export const startProductProductMgtUpdateProductOrdersStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartProductProductMgtUpdateProductOrdersStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartProductProductMgtUpdateProductOrdersStartPostResponses,
    StartProductProductMgtUpdateProductOrdersStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartProductProductMgtUpdateProductOrdersStartPostResponses,
        StartProductProductMgtUpdateProductOrdersStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/product/product_mgt/update_product_orders/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Preview Link
 *
 * Get the metadata from a weblink based on the HTML or API for supported services.
 *
 * Args:
 * url: The URL to preview
 *
 * Returns:
 * LinkPreview with extracted metadata
 *
 * Raises:
 * HTTPException: On error fetching or parsing data
 */
export const previewLinkProxyPreviewLinkGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PreviewLinkProxyPreviewLinkGetData, ThrowOnError>
): RequestResult<
    PreviewLinkProxyPreviewLinkGetResponses,
    PreviewLinkProxyPreviewLinkGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        PreviewLinkProxyPreviewLinkGetResponses,
        PreviewLinkProxyPreviewLinkGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/proxy/preview-link",
        ...options,
    });

/**
 * Search
 */
export const searchSearchGet = <ThrowOnError extends boolean = false>(
    options: Options<SearchSearchGetData, ThrowOnError>
): RequestResult<
    SearchSearchGetResponses,
    SearchSearchGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        SearchSearchGetResponses,
        SearchSearchGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/search/",
        ...options,
    });

/**
 * Delete Integration Settings
 *
 * Delete integration settings for the current organization.
 *
 * Args:
 * integration_type: The integration you want to delete
 */
export const deleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDelete =
    <ThrowOnError extends boolean = false>(
        options: Options<
            DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteData,
            ThrowOnError
        >
    ): RequestResult<
        DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses,
        DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors,
        ThrowOnError
    > =>
        (options.client ?? client).delete<
            DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses,
            DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/stek/integration_mgt/integration/settings/{integration_type}",
            ...options,
        });

/**
 * Get Integration Settings
 *
 * Get integration settings for the current organization.
 *
 * Args:
 * integration_type: The integration you want to get
 *
 * Returns:
 * Integration
 *
 * Raises:
 * HTTPException: If organization not found or settings not configured
 */
export const getIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGet =
    <ThrowOnError extends boolean = false>(
        options: Options<
            GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetData,
            ThrowOnError
        >
    ): RequestResult<
        GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses,
        GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors,
        ThrowOnError
    > =>
        (options.client ?? client).get<
            GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses,
            GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/stek/integration_mgt/integration/settings/{integration_type}",
            ...options,
        });

/**
 * Create Api Integration
 *
 * Create an API integration
 *
 * Args:
 * integration_type: The integration you want to save
 * api_key: The API key for the integration
 */
export const createApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostData,
            ThrowOnError
        >
    ): RequestResult<
        CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses,
        CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses,
            CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/stek/integration_mgt/integration/settings/{integration_type}",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Test Integration Connection
 *
 * Test integration connection with provided credentials.
 *
 * Args:
 * integration_type: The integration type to test
 * api_key: The API key for the integration
 * host: Optional custom host URL
 *
 * Returns:
 * Connection test result
 *
 * Raises:
 * HTTPException: If the connection test fails
 */
export const testIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePost =
    <ThrowOnError extends boolean = false>(
        options: Options<
            TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostData,
            ThrowOnError
        >
    ): RequestResult<
        TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses,
        TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors,
        ThrowOnError
    > =>
        (options.client ?? client).post<
            TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses,
            TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors,
            ThrowOnError
        >({
            security: [
                {
                    key: "ProbacBearer",
                    scheme: "bearer",
                    type: "http",
                },
                { name: "organization", type: "apiKey" },
                { name: "stek", type: "apiKey" },
            ],
            url: "/stek/integration_mgt/integration/test/{integration_type}",
            ...options,
            headers: {
                "Content-Type": "application/json",
                ...options.headers,
            },
        });

/**
 * Start
 *
 * Get all compliance evidence for a process instance.
 *
 * Returns all compliance evidence items with their event context:
 * - Evidence details (type, value, description, timestamp)
 * - Event context (event_id, event_type, business_key)
 */
export const startStekLiveMgtGetComplianceEvidenceStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekLiveMgtGetComplianceEvidenceStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekLiveMgtGetComplianceEvidenceStartPostResponses,
    StartStekLiveMgtGetComplianceEvidenceStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekLiveMgtGetComplianceEvidenceStartPostResponses,
        StartStekLiveMgtGetComplianceEvidenceStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_compliance_evidence/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Per-BPMN-element live metrics for a process — backs the live overlay.
 *
 * For each element: how many running instances are parked there now (here_now),
 * how many distinct instances passed through (throughput), the average dwell time
 * (avg_duration_seconds) and the error count. Window is ``hours`` or an absolute
 * ``start_time`` + ``end_time``.
 */
export const startStekLiveMgtGetElementMetricsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekLiveMgtGetElementMetricsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekLiveMgtGetElementMetricsStartPostResponses,
    StartStekLiveMgtGetElementMetricsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekLiveMgtGetElementMetricsStartPostResponses,
        StartStekLiveMgtGetElementMetricsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_element_metrics/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Derive the anomaly-focused "needs attention" live insights.
 *
 * Exactly one of ``process_id``, ``product_id``, ``domain_id`` or ``stek_id``
 * must be given. A process compares live behaviour to a learned 30-day
 * baseline; a product or domain aggregates the notable per-process findings
 * across it; a stek returns only ``entity_attention`` (per-entity needs-
 * attention counts for the live worktree tree). Each insight carries a
 * ``basis`` (learned | direct) and a ``coverage_note`` so the client can show
 * how much data backs it.
 */
export const startStekLiveMgtGetLiveInsightsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartStekLiveMgtGetLiveInsightsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekLiveMgtGetLiveInsightsStartPostResponses,
    StartStekLiveMgtGetLiveInsightsStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekLiveMgtGetLiveInsightsStartPostResponses,
        StartStekLiveMgtGetLiveInsightsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_live_insights/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Start
 *
 * Get aggregated metrics for a Stek, Domain, Product, or Process.
 *
 * Exactly one of stek_id, domain_id, product_id, or process_id must be provided.
 * Pass either ``hours`` (relative) or ``start_time`` + ``end_time`` (absolute).
 */
export const startStekLiveMgtGetMetricsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekLiveMgtGetMetricsStartPostData, ThrowOnError>
): RequestResult<
    StartStekLiveMgtGetMetricsStartPostResponses,
    StartStekLiveMgtGetMetricsStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekLiveMgtGetMetricsStartPostResponses,
        StartStekLiveMgtGetMetricsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_metrics/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Start
 *
 * Runtime metrics for a process's instances, newest first, paginated.
 *
 * Returns a ``Page`` envelope (items + limit/offset/has_more/total); ``offset``
 * pages through older runs. Window is ``hours`` or ``start_time`` + ``end_time``.
 */
export const startStekLiveMgtGetProcessInstancesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekLiveMgtGetProcessInstancesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekLiveMgtGetProcessInstancesStartPostResponses,
    StartStekLiveMgtGetProcessInstancesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekLiveMgtGetProcessInstancesStartPostResponses,
        StartStekLiveMgtGetProcessInstancesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_process_instances/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Most-recent live events for one scope, newest first (live-activity feed).
 *
 * Exactly one of stek_id / domain_id / product_id / process_id / process_instance_id
 * must be given; a process_instance_id drill-down is additionally scoped to the
 * request's stek.
 * ``offset`` pages through older events (offset-based, like the other feeds).
 * Returns a ``Page`` envelope (items + limit/offset/has_more) so the client can
 * page without a separate count call.
 */
export const startStekLiveMgtGetRecentActivityStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartStekLiveMgtGetRecentActivityStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekLiveMgtGetRecentActivityStartPostResponses,
    StartStekLiveMgtGetRecentActivityStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekLiveMgtGetRecentActivityStartPostResponses,
        StartStekLiveMgtGetRecentActivityStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_recent_activity/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Start
 *
 * Get all unique releases for a given Stek
 */
export const startStekLiveMgtGetReleasesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekLiveMgtGetReleasesStartPostData, ThrowOnError>
): RequestResult<
    StartStekLiveMgtGetReleasesStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekLiveMgtGetReleasesStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/get_releases/start",
        ...options,
    });

/**
 * Start
 *
 * Ingest an event from a running Stek.
 *
 * This endpoint is designed to be flexible:
 * - Only `stek_release` is strictly required.
 * - If `process_element_id`, `process_id`, or `product_id` is provided, the backend
 * automatically resolves the full parent hierarchy (Domain, Product, Process).
 * - If `timestamp` is omitted, it defaults to the current UTC time.
 * - `event_type` defaults to 'generic.event' and `payload` to an empty object if not specified.
 *
 * Payload structure:
 * - Can contain any arbitrary data (extra fields allowed)
 * - If including compliance evidence, use the `compliance_proof` structure:
 * {
 * "compliance_proof": {
 * "evidence": [
 * {
 * "id": "evidence_123",
 * "type": "uri",  // or "description"
 * "value": "https://...",  // URL for uri, text for description
 * "description": "What this proves",
 * "timestamp": "2026-01-31T10:30:00Z",
 * "created_by": "user@example.com"  // optional
 * }
 * ],
 * "metadata": {}  // optional
 * },
 * "custom_field": "any other data"
 * }
 */
export const startStekLiveMgtIngestEventStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartStekLiveMgtIngestEventStartPostData, ThrowOnError>
): RequestResult<
    StartStekLiveMgtIngestEventStartPostResponses,
    StartStekLiveMgtIngestEventStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekLiveMgtIngestEventStartPostResponses,
        StartStekLiveMgtIngestEventStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/ingest_event/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Server-Sent Events stream of live events for one scope (live-activity feed).
 *
 * Exactly one of stek_id / domain_id / product_id / process_id / process_instance_id
 * must be given; a process_instance_id drill-down is additionally scoped to the
 * request's stek.
 * Authorization and an initial snapshot happen up front (HTTP errors can't be
 * raised once the body is flowing); after that, events pushed by ``ingest_event``
 * are streamed as they land. The client can switch this off and fall back to the
 * polling endpoint at any time.
 */
export const startStekLiveMgtStreamActivityStartGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekLiveMgtStreamActivityStartGetData, ThrowOnError>
): RequestResult<
    StartStekLiveMgtStreamActivityStartGetResponses,
    StartStekLiveMgtStreamActivityStartGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        StartStekLiveMgtStreamActivityStartGetResponses,
        StartStekLiveMgtStreamActivityStartGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/live_mgt/stream_activity/start",
        ...options,
    });

/**
 * Start
 *
 * Create a new Stek with optional logo, FQDN, and description
 */
export const startStekStekMgtCreateStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartStekStekMgtCreateStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtCreateStekStartPostResponses,
    StartStekStekMgtCreateStekStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekMgtCreateStekStartPostResponses,
        StartStekStekMgtCreateStekStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/create_stek/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a STek
 */
export const startStekStekMgtDeleteStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekStekMgtDeleteStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtDeleteStekStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekMgtDeleteStekStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/delete_stek/start",
        ...options,
    });

/**
 * Start
 *
 * Export a Stek as a ZIP file.
 */
export const startStekStekMgtExportStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekStekMgtExportStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtExportStekStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekMgtExportStekStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/export_stek/start",
        ...options,
    });

/**
 * Start
 *
 * Generate stek details based on the context available.
 */
export const startStekStekMgtGenerateStekDetailsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekStekMgtGenerateStekDetailsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekStekMgtGenerateStekDetailsStartPostResponses,
    StartStekStekMgtGenerateStekDetailsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekMgtGenerateStekDetailsStartPostResponses,
        StartStekStekMgtGenerateStekDetailsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/generate_stek_details/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get the setup-completeness status for a Stek
 */
export const startStekStekMgtGetSetupStatusStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekStekMgtGetSetupStatusStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtGetSetupStatusStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekMgtGetSetupStatusStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/get_setup_status/start",
        ...options,
    });

/**
 * Start
 *
 * Get Stek
 */
export const startStekStekMgtGetStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekStekMgtGetStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtGetStekStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekMgtGetStekStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/get_stek/start",
        ...options,
    });

/**
 * Start
 *
 * Get Steks by Organization
 */
export const startStekStekMgtGetSteksByOrganizationStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartStekStekMgtGetSteksByOrganizationStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekStekMgtGetSteksByOrganizationStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekMgtGetSteksByOrganizationStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/get_steks_by_organization/start",
        ...options,
    });

/**
 * Start
 *
 * Import a Stek from a ZIP file.
 */
export const startStekStekMgtImportStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartStekStekMgtImportStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtImportStekStartPostResponses,
    StartStekStekMgtImportStekStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekMgtImportStekStartPostResponses,
        StartStekStekMgtImportStekStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/import_stek/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a Stek's management settings.
 */
export const startStekStekMgtManageStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartStekStekMgtManageStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtManageStekStartPostResponses,
    StartStekStekMgtManageStekStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekMgtManageStekStartPostResponses,
        StartStekStekMgtManageStekStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/manage_stek/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get tree for given Stek containing all directories and files
 */
export const startStekStekMgtTreeStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StartStekStekMgtTreeStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtTreeStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekMgtTreeStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/tree/start",
        ...options,
    });

/**
 * Start
 *
 * Update a Stek's content: logo, description, mission, vision, and related text fields.
 */
export const startStekStekMgtUpdateStekStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartStekStekMgtUpdateStekStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtUpdateStekStartPostResponses,
    StartStekStekMgtUpdateStekStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekMgtUpdateStekStartPostResponses,
        StartStekStekMgtUpdateStekStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/update_stek/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create or update the stek's mission & vision strategy document (stek-manager only).
 */
export const startStekStekMgtUpdateStrategyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartStekStekMgtUpdateStrategyStartPostData, ThrowOnError>
): RequestResult<
    StartStekStekMgtUpdateStrategyStartPostResponses,
    StartStekStekMgtUpdateStrategyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekMgtUpdateStrategyStartPostResponses,
        StartStekStekMgtUpdateStrategyStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_mgt/update_strategy/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new release by tagging all domains in the stek.
 */
export const startStekStekReleaseMgtCreateReleaseStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekStekReleaseMgtCreateReleaseStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekStekReleaseMgtCreateReleaseStartPostResponses,
    StartStekStekReleaseMgtCreateReleaseStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekReleaseMgtCreateReleaseStartPostResponses,
        StartStekStekReleaseMgtCreateReleaseStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_release_mgt/create_release/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get a specific release by name.
 */
export const startStekStekReleaseMgtGetReleaseStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekStekReleaseMgtGetReleaseStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekStekReleaseMgtGetReleaseStartPostResponses,
    StartStekStekReleaseMgtGetReleaseStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekReleaseMgtGetReleaseStartPostResponses,
        StartStekStekReleaseMgtGetReleaseStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_release_mgt/get_release/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get diff between two releases (or HEAD to a release).
 */
export const startStekStekReleaseMgtGetReleaseDiffStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStekStekReleaseMgtGetReleaseDiffStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekStekReleaseMgtGetReleaseDiffStartPostResponses,
    StartStekStekReleaseMgtGetReleaseDiffStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStekStekReleaseMgtGetReleaseDiffStartPostResponses,
        StartStekStekReleaseMgtGetReleaseDiffStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_release_mgt/get_release_diff/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * List all releases for a stek.
 */
export const startStekStekReleaseMgtListReleasesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartStekStekReleaseMgtListReleasesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStekStekReleaseMgtListReleasesStartPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartStekStekReleaseMgtListReleasesStartPostResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stek/stek_release_mgt/list_releases/start",
        ...options,
    });

/**
 * Start
 *
 * Create the one competitor this card stands for; leave the rest offered.
 */
export const startStrategyStrategyMgtAcceptProposedCompetitorStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtAcceptProposedCompetitorStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponses,
    StartStrategyStrategyMgtAcceptProposedCompetitorStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponses,
        StartStrategyStrategyMgtAcceptProposedCompetitorStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/accept_proposed_competitor/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Add a competitor to a stek's market picture.
 */
export const startStrategyStrategyMgtCreateCompetitorStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtCreateCompetitorStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtCreateCompetitorStartPostResponses,
    StartStrategyStrategyMgtCreateCompetitorStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtCreateCompetitorStartPostResponses,
        StartStrategyStrategyMgtCreateCompetitorStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/create_competitor/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new strategic objective for a stek.
 */
export const startStrategyStrategyMgtCreateObjectiveStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtCreateObjectiveStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtCreateObjectiveStartPostResponses,
    StartStrategyStrategyMgtCreateObjectiveStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtCreateObjectiveStartPostResponses,
        StartStrategyStrategyMgtCreateObjectiveStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/create_objective/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Add a trend to a stek's market picture.
 */
export const startStrategyStrategyMgtCreateTrendStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtCreateTrendStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtCreateTrendStartPostResponses,
    StartStrategyStrategyMgtCreateTrendStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtCreateTrendStartPostResponses,
        StartStrategyStrategyMgtCreateTrendStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/create_trend/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a watcher for a stek.
 */
export const startStrategyStrategyMgtCreateWatcherStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtCreateWatcherStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtCreateWatcherStartPostResponses,
    StartStrategyStrategyMgtCreateWatcherStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtCreateWatcherStartPostResponses,
        StartStrategyStrategyMgtCreateWatcherStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/create_watcher/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Answer no to the one competitor this card stands for; leave the rest offered.
 */
export const startStrategyStrategyMgtDeclineProposedCompetitorStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtDeclineProposedCompetitorStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponses,
    StartStrategyStrategyMgtDeclineProposedCompetitorStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponses,
        StartStrategyStrategyMgtDeclineProposedCompetitorStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/decline_proposed_competitor/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a competitor from the given stek's market picture.
 */
export const startStrategyStrategyMgtDeleteCompetitorStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtDeleteCompetitorStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtDeleteCompetitorStartPostResponses,
    StartStrategyStrategyMgtDeleteCompetitorStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtDeleteCompetitorStartPostResponses,
        StartStrategyStrategyMgtDeleteCompetitorStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/delete_competitor/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete an objective belonging to a stek.
 */
export const startStrategyStrategyMgtDeleteObjectiveStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtDeleteObjectiveStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtDeleteObjectiveStartPostResponses,
    StartStrategyStrategyMgtDeleteObjectiveStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtDeleteObjectiveStartPostResponses,
        StartStrategyStrategyMgtDeleteObjectiveStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/delete_objective/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a trend from the given stek's market picture.
 */
export const startStrategyStrategyMgtDeleteTrendStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtDeleteTrendStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtDeleteTrendStartPostResponses,
    StartStrategyStrategyMgtDeleteTrendStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtDeleteTrendStartPostResponses,
        StartStrategyStrategyMgtDeleteTrendStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/delete_trend/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete a watcher belonging to the given stek.
 */
export const startStrategyStrategyMgtDeleteWatcherStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtDeleteWatcherStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtDeleteWatcherStartPostResponses,
    StartStrategyStrategyMgtDeleteWatcherStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtDeleteWatcherStartPostResponses,
        StartStrategyStrategyMgtDeleteWatcherStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/delete_watcher/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * What has happened to one competitor, newest first.
 */
export const startStrategyStrategyMgtGetCompetitorHistoryStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtGetCompetitorHistoryStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponses,
    StartStrategyStrategyMgtGetCompetitorHistoryStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponses,
        StartStrategyStrategyMgtGetCompetitorHistoryStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/get_competitor_history/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get the stek's horizon placement (key result → Now/Next/Later).
 */
export const startStrategyStrategyMgtGetHorizonsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtGetHorizonsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtGetHorizonsStartPostResponses,
    StartStrategyStrategyMgtGetHorizonsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtGetHorizonsStartPostResponses,
        StartStrategyStrategyMgtGetHorizonsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/get_horizons/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get a stek's market picture: its competitors and its trends.
 */
export const startStrategyStrategyMgtGetMarketStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtGetMarketStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtGetMarketStartPostResponses,
    StartStrategyStrategyMgtGetMarketStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtGetMarketStartPostResponses,
        StartStrategyStrategyMgtGetMarketStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/get_market/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all objectives (with key results) for a stek.
 */
export const startStrategyStrategyMgtGetObjectivesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtGetObjectivesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtGetObjectivesStartPostResponses,
    StartStrategyStrategyMgtGetObjectivesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtGetObjectivesStartPostResponses,
        StartStrategyStrategyMgtGetObjectivesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/get_objectives/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Competitors an agent has put forward that nobody has answered yet.
 */
export const startStrategyStrategyMgtGetProposedCompetitorsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtGetProposedCompetitorsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponses,
    StartStrategyStrategyMgtGetProposedCompetitorsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponses,
        StartStrategyStrategyMgtGetProposedCompetitorsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/get_proposed_competitors/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get all watchers for a stek.
 */
export const startStrategyStrategyMgtGetWatchersStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtGetWatchersStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtGetWatchersStartPostResponses,
    StartStrategyStrategyMgtGetWatchersStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtGetWatchersStartPostResponses,
        StartStrategyStrategyMgtGetWatchersStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/get_watchers/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a competitor; omitted fields are left unchanged.
 */
export const startStrategyStrategyMgtUpdateCompetitorStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtUpdateCompetitorStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtUpdateCompetitorStartPostResponses,
    StartStrategyStrategyMgtUpdateCompetitorStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtUpdateCompetitorStartPostResponses,
        StartStrategyStrategyMgtUpdateCompetitorStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/update_competitor/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Replace the stek's horizon placement (stek-manager only).
 */
export const startStrategyStrategyMgtUpdateHorizonsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtUpdateHorizonsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtUpdateHorizonsStartPostResponses,
    StartStrategyStrategyMgtUpdateHorizonsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtUpdateHorizonsStartPostResponses,
        StartStrategyStrategyMgtUpdateHorizonsStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/update_horizons/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update an objective's title/description and key results.
 */
export const startStrategyStrategyMgtUpdateObjectiveStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtUpdateObjectiveStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtUpdateObjectiveStartPostResponses,
    StartStrategyStrategyMgtUpdateObjectiveStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtUpdateObjectiveStartPostResponses,
        StartStrategyStrategyMgtUpdateObjectiveStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/update_objective/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a trend; omitted fields are left unchanged.
 */
export const startStrategyStrategyMgtUpdateTrendStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtUpdateTrendStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtUpdateTrendStartPostResponses,
    StartStrategyStrategyMgtUpdateTrendStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtUpdateTrendStartPostResponses,
        StartStrategyStrategyMgtUpdateTrendStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/update_trend/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Update a watcher's title/description/interval/enabled.
 */
export const startStrategyStrategyMgtUpdateWatcherStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartStrategyStrategyMgtUpdateWatcherStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartStrategyStrategyMgtUpdateWatcherStartPostResponses,
    StartStrategyStrategyMgtUpdateWatcherStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartStrategyStrategyMgtUpdateWatcherStartPostResponses,
        StartStrategyStrategyMgtUpdateWatcherStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/strategy/strategy_mgt/update_watcher/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Create Checkout Session
 *
 * Create a Stripe Checkout Session for a per-feature subscription.
 *
 * Body::
 *
 * {
 * "feature_id": "live_mode",
 * "tier_id": "starter"
 * }
 *
 * or for variant features::
 *
 * {
 * "feature_id": "dashboard",
 * "variant_id": "pro"
 * }
 *
 * Returns a URL the frontend should immediately redirect to.  After payment
 * the Stripe webhook activates the subscription in our DB.
 */
export const createCheckoutSessionStripeCheckoutSessionPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        CreateCheckoutSessionStripeCheckoutSessionPostData,
        ThrowOnError
    >
): RequestResult<
    CreateCheckoutSessionStripeCheckoutSessionPostResponses,
    CreateCheckoutSessionStripeCheckoutSessionPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        CreateCheckoutSessionStripeCheckoutSessionPostResponses,
        CreateCheckoutSessionStripeCheckoutSessionPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stripe/checkout-session",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Create Portal Session
 *
 * Create a Stripe Customer Portal Session for the organisation in scope.
 */
export const createPortalSessionStripePortalSessionPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        CreatePortalSessionStripePortalSessionPostData,
        ThrowOnError
    >
): RequestResult<
    CreatePortalSessionStripePortalSessionPostResponses,
    CreatePortalSessionStripePortalSessionPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        CreatePortalSessionStripePortalSessionPostResponses,
        CreatePortalSessionStripePortalSessionPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/stripe/portal-session",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Stripe Webhook
 *
 * Handle incoming Stripe webhook events.
 *
 * This endpoint does **not** require user authentication; it verifies the
 * Stripe signature instead.
 */
export const stripeWebhookStripeWebhookPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StripeWebhookStripeWebhookPostData, ThrowOnError>
): RequestResult<
    StripeWebhookStripeWebhookPostResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StripeWebhookStripeWebhookPostResponses,
        unknown,
        ThrowOnError
    >({ url: "/stripe/webhook", ...options });

/**
 * Get Entitlements
 *
 * Return entitlement status and usage for all features in this organisation.
 */
export const getEntitlementsSubscriptionEntitlementsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        GetEntitlementsSubscriptionEntitlementsGetData,
        ThrowOnError
    >
): RequestResult<
    GetEntitlementsSubscriptionEntitlementsGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetEntitlementsSubscriptionEntitlementsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/subscription/entitlements",
        ...options,
    });

/**
 * List Features
 *
 * Return the full feature registry as a JSON object keyed by feature_id.
 *
 * Example response::
 *
 * {
 * "live_mode": {
 * "feature_id": "live_mode",
 * "type": "usage_based",
 * "label": "Live Mode",
 * "description": "Process real events …",
 * "dependencies": [],
 * "tiers": [
 * {"tier_id": "free", "cap": 1000, "price_cents": 0, "currency": null,
 * "has_stripe_price": false},
 * {"tier_id": "starter", "cap": 10000, "price_cents": 1000, "currency": "eur",
 * "has_stripe_price": true},
 * …
 * ],
 * "variants": [],
 * "trial_days": 0,
 * "has_stripe_price": false
 * },
 * "compliancy": { … }
 * }
 *
 * Stripe price IDs are **never** exposed; ``has_stripe_price`` indicates
 * whether a price is configured so the frontend can enable the checkout button.
 */
export const listFeaturesSubscriptionFeaturesGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<ListFeaturesSubscriptionFeaturesGetData, ThrowOnError>
): RequestResult<
    ListFeaturesSubscriptionFeaturesGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        ListFeaturesSubscriptionFeaturesGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/subscription/features",
        ...options,
    });

/**
 * Cancel Subscription
 *
 * Cancel the active subscription for a feature in this organisation.
 *
 * Cancellation is at period end (``cancel_at_period_end`` semantics).
 *
 * Features that depend on this one and are still billed by the provider must
 * be cancelled first — the request is refused with a 422 naming them. Any
 * remaining dependents (free, or comped without a provider subscription) are
 * cascaded by the domain task.
 */
export const cancelSubscriptionSubscriptionFeatureKeyCancelPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        CancelSubscriptionSubscriptionFeatureKeyCancelPostData,
        ThrowOnError
    >
): RequestResult<
    CancelSubscriptionSubscriptionFeatureKeyCancelPostResponses,
    CancelSubscriptionSubscriptionFeatureKeyCancelPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        CancelSubscriptionSubscriptionFeatureKeyCancelPostResponses,
        CancelSubscriptionSubscriptionFeatureKeyCancelPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/subscription/{feature_key}/cancel",
        ...options,
    });

/**
 * Stek Thread Events
 *
 * Stream real-time thread events for every thread in this stek.
 *
 * No thread id: this is what lets the top bar badge and thread list pick up a
 * ``new_entry``/``thread_read`` for ANY thread in the stek — not just the one
 * open in a conversation pane, which the per-thread stream above still covers
 * while that pane is open. Authorization is the same VIEWER check the list
 * endpoint enforces, run here against a short-lived session that is released
 * before the stream starts (same arrangement as the per-thread route).
 */
export const stekThreadEventsThreadEventsGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<StekThreadEventsThreadEventsGetData, ThrowOnError>
): RequestResult<
    StekThreadEventsThreadEventsGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        StekThreadEventsThreadEventsGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/events",
        ...options,
    });

/**
 * Thread Events
 *
 * Stream real-time events for a thread over SSE.
 *
 * Authorization is the same VIEWER check the GET endpoint enforces — run here against a
 * short-lived session that is released before the stream starts.
 */
export const threadEventsThreadEventsThreadIdGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<ThreadEventsThreadEventsThreadIdGetData, ThrowOnError>
): RequestResult<
    ThreadEventsThreadEventsThreadIdGetResponses,
    ThreadEventsThreadEventsThreadIdGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        ThreadEventsThreadEventsThreadIdGetResponses,
        ThreadEventsThreadEventsThreadIdGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/events/{thread_id}",
        ...options,
    });

/**
 * Start
 *
 * Fetch a web page and attach its text to the thread.
 *
 * The fetch runs here rather than in the domain op, which stays off the network.
 */
export const startThreadThreadMgtAttachThreadLinkStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtAttachThreadLinkStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtAttachThreadLinkStartPostResponses,
    StartThreadThreadMgtAttachThreadLinkStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtAttachThreadLinkStartPostResponses,
        StartThreadThreadMgtAttachThreadLinkStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/attach_thread_link/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Catch an open thread up with main (the open/view interaction trigger).
 *
 * Merges current master INTO the thread branch per repo. A clean catch-up
 * folds master's changes onto the branch (so a forked domain reads fresh and
 * diff badges are accurate) and logs a SYSTEM_EVENT of what it absorbed; a
 * repo that can't merge cleanly leaves the thread behind-conflicted with
 * pending conflict records (surfaced by the behind-main banner). The thread's
 * status is never changed here — it stays OPEN either way.
 */
export const startThreadThreadMgtCatchUpStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartThreadThreadMgtCatchUpStartPostData, ThrowOnError>
): RequestResult<
    StartThreadThreadMgtCatchUpStartPostResponses,
    StartThreadThreadMgtCatchUpStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtCatchUpStartPostResponses,
        StartThreadThreadMgtCatchUpStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/catch_up/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Add a contribution to a thread.
 *
 * The thread agent is dispatched to run in the background.
 * The endpoint returns as soon as the contribution is saved; the agent's
 * response entries appear on subsequent thread fetches.
 */
export const startThreadThreadMgtContributeToThreadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtContributeToThreadStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtContributeToThreadStartPostResponses,
    StartThreadThreadMgtContributeToThreadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtContributeToThreadStartPostResponses,
        StartThreadThreadMgtContributeToThreadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/contribute_to_thread/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Create a new thread. A plain thread engages the agent on the first
 * contribution; a thread with a ``kind`` dispatches it immediately.
 *
 * ``defer_dispatch`` holds the agent back so the caller can attach files and
 * pages first, then call ``start_thread_agent``.
 *
 * ``auto_created`` is TRUSTED INPUT, deliberately. Nothing server-side can
 * tell an Edit click from a "Start a draft" click, so the client says which
 * it was, and that is the flag that makes a draft erasable later. Sending it
 * by hand buys a caller the ability to delete a draft they created — their
 * own, still empty, still open, still kind-less, with no conversation and
 * nothing staged, all of which ``delete_thread`` checks separately. That is
 * the whole blast radius: erasing an empty draft of your own that you could
 * have rejected anyway.
 */
export const startThreadThreadMgtCreateThreadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtCreateThreadStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtCreateThreadStartPostResponses,
    StartThreadThreadMgtCreateThreadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtCreateThreadStartPostResponses,
        StartThreadThreadMgtCreateThreadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/create_thread/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Delete an empty, unresolved, kind-less draft and its branch.
 *
 * Refuses anything that carries meaning — see the domain op. Returns the
 * thread it removed so the caller can confirm what went.
 */
export const startThreadThreadMgtDeleteThreadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtDeleteThreadStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtDeleteThreadStartPostResponses,
    StartThreadThreadMgtDeleteThreadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtDeleteThreadStartPostResponses,
        StartThreadThreadMgtDeleteThreadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/delete_thread/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Remove an attached file from a thread.
 *
 * Only the user who uploaded the file may delete it. Drops both the ``FILE``
 * context item and the stored bytes. Returns the deleted file id.
 */
export const startThreadThreadMgtDeleteThreadFileStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtDeleteThreadFileStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtDeleteThreadFileStartPostResponses,
    StartThreadThreadMgtDeleteThreadFileStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtDeleteThreadFileStartPostResponses,
        StartThreadThreadMgtDeleteThreadFileStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/delete_thread_file/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Suggest an accept message for a thread from its discussion and changes.
 *
 * Read-only: does not resolve the thread. The client pre-fills the editable
 * accept-reason field with this; the user reviews before accepting.
 */
export const startThreadThreadMgtGenerateAcceptMessageStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtGenerateAcceptMessageStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtGenerateAcceptMessageStartPostResponses,
    StartThreadThreadMgtGenerateAcceptMessageStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtGenerateAcceptMessageStartPostResponses,
        StartThreadThreadMgtGenerateAcceptMessageStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/generate_accept_message/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get a thread with its entries.
 *
 * Pass ``since_sequence`` to fetch only entries newer than that sequence (delta fetch
 * after a real-time ``new_entry`` push).
 *
 * ``include_affected_entities`` is the same switch ``list_threads`` carries,
 * and costs the same: a whole-worktree build at the thread revision plus a
 * stek read for the display name. Defaults to True so existing callers are
 * unaffected; pass False when the manifest is all you need.
 */
export const startThreadThreadMgtGetThreadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<StartThreadThreadMgtGetThreadStartPostData, ThrowOnError>
): RequestResult<
    StartThreadThreadMgtGetThreadStartPostResponses,
    StartThreadThreadMgtGetThreadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtGetThreadStartPostResponses,
        StartThreadThreadMgtGetThreadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/get_thread/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Stream a thread attachment for view/download.
 *
 * Any member who can view the thread can fetch its files.
 */
export const startThreadThreadMgtGetThreadFileStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtGetThreadFileStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtGetThreadFileStartPostResponses,
    StartThreadThreadMgtGetThreadFileStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtGetThreadFileStartPostResponses,
        StartThreadThreadMgtGetThreadFileStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/get_thread_file/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * List the entities a user (not the agent) edited directly on the thread branch.
 *
 * The resolve dialog renders these as its "Changes made directly by users" section
 * so a reviewer sees the non-agent footprint they are about to accept/reject.
 */
export const startThreadThreadMgtListThreadUserChangesStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtListThreadUserChangesStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtListThreadUserChangesStartPostResponses,
    StartThreadThreadMgtListThreadUserChangesStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtListThreadUserChangesStartPostResponses,
        StartThreadThreadMgtListThreadUserChangesStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/list_thread_user_changes/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * List all threads.
 *
 * ``include_affected_entities`` is what the per-thread branch diff costs, and
 * it is most of this endpoint's runtime — a full worktree build per OPEN
 * thread, serially (see the domain op). Measured at ~1.4s per open thread, so
 * a stek with thirty open drafts spends the better part of a minute here.
 *
 * Defaults to True so every existing caller keeps the behaviour it had. Pass
 * False when you only need the records — titles, status, timestamps — and the
 * listing returns promptly.
 */
export const startThreadThreadMgtListThreadsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        StartThreadThreadMgtListThreadsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtListThreadsStartPostResponses,
    StartThreadThreadMgtListThreadsStartPostErrors,
    ThrowOnError
> =>
    (options?.client ?? client).post<
        StartThreadThreadMgtListThreadsStartPostResponses,
        StartThreadThreadMgtListThreadsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/list_threads/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Start
 *
 * Follow the thread (if not already) and mark it read up to its latest entry.
 *
 * Called when a thread's conversation is opened, and again whenever a new
 * entry arrives while it stays open — so the unread badge never re-appears
 * for content the viewer is already looking at.
 */
export const startThreadThreadMgtMarkThreadReadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtMarkThreadReadStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtMarkThreadReadStartPostResponses,
    StartThreadThreadMgtMarkThreadReadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtMarkThreadReadStartPostResponses,
        StartThreadThreadMgtMarkThreadReadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/mark_thread_read/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Read a conflicted entity's content at base / master / branch for a 3-way diff.
 *
 * Returns the entity's content at the fork point (merge base), ``master`` and the
 * thread branch — the read seam the pick-a-side UX renders as two pairwise diffs.
 */
export const startThreadThreadMgtReadEntityVersionsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtReadEntityVersionsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtReadEntityVersionsStartPostResponses,
    StartThreadThreadMgtReadEntityVersionsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtReadEntityVersionsStartPostResponses,
        StartThreadThreadMgtReadEntityVersionsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/read_entity_versions/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Resolve one entity's catch-up conflict by picking a side.
 *
 * ``resolution`` is ``keep_main`` / ``keep_thread`` / ``edited`` (``content``
 * required for ``edited``). Once a repo's conflicts are all resolved the next
 * catch-up runs clean and the accept gate unblocks.
 */
export const startThreadThreadMgtResolveConflictStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtResolveConflictStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtResolveConflictStartPostResponses,
    StartThreadThreadMgtResolveConflictStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtResolveConflictStartPostResponses,
        StartThreadThreadMgtResolveConflictStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/resolve_conflict/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Approve every pending safe AI suggestion in one action (869dyvvu5).
 *
 * Applies the AI's recommended side per record with agent attribution —
 * each pick stays individually revertible until accept. Records whose
 * earlier AI decision a user undid are excluded (they left the suggested
 * set). Returns the records it resolved (empty when none qualified).
 */
export const startThreadThreadMgtResolveSafeConflictsStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtResolveSafeConflictsStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtResolveSafeConflictsStartPostResponses,
    StartThreadThreadMgtResolveSafeConflictsStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtResolveSafeConflictsStartPostResponses,
        StartThreadThreadMgtResolveSafeConflictsStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/resolve_safe_conflicts/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Accept or reject a thread.
 */
export const startThreadThreadMgtResolveThreadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtResolveThreadStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtResolveThreadStartPostResponses,
    StartThreadThreadMgtResolveThreadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtResolveThreadStartPostResponses,
        StartThreadThreadMgtResolveThreadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/resolve_thread/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Answer the agent's proposal.
 *
 * Confirm executes the plan saved with the proposal right away; if the plan
 * can't run, it falls back to a normal agent run. Cancel just records the
 * answer — no agent run at all.
 */
export const startThreadThreadMgtRespondToProposalStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtRespondToProposalStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtRespondToProposalStartPostResponses,
    StartThreadThreadMgtRespondToProposalStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtRespondToProposalStartPostResponses,
        StartThreadThreadMgtRespondToProposalStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/respond_to_proposal/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Set whether the agent applies its own plans on this thread.
 *
 * Takes effect from the next proposal; one already standing is left alone.
 */
export const startThreadThreadMgtSetAutoApplyStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtSetAutoApplyStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtSetAutoApplyStartPostResponses,
    StartThreadThreadMgtSetAutoApplyStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtSetAutoApplyStartPostResponses,
        StartThreadThreadMgtSetAutoApplyStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/set_auto_apply/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Run the agent on a thread created with ``defer_dispatch``.
 *
 * Attachments have to exist before the agent reads the thread, so the caller
 * creates it quiet, attaches, and then calls this.
 */
export const startThreadThreadMgtStartThreadAgentStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtStartThreadAgentStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtStartThreadAgentStartPostResponses,
    StartThreadThreadMgtStartThreadAgentStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtStartThreadAgentStartPostResponses,
        StartThreadThreadMgtStartThreadAgentStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/start_thread_agent/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Flip one entity's resolved catch-up conflict back to pending.
 *
 * The reconcile page's re-decide/undo: resolutions are shared state and stay
 * revertible until the thread is accepted (the fold happens at accept-time).
 * Rejected once the record's repo already absorbed master (a prior partial
 * accept) — that resolution is final.
 */
export const startThreadThreadMgtUnresolveConflictStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtUnresolveConflictStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtUnresolveConflictStartPostResponses,
    StartThreadThreadMgtUnresolveConflictStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtUnresolveConflictStartPostResponses,
        StartThreadThreadMgtUnresolveConflictStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/unresolve_conflict/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Rename/redescribe an open thread.
 */
export const startThreadThreadMgtUpdateThreadStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtUpdateThreadStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtUpdateThreadStartPostResponses,
    StartThreadThreadMgtUpdateThreadStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtUpdateThreadStartPostResponses,
        StartThreadThreadMgtUpdateThreadStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/update_thread/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Attach an uploaded file to a thread (multipart/form-data).
 *
 * Stores the bytes in the thread's VFS tree and appends a ``FILE`` context
 * item (id, name, mimetype, uploader) so every viewer can download it and the
 * thread agent reads it as context. A PDF, Word or Excel file also has its
 * text extracted so the agent can read that instead of the raw bytes.
 *
 * ``source``/``source_url`` say the file came off a connected drive rather
 * than the desktop, and are recorded on the item. ``source_url`` uses the same
 * key a page attached by URL does, so the engagement classifier already
 * reports the origin.
 */
export const startThreadThreadMgtUploadThreadFileStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartThreadThreadMgtUploadThreadFileStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartThreadThreadMgtUploadThreadFileStartPostResponses,
    StartThreadThreadMgtUploadThreadFileStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartThreadThreadMgtUploadThreadFileStartPostResponses,
        StartThreadThreadMgtUploadThreadFileStartPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/thread_mgt/upload_thread_file/start",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Notify Typing
 *
 * Flag the thread as "a user is typing" so the agent holds off — and if a
 * run is already executing, stop it and reschedule it for after they stop.
 */
export const notifyTypingThreadTypingThreadIdPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<NotifyTypingThreadTypingThreadIdPostData, ThrowOnError>
): RequestResult<
    NotifyTypingThreadTypingThreadIdPostResponses,
    NotifyTypingThreadTypingThreadIdPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        NotifyTypingThreadTypingThreadIdPostResponses,
        NotifyTypingThreadTypingThreadIdPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/thread/typing/{thread_id}",
        ...options,
    });

/**
 * Get Users
 *
 * Get all users.
 */
export const getUsersUserGet = <ThrowOnError extends boolean = false>(
    options?: Options<GetUsersUserGetData, ThrowOnError>
): RequestResult<GetUsersUserGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        GetUsersUserGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/",
        ...options,
    });

/**
 * Create User
 *
 * Create a user.
 */
export const createUserUserPost = <ThrowOnError extends boolean = false>(
    options: Options<CreateUserUserPostData, ThrowOnError>
): RequestResult<
    CreateUserUserPostResponses,
    CreateUserUserPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        CreateUserUserPostResponses,
        CreateUserUserPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get All Platform Users
 *
 * Get all users across all organizations (platform-wide).
 *
 * Platform admins only (``User.is_platform_admin``) — this is a platform-wide operation,
 * not an organization role. Returns all Gotoko platform users.
 *
 * Note:
 * - To get Firebase authentication details for a specific user, use GET /user/firebase/{email}.
 */
export const getAllPlatformUsersUserAllGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<GetAllPlatformUsersUserAllGetData, ThrowOnError>
): RequestResult<
    GetAllPlatformUsersUserAllGetResponses,
    GetAllPlatformUsersUserAllGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetAllPlatformUsersUserAllGetResponses,
        GetAllPlatformUsersUserAllGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/all/",
        ...options,
    });

/**
 * Create Api Key
 *
 * Create a new API key for the current user in the current organization.
 */
export const createApiKeyUserApiKeyPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<CreateApiKeyUserApiKeyPostData, ThrowOnError>
): RequestResult<
    CreateApiKeyUserApiKeyPostResponses,
    CreateApiKeyUserApiKeyPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        CreateApiKeyUserApiKeyPostResponses,
        CreateApiKeyUserApiKeyPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/api-key",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Revoke Api Key
 *
 * Revoke an API key.
 */
export const revokeApiKeyUserApiKeyApiKeyIdDelete = <
    ThrowOnError extends boolean = false,
>(
    options: Options<RevokeApiKeyUserApiKeyApiKeyIdDeleteData, ThrowOnError>
): RequestResult<
    RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses,
    RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors,
    ThrowOnError
> =>
    (options.client ?? client).delete<
        RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses,
        RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/api-key/{api_key_id}",
        ...options,
    });

/**
 * List Api Keys
 *
 * List all API keys for the current user in the current organization.
 */
export const listApiKeysUserApiKeysGet = <ThrowOnError extends boolean = false>(
    options?: Options<ListApiKeysUserApiKeysGetData, ThrowOnError>
): RequestResult<ListApiKeysUserApiKeysGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        ListApiKeysUserApiKeysGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/api-keys",
        ...options,
    });

/**
 * Get Firebase User By Email
 *
 * Get Firebase authentication details for a user by email.
 *
 * Platform admins only (``User.is_platform_admin``). Returns Firebase user details
 * including MFA settings.
 *
 * Args:
 * email: The user's email address.
 *
 * Returns:
 * Firebase user record with authentication details and MFA enrollments.
 */
export const getFirebaseUserByEmailUserFirebaseEmailGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetFirebaseUserByEmailUserFirebaseEmailGetData,
        ThrowOnError
    >
): RequestResult<
    GetFirebaseUserByEmailUserFirebaseEmailGetResponses,
    GetFirebaseUserByEmailUserFirebaseEmailGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetFirebaseUserByEmailUserFirebaseEmailGetResponses,
        GetFirebaseUserByEmailUserFirebaseEmailGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/firebase/{email}",
        ...options,
    });

/**
 * Validate Invitation
 *
 * Validate an invitation token and return invitation details.
 *
 * This endpoint is unauthenticated - the user hasn't created their account yet.
 *
 * Args:
 * request: Request body containing the encrypted invitation token
 *
 * Returns:
 * InvitationValidation with email and organization name
 */
export const validateInvitationUserInvitationValidatePost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        ValidateInvitationUserInvitationValidatePostData,
        ThrowOnError
    >
): RequestResult<
    ValidateInvitationUserInvitationValidatePostResponses,
    ValidateInvitationUserInvitationValidatePostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        ValidateInvitationUserInvitationValidatePostResponses,
        ValidateInvitationUserInvitationValidatePostErrors,
        ThrowOnError
    >({
        url: "/user/invitation/validate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Self
 *
 * Get currently logged in user.
 */
export const getSelfUserMeGet = <ThrowOnError extends boolean = false>(
    options?: Options<GetSelfUserMeGetData, ThrowOnError>
): RequestResult<GetSelfUserMeGetResponses, unknown, ThrowOnError> =>
    (options?.client ?? client).get<
        GetSelfUserMeGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/me",
        ...options,
    });

/**
 * Update Self
 *
 * Update current user's profile.
 */
export const updateSelfUserMePut = <ThrowOnError extends boolean = false>(
    options: Options<UpdateSelfUserMePutData, ThrowOnError>
): RequestResult<
    UpdateSelfUserMePutResponses,
    UpdateSelfUserMePutErrors,
    ThrowOnError
> =>
    (options.client ?? client).put<
        UpdateSelfUserMePutResponses,
        UpdateSelfUserMePutErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/me",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Update Self Preferences
 *
 * Update current user's hint/UI preferences (patch semantics).
 */
export const updateSelfPreferencesUserMePreferencesPatch = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        UpdateSelfPreferencesUserMePreferencesPatchData,
        ThrowOnError
    >
): RequestResult<
    UpdateSelfPreferencesUserMePreferencesPatchResponses,
    UpdateSelfPreferencesUserMePreferencesPatchErrors,
    ThrowOnError
> =>
    (options.client ?? client).patch<
        UpdateSelfPreferencesUserMePreferencesPatchResponses,
        UpdateSelfPreferencesUserMePreferencesPatchErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/me/preferences",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Record Policy Acceptance
 *
 * Record user acceptance of a policy.
 */
export const recordPolicyAcceptanceUserPolicyAcceptancePost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        RecordPolicyAcceptanceUserPolicyAcceptancePostData,
        ThrowOnError
    >
): RequestResult<
    RecordPolicyAcceptanceUserPolicyAcceptancePostResponses,
    RecordPolicyAcceptanceUserPolicyAcceptancePostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        RecordPolicyAcceptanceUserPolicyAcceptancePostResponses,
        RecordPolicyAcceptanceUserPolicyAcceptancePostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/policy-acceptance",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Policy Acceptances
 *
 * Get policy acceptance history for the current user.
 */
export const getPolicyAcceptancesUserPolicyAcceptancesGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        GetPolicyAcceptancesUserPolicyAcceptancesGetData,
        ThrowOnError
    >
): RequestResult<
    GetPolicyAcceptancesUserPolicyAcceptancesGetResponses,
    GetPolicyAcceptancesUserPolicyAcceptancesGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetPolicyAcceptancesUserPolicyAcceptancesGetResponses,
        GetPolicyAcceptancesUserPolicyAcceptancesGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/policy-acceptances",
        ...options,
    });

/**
 * Get Policy Status
 *
 * Get current policy acceptance status for the user.
 */
export const getPolicyStatusUserPolicyStatusGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<GetPolicyStatusUserPolicyStatusGetData, ThrowOnError>
): RequestResult<
    GetPolicyStatusUserPolicyStatusGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetPolicyStatusUserPolicyStatusGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/policy-status",
        ...options,
    });

/**
 * Signup
 *
 * Create a new user account with policy acceptance.
 *
 * This endpoint is idempotent - calling it multiple times with the same
 * email will succeed if the user is fully created.
 *
 * Note: Uses ctx directly instead of service.execute() because the user
 * may not exist yet during signup (service.execute() calls current_user()
 * which would try to auto-create from Firebase).
 */
export const signupUserSignupPost = <ThrowOnError extends boolean = false>(
    options: Options<SignupUserSignupPostData, ThrowOnError>
): RequestResult<
    SignupUserSignupPostResponses,
    SignupUserSignupPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        SignupUserSignupPostResponses,
        SignupUserSignupPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/signup",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Signup With Invitation
 *
 * Create a new user account via invitation.
 *
 * This endpoint is idempotent - calling it multiple times with the same
 * email will succeed if the user is fully created and authorized.
 *
 * Authentication: Uses get_current_user_email_for_signup which skips email
 * verification and MFA checks. This is necessary because:
 * - Frontend needs to call this endpoint BEFORE MFA enrollment
 * - MFA enrollment requires emailVerified=true in Firebase
 * - Only this endpoint can set emailVerified=true (via Firebase Admin SDK)
 * - The invitation token itself proves email ownership
 * After this succeeds, frontend enrolls MFA with the now-verified email.
 *
 * Note: Uses ctx directly instead of service.execute() because the user
 * may not exist yet during signup (service.execute() calls current_user()
 * which would try to auto-create from Firebase).
 */
export const signupWithInvitationUserSignupWithInvitationPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        SignupWithInvitationUserSignupWithInvitationPostData,
        ThrowOnError
    >
): RequestResult<
    SignupWithInvitationUserSignupWithInvitationPostResponses,
    SignupWithInvitationUserSignupWithInvitationPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        SignupWithInvitationUserSignupWithInvitationPostResponses,
        SignupWithInvitationUserSignupWithInvitationPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/signup-with-invitation",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Delete User
 *
 * Delete a User.
 */
export const deleteUserUserUserIdDelete = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteUserUserUserIdDeleteData, ThrowOnError>
): RequestResult<
    DeleteUserUserUserIdDeleteResponses,
    DeleteUserUserUserIdDeleteErrors,
    ThrowOnError
> =>
    (options.client ?? client).delete<
        DeleteUserUserUserIdDeleteResponses,
        DeleteUserUserUserIdDeleteErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/{user_id}",
        ...options,
    });

/**
 * Update Authorization
 *
 * Set the full list of roles for a user in the organization.
 */
export const updateAuthorizationUserUserIdAuthorizationPut = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        UpdateAuthorizationUserUserIdAuthorizationPutData,
        ThrowOnError
    >
): RequestResult<
    UpdateAuthorizationUserUserIdAuthorizationPutResponses,
    UpdateAuthorizationUserUserIdAuthorizationPutErrors,
    ThrowOnError
> =>
    (options.client ?? client).put<
        UpdateAuthorizationUserUserIdAuthorizationPutResponses,
        UpdateAuthorizationUserUserIdAuthorizationPutErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/{user_id}/authorization",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Domain Roles
 *
 * Get roles for given domain.
 */
export const getDomainRolesUserUserIdDomainRolesGet = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetDomainRolesUserUserIdDomainRolesGetData, ThrowOnError>
): RequestResult<
    GetDomainRolesUserUserIdDomainRolesGetResponses,
    GetDomainRolesUserUserIdDomainRolesGetErrors,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetDomainRolesUserUserIdDomainRolesGetResponses,
        GetDomainRolesUserUserIdDomainRolesGetErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/{user_id}/domain-roles",
        ...options,
    });

/**
 * Resend Invitation Endpoint
 *
 * Resend invitation to a user with expired invitation token.
 *
 * Only works for users with INVITATION_EXPIRED status.
 * Generates a new token and sends a new invitation email.
 */
export const resendInvitationEndpointUserUserIdResendInvitationPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        ResendInvitationEndpointUserUserIdResendInvitationPostData,
        ThrowOnError
    >
): RequestResult<
    ResendInvitationEndpointUserUserIdResendInvitationPostResponses,
    ResendInvitationEndpointUserUserIdResendInvitationPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        ResendInvitationEndpointUserUserIdResendInvitationPostResponses,
        ResendInvitationEndpointUserUserIdResendInvitationPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/user/{user_id}/resend-invitation",
        ...options,
    });

/**
 * Get Entries
 *
 * List all What's New entries for the organization.
 */
export const getEntriesWhatsNewWhatsNewMgtEntriesGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<GetEntriesWhatsNewWhatsNewMgtEntriesGetData, ThrowOnError>
): RequestResult<
    GetEntriesWhatsNewWhatsNewMgtEntriesGetResponses,
    GetEntriesWhatsNewWhatsNewMgtEntriesGetErrors,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetEntriesWhatsNewWhatsNewMgtEntriesGetResponses,
        GetEntriesWhatsNewWhatsNewMgtEntriesGetErrors,
        ThrowOnError
    >({ url: "/whats_new/whats_new_mgt/entries", ...options });

/**
 * Create Entry
 *
 * Create a new What's New entry (platform admin only).
 */
export const createEntryWhatsNewWhatsNewMgtEntriesPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        CreateEntryWhatsNewWhatsNewMgtEntriesPostData,
        ThrowOnError
    >
): RequestResult<
    CreateEntryWhatsNewWhatsNewMgtEntriesPostResponses,
    CreateEntryWhatsNewWhatsNewMgtEntriesPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        CreateEntryWhatsNewWhatsNewMgtEntriesPostResponses,
        CreateEntryWhatsNewWhatsNewMgtEntriesPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/whats_new/whats_new_mgt/entries",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Unseen Entries
 *
 * List What's New entries the current user hasn't seen yet.
 */
export const getUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGet = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetData,
        ThrowOnError
    >
): RequestResult<
    GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponses,
    unknown,
    ThrowOnError
> =>
    (options?.client ?? client).get<
        GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponses,
        unknown,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/whats_new/whats_new_mgt/entries/unseen",
        ...options,
    });

/**
 * Delete Entry
 *
 * Delete a What's New entry (platform admin only).
 */
export const deleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDelete = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteData,
        ThrowOnError
    >
): RequestResult<
    DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponses,
    DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteErrors,
    ThrowOnError
> =>
    (options.client ?? client).delete<
        DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponses,
        DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/whats_new/whats_new_mgt/entries/{entry_id}",
        ...options,
    });

/**
 * Update Entry
 *
 * Update an existing What's New entry (platform admin only).
 */
export const updateEntryWhatsNewWhatsNewMgtEntriesEntryIdPut = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutData,
        ThrowOnError
    >
): RequestResult<
    UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponses,
    UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutErrors,
    ThrowOnError
> =>
    (options.client ?? client).put<
        UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponses,
        UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/whats_new/whats_new_mgt/entries/{entry_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Mark Seen
 *
 * Mark a What's New entry as seen by the current user.
 */
export const markSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostData,
        ThrowOnError
    >
): RequestResult<
    MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponses,
    MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponses,
        MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/whats_new/whats_new_mgt/entries/{entry_id}/seen",
        ...options,
    });

/**
 * Upload Media
 *
 * Upload an image or video for a What's New entry (platform admin only).
 *
 * Gated like the entry endpoints it serves: What's New is Gotoko-wide and its
 * manager lives on the org-less Platform Admin page, so this must not require
 * an organization context.
 */
export const uploadMediaWhatsNewWhatsNewMgtUploadsPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        UploadMediaWhatsNewWhatsNewMgtUploadsPostData,
        ThrowOnError
    >
): RequestResult<
    UploadMediaWhatsNewWhatsNewMgtUploadsPostResponses,
    UploadMediaWhatsNewWhatsNewMgtUploadsPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        UploadMediaWhatsNewWhatsNewMgtUploadsPostResponses,
        UploadMediaWhatsNewWhatsNewMgtUploadsPostErrors,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/whats_new/whats_new_mgt/uploads",
        ...options,
        headers: {
            "Content-Type": null,
            ...options.headers,
        },
    });

/**
 * Start
 *
 * Get Workspace by Stek
 */
export const startWorkspaceWorktreeMgtGetWorktreeStartPost = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        StartWorkspaceWorktreeMgtGetWorktreeStartPostData,
        ThrowOnError
    >
): RequestResult<
    StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses,
    StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors,
    ThrowOnError
> =>
    (options.client ?? client).post<
        StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses,
        StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors,
        ThrowOnError
    >({
        security: [
            {
                key: "ProbacBearer",
                scheme: "bearer",
                type: "http",
            },
            { name: "organization", type: "apiKey" },
            { name: "stek", type: "apiKey" },
        ],
        url: "/workspace/worktree_mgt/get_worktree/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
